import { format, getTime } from 'date-fns'
import { zonedTimeToUtc } from 'date-fns-tz'
import { jwtDecode } from 'jwt-decode'
import DOMPurify from 'dompurify'
import CONSTANTS, { PAGES_ROUTES } from '../Constants'
import {
  ADVANCE_SEARCH,
  ASSETS_CRUD,
  AUTH_MANAGEMENT,
  BULK_OPERATIONS,
  CONTAINER_MANAGEMENT_CRUD,
  COUNTRIES_CRUD,
  MASTERS_MANAGEMENT,
  MULTIUSER_LOCKING,
  REVOKE_ACCESS_API,
  SITE_NAVIGATION_CRUD,
  SYSTEM_CONFIG_APIS,
  WIDGET_MANAGEMENT_CRUD,
} from '../Constants/ApiDefinations'
import { MASTER_MANAGEMENT_CONSTANTS } from '../Constants/Constant/Masters'
import { FormValues, TypeObject, roleModulesModal } from '../Models'
import mainApiService from '../Services'
import { AppDispatch, store } from '../Store'
import { showAlert } from '../Store/Slice/alert.slice'
import { CATEGORY_LABEL, DATA_ENGINES, FORM_FIELD } from '../Constants/ManageWidget'
import {
  getAutomatedMastersData,
  getMastersData,
  getParameterRepositoryDetail,
  setFetchedAssetsList,
} from '../Store/Slice/data-engine-category.slice'
import { setAuthConfig } from '../Store/Slice/user.slice'
import { getLocalStorage, setLocalStorage } from './Storage'
import { FieldFunctions } from './constant'
import { Dispatch } from '@reduxjs/toolkit'
import {
  setContainerErrors,
  setHookFormErrors,
  setHookFormPersistErrors,
} from '../Store/Slice/masters.slice'
import { setLoader } from '../Store/Slice/loader.slice'
import {
  counterType,
  DataObject,
  HandleCsvBulkUpdateJobCancel,
  FetchRightDrawerLayout,
  IExtendedFile,
  IFieldTitleValue,
  IKeyValue,
  IModuleType,
  IPinnedLang,
  ItemErrorKeys,
  ModalType,
  ResultObject,
  WidgetFilterType,
  IReplaceAndEditItemData,
} from '../Models/CommonListHeadingModal'
import { getMasterByKey } from '../Store/Slice/system-configuration.slice'
import { MODULE_CONSTANTS } from '../Constants/Texts'
import React, { Dispatch as ReactDispatch, SetStateAction } from 'react'
import AssetStateLabel from '../Components/Labels/AssetStateLabel'
import { initialState as AssetFieldsIntialState } from '../Components/Shared/DefinitionFields/AssetFields'
import {
  assetList,
  assetTypes,
  getIDKey,
  getWidgetDetailById,
  getWidgetListAPICall,
} from '../Store/Slice/manage-widget.slice'
import { DrawerData } from '../Constants/Constant/SidebarConstent'
import { filterConditions } from '../Constants/Constant/ListingPageConstant/ContentListingConstants'
import { getContainerListAPICall } from '../Store/Slice/manage-container.slice'
import { getCheckboxOrRadioComponent } from '../Components/Molecule/CategoryFormData/CommonHelperFunctions'
import { GetItemsList, ManageWidgetConfirmHandler } from '../Models/DataCategoryUtils'
import axios from 'axios'
import { CSV_VALIDATION_RULES } from '../Constants/Constant'
import {
  CsvUpload,
  CsvValidationError,
  CsvValidationResult,
  ITypeAndLayoutList,
  UploadCsvProcess,
} from '../Models/CsvBulkUpdate'
import { PageNames } from '../Constants/PagesRoutes/PageURLs'

export const getStatus = (status: any) => {
  const statusMap: Record<string, string> = {
    [CONSTANTS.ASSET_STATUS.CREATED]: 'Draft-Created',
    [CONSTANTS.ASSET_STATUS.DRAFT]: 'Draft',
    [CONSTANTS.ASSET_STATUS.DRAFT_CREATE]: 'Draft Create',
    [CONSTANTS.ASSET_STATUS.DRAFT_COMPLETE]: 'Draft Complete',
    [CONSTANTS.ASSET_STATUS.DRAFT_UNDER_QC]: 'Draft Under QC',
    [CONSTANTS.ASSET_STATUS.DRAFT_READY_FOR_FEATURING]: 'Draft - Ready for Featuring',
    [CONSTANTS.ASSET_STATUS.SCHEDULE_FEATURE]: 'Scheduled For Featured',
    [CONSTANTS.ASSET_STATUS.FAILED]: 'Failed',
    [CONSTANTS.ASSET_STATUS.PUBLISH_FAIL]: 'Publishing Failed',
    [CONSTANTS.ASSET_STATUS.FEATURED]: 'Featured',
    [CONSTANTS.ASSET_STATUS.ARCHIEVED]: 'Archived',
    [CONSTANTS.ASSET_STATUS.DE_PUBLISH]: 'Depublished',
    [CONSTANTS.ASSET_STATUS.UNFEATURED]: 'Un Featured',
    [CONSTANTS.ASSET_STATUS.RIGHTS_EXPIRED]: 'Rights Expired',
    [CONSTANTS.ASSET_STATUS.DRAFT_CREATE]: 'Draft Create',
    [CONSTANTS.ASSET_STATUS.PUBLISHED]: 'Published',
    [CONSTANTS.ASSET_STATUS.DELETED]: 'Deleted',
    [CONSTANTS.BULK_STATE.COMPLETED]: 'Completes',
    [CONSTANTS.BULK_STATE.IN_PROGRESS]: 'In Progress',
  }

  return statusMap[status] || status || ''
}

export const getAssetStatusBackgroundColor = (status: any) => {
  const colorMap: Record<string, string> = {
    [CONSTANTS.ASSET_STATUS.CREATED]: '#0073A1',
    [CONSTANTS.ASSET_STATUS.DRAFT]: '#9F760D',
    [CONSTANTS.ASSET_STATUS.DRAFT_COMPLETE]: '#5C4200',
    [CONSTANTS.ASSET_STATUS.DRAFT_UNDER_QC]: '#402080',
    [CONSTANTS.ASSET_STATUS.DRAFT_READY_FOR_FEATURING]: '#160B2D',
    [CONSTANTS.ASSET_STATUS.SCHEDULE_FEATURE]: '#0073A1',
    [CONSTANTS.ASSET_STATUS.FAILED]: '#D4351C',
    [CONSTANTS.ASSET_STATUS.PUBLISH_FAIL]: '#D4351C',
    [CONSTANTS.ASSET_STATUS.FEATURED]: '#005A30',
    [CONSTANTS.ASSET_STATUS.ARCHIEVED]: '#D4351C',
    [CONSTANTS.ASSET_STATUS.DE_PUBLISH]: '#D4351C',
    [CONSTANTS.ASSET_STATUS.UNFEATURED]: '#D4351C',
    [CONSTANTS.ASSET_STATUS.RIGHTS_EXPIRED]: '#D4351C',
    [CONSTANTS.ASSET_STATUS.DELETED]: '#D4351C',
  }

  return colorMap[status] || '#E6F7FD'
}
export const getColorForState = (stateName: string) => {
  const colors: { [key: string]: string } = {
    [CONSTANTS.COUNT_STATUS.DRAFT]: '#7CAB13',
    [CONSTANTS.COUNT_STATUS.READY_FOR_PUBLISHING]: '#79DEFE',
    [CONSTANTS.COUNT_STATUS.FEATURED]: '#7557FB',
    [CONSTANTS.COUNT_STATUS.UNFEATURED]: '#F96E5A',
    [CONSTANTS.COUNT_STATUS.SCHEDULE_TO_FEATURE]: '#FFB26A',
    [CONSTANTS.COUNT_STATUS.ARCHIEVED]: '#dcdcdc',
  }
  return colors[stateName] || '#000000'
}
export const STATE_ORDER = [
  'draft',
  'ready_for_featuring',
  'featured',
  'unfeatured',
  'scheduled_to_feature',
]
export const stringToHexColor = (str: string) => {
  let hashCode = 0
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i)
    hashCode = (hashCode << 5) - hashCode + char
    hashCode &= hashCode
  }

  const colorCode = '#' + (hashCode & 0xffffff).toString(16).padStart(6, '0')

  return colorCode
}
export const getContentCategoryColor = (status: any) => {
  const colorMap: Record<string, string> = {
    ['TV_SHOW']: '#7CAB13',
    ['ORIGINALS']: '#F96E5A',
    ['MOVIES']: '#7557FB',
    ['NON_VOD_ASSETS']: '#FFB26A',
    ['SPORTS']: '#DE76C1',
    ['INDEPENDENT_VOD_ASSETS']: '#79DEFE',
  }

  return colorMap[status] || stringToHexColor(status)
}

export const getMetaCategoryName = (status: any) => {
  const statusMap: Record<string, string> = {
    ['TV_SHOW']: 'TV Shows',
    ['ORIGINALS']: 'Originals',
    ['MOVIES']: 'Movies',
    ['SPORTS']: 'Sports',
    ['INDEPENDENT_VOD_ASSETS']: 'Independent VOD Assets',
    ['NON_VOD_ASSETS']: 'Non VOD Assets',
  }

  return statusMap[status] || status || ''
}
export const getMetaCategoryNameHomepage = (status: any) => {
  const statusMap: Record<string, string> = {
    ['TV_SHOW']: 'TV Shows',
    ['ORIGINALS']: 'Originals',
    ['MOVIES']: 'Movies',
    ['SPORTS']: 'Sports',
    ['INDEPENDENT_VOD_ASSETS']: 'Independent VOD',
    ['NON_VOD_ASSETS']: 'Non VOD',
  }

  return statusMap[status] || status || ''
}
export const toMilliseconds = (hrs: number, min: number, sec: number) =>
  (hrs * 60 * 60 + min * 60 + sec) * 1000

export const setToken = (token: string) => {
  const decoded = jwtDecode(token)
  const { exp = 0 } = decoded || {}
  const expireTimeInMiliSec = exp * 1000
  const authConfig: any = {
    token: token,
    expireTime: expireTimeInMiliSec,
  }
  setLocalStorage(CONSTANTS.LOCAL_KEYS.AUTH_CONFIG, authConfig)
  store.dispatch(setAuthConfig(authConfig) as any)
  setRefreshTokenCallback()
}

export const setRefreshTokenCallback = () => {
  const token: { token: string; expireTime: number } = JSON.parse(
    localStorage.getItem(CONSTANTS.LOCAL_KEYS.AUTH_CONFIG) as string,
  )
  if (token?.expireTime) {
    const expireTimeInMiliSec = new Date(token?.expireTime).setMinutes(
      new Date(token.expireTime).getMinutes() - 5,
    )
    if (new Date(expireTimeInMiliSec) < new Date()) refreshToken()
  }
}

export const refreshToken = async () => {
  const { data = {} } = await mainApiService(AUTH_MANAGEMENT.REFRESH_TOKEN())
  const { token = '' } = data
  if (token) setToken(token)
}

export const getDateInFormat = (date: string, dFormat: string) => {
  if (date === 'NA') return 'NA'
  if (date) return format(new Date(date), dFormat)
  return ''
}
export const convertToUTC = (localDate: string, timeZone: string) => {
  if (!localDate || localDate === 'NA') return 'NA'
  const utcDate = zonedTimeToUtc(localDate, timeZone)
  return utcDate.toISOString()
}

export const isAtLeastOneTrue = (arr: roleModulesModal[]) => {
  for (const module of arr) {
    for (const submodule of module.submodules) {
      const permissions = submodule.permission
      if (Object.values(permissions).some((value) => value === true)) {
        return true
      }
    }
  }
  return false
}

export const isAtLeastOneSelectedPerModule = (arr: roleModulesModal[]) => {
  const hasTruePermission = (submodules: any[]) => {
    for (const submodule of submodules) {
      const permissions = submodule.permission
      if (Object.values(permissions).some((value) => value === true)) {
        return true
      }
    }
    return false
  }
  for (const module of arr) {
    if (hasTruePermission(module.submodules)) {
      return true
    }
  }
  return false
}
export const getWidgetTypeText = (layout: string) => {
  const {
    ASSET_TEXT_WITH_S,
    ASSET_TEXT,
    ITEM_TEXT_WITH_S,
    WIDGET_TEXT_WITH_S,
    CONTAINER_TEXT_WITH_S,
  } = MODULE_CONSTANTS
  if (!layout || layout.trim().length === 0) return ASSET_TEXT_WITH_S
  if (getWidgetDataBasedOnType(layout, 'spotLightLayout')) {
    return ITEM_TEXT_WITH_S
  }
  if (getWidgetDataBasedOnType(layout, 'widgetTabList')) {
    return WIDGET_TEXT_WITH_S
  }
  if (getWidgetDataBasedOnType(layout, 'categoryPageLayout')) {
    return CONTAINER_TEXT_WITH_S
  }
  if (getWidgetDataBasedOnType(layout, 'cardSkinnedVideo')) {
    return ASSET_TEXT
  }
  return ASSET_TEXT_WITH_S
}
export const objectToQueryString = (obj: any): any => {
  const keys = Object.keys(obj)
  const keyValuePairs = keys.map((key) => {
    if (obj[key]) {
      return (key + '=' + obj[key]) as string | number | boolean
    }
  })

  const filteredArray = keyValuePairs.filter((element) => element !== undefined)
  return filteredArray.join('&')
}
export function convertHyphenatedString(input: string) {
  return input
    .toLowerCase()
    .split('-')
    .map((word: string, index: number) =>
      index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
    )
    .join('')
}
export const getPageTitle = (id: string) => {
  const { VIEW, EDIT, CREATE } = CONSTANTS.PAGE_TYPE
  switch (id) {
    case VIEW as string:
      return VIEW
    case CREATE:
      return CREATE
    default:
      return EDIT
  }
}

export const getSubstring = (value: string, limit: number) => {
  return value?.length > limit ? `${value?.substring(0, limit)}...` : value
}

export const getStringLimit = (value: string, limit: number): string => {
  if (value?.length > limit) {
    return value
  } else return ''
}

export const combineErrorMessage = (unwrappableRes: any) => {
  if (Array.isArray(unwrappableRes?.error?.errors)) {
    if (unwrappableRes?.error?.errors?.length > 0) {
      return unwrappableRes?.error?.errors.join('\n')
    }
    if (unwrappableRes?.error?.data?.length > 0) {
      return unwrappableRes?.error?.data.join('\n')
    }
  }

  return unwrappableRes?.error?.message || 'Something went wrong'
}

export const combineErrors = (errors: any) => {
  if (Array.isArray(errors)) {
    if (errors?.length > 0) {
      return errors.join(',\n')
    } else {
      return 'Something went wrong'
    }
  } else {
    return 'Something went wrong'
  }
}

export const handleApiError = (dispatch: Dispatch, result: { error?: { errors: any[] } }) => {
  const containerErrors = result?.error?.errors?.filter(
    (item: ItemErrorKeys) =>
      item.missingImage ||
      item.duplicateAsset ||
      item.missingMandatoryFields ||
      item.invalidPosition ||
      item.isPositionExceed ||
      item.invalidAvailableTo,
  )
  const withoutContainerErrors = result?.error?.errors?.filter(
    (item: ItemErrorKeys) =>
      !item.missingImage &&
      !item.duplicateAsset &&
      !item.missingMandatoryFields &&
      !item.invalidPosition &&
      !item.isPositionExceed &&
      !item.invalidAvailableTo,
  )
  if (containerErrors && containerErrors?.length > 0) {
    dispatch(setContainerErrors(containerErrors))
  }
  dispatch(setHookFormErrors(withoutContainerErrors))
  dispatch(setLoader(false))

  const toastMessages =
    result?.error?.errors
      ?.filter((item: any) => item.includes('toastMessage'))
      .map((item: any) => item.replace(/["']?toastMessage["']?\s*/i, '').trim()) || []

  if (toastMessages.length > 0) {
    dispatch(showAlert([true, combineErrors(toastMessages), 'error']))
  }
  if (toastMessages.length === 0) {
    dispatch(setHookFormPersistErrors(result?.error?.errors))
  }
}

export const isValidObject = (obj: any) => {
  if (obj) {
    return Object.keys(obj).length > 0 ? true : false
  }
  return false
}

export const getValueFromObjArr = (obArr: any[], key: string) => {
  let value = ''
  if (obArr?.length > 0 && key) {
    obArr?.forEach((obj: any) => {
      if (isValidObject(obj) && obj?.key === key) {
        value = obj?.value
      }
    })
  }
  return value ? value : ''
}
/**
Returns the first `count` words from a comma-separated string and the remaining count.
@param input - The comma-separated string.
@param count - Number of words to return from the start.
@returns A formatted string like "First, Second + N others" or just "First, Second".
 */
export function getFormattedWords(input: string, count: number): string {
  if (!input || typeof input !== 'string' || count <= 0) {
    return '' // Handle invalid inputs or zero/negative count
  }
  const parts = input?.split(',') // Split the input string by commas
  const selectedWords = parts?.slice(0, count).join(', ') // Get the first `count` words
  const remainingCount = parts?.length - count // Calculate remaining words count
  return remainingCount > 0 ? `${selectedWords} +${remainingCount} others` : selectedWords
}
export function truncatedValue(text: string, length: number) {
  return `${text.slice(0, length)}${text.length >= length ? '...' : ''}`
}
export function trimStrings(value: any): any {
  // If the value is a string, trim it and return it
  if (typeof value === 'string') {
    return value.trim()
  }
  // If the value is an array, recursively trim its elements
  if (Array.isArray(value)) {
    return value.map(trimStrings)
  }
  // If the value is an object, recursively trim its properties
  if (typeof value === 'object' && value !== null) {
    // Create a new object to store the trimmed values
    const trimmedObj: any = {}
    // Loop through each key in the object
    for (const key in value) {
      // Ensure the property is directly on the object and not inherited
      if (Object.hasOwn(value, key)) {
        trimmedObj[key] = trimStrings(value[key])
      }
    }
    return trimmedObj
  }
  // For other types, just return the value as is
  return value
}

export const createAttributePayload = (attributeFormData: any, type: string) => {
  const tmpArr: any[] = []
  attributeFormData?.attributeRef?.forEach((item: any, index: number) => {
    tmpArr.push({
      _id: item?._id,
      sortOrder: index + 1,
    })
  })

  let affiliatePartner = []
  if (attributeFormData?.affiliatePartner?.length > 0) {
    affiliatePartner = attributeFormData?.affiliatePartner.map((x: any) => x.key)
  }

  const defaultPayload = {
    fieldType: attributeFormData?.fieldType ? attributeFormData?.fieldType : undefined,
    dataType: attributeFormData?.dataType ? attributeFormData?.dataType : undefined,
    fieldName: attributeFormData?.fieldName ? attributeFormData?.fieldName?.trim() : undefined,
    isRequired: attributeFormData?.isRequired
      ? attributeFormData?.isRequired === 'Yes'
        ? true
        : false
      : undefined,
    isMultiple: attributeFormData?.isMultiple
      ? attributeFormData?.isMultiple === 'Yes'
        ? true
        : false
      : undefined,
    label: attributeFormData?.label ? attributeFormData?.label : undefined,
    isB2B: attributeFormData?.isB2B
      ? attributeFormData?.isB2B === 'Yes'
        ? true
        : false
      : undefined,
    defaultValue: attributeFormData?.defaultValue ? attributeFormData?.defaultValue : '',
    affiliatePartner: attributeFormData?.affiliatePartner?.length > 0 ? affiliatePartner : [],
    placeholder: attributeFormData?.placeholder ? attributeFormData?.placeholder : undefined,
    master: attributeFormData?.master ? attributeFormData?.master : undefined,
    options: attributeFormData?.dataType ? attributeFormData?.dataType : undefined,
    addMore: attributeFormData?.addMore
      ? attributeFormData?.addMore === 'Yes'
        ? true
        : false
      : undefined,
    status: attributeFormData?.status ? attributeFormData?.status : undefined,
    isMultilingual: attributeFormData?.isMultilingual
      ? attributeFormData?.isMultilingual === 'Yes'
        ? true
        : false
      : undefined,
    esField: attributeFormData?.esField ? attributeFormData?.esField : null,
    description: attributeFormData?.description ? attributeFormData?.description : undefined,
    additionalProperties: attributeFormData?.additionalProperties
      ? JSON.parse(attributeFormData?.additionalProperties)
      : null,

    attributeRef: tmpArr,
    metaCategory: 'NA',
    validations: {},
  }
  if (type === CONSTANTS.PAGE_TYPE.CREATE) {
    const reqData = {
      ...defaultPayload,
      options: attributeFormData?.options?.split(',') || [],
    }
    return reqData
  }
  if (type === CONSTANTS.PAGE_TYPE.EDIT) {
    let options = []
    if (Array.isArray(attributeFormData?.options)) {
      options = attributeFormData?.options?.toString()
      options = options.split(',')
    } else {
      options = attributeFormData?.options?.split(',') || []
    }
    const reqData = {
      ...defaultPayload,
      options: options,
    }
    return reqData
  }
  return {}
}

export const removeDuplicateAttributes = (arr: any[]) => {
  const uniqueArr: any[] = []
  arr?.forEach((x: any) => {
    const index = uniqueArr.findIndex((y: any) => y?.fieldName === x?.fieldName)
    if (index < 0) {
      uniqueArr.push(x)
    }
  })
  return uniqueArr
}

export const isValidArray = (array: any[]) => {
  return typeof array === 'object' && typeof array !== 'string' && array?.length > 0 ? true : false
}

export const isValidJSON = (str: string) => {
  /*
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
  */
  try {
    const o = JSON.parse(str)
    if (o && typeof o === 'object') return true
    return false
  } catch (e) {
    return false
  }
}

// delete element from object if its null/undefined/empty
export const ValidateObject = (Obj: any) => {
  try {
    Object.keys(Obj).forEach((key) => {
      if (Obj[key] === null || Obj[key] === undefined || Obj[key] === '') {
        delete Obj[key]
      }
    })
    return Obj
  } catch (e) {
    return {}
  }
}

export const getSystemConfigurationMasterObject = (systemConfigurationPageType: string) => {
  let result: any = null
  MASTER_MANAGEMENT_CONSTANTS.SYSTEM_CONFIGURATION_LIST?.forEach((sc: any) => {
    const { url = '', key = '', name = '' } = sc
    if (url && key && name) {
      const splittedURL = url?.split('/')
      const pageType = splittedURL[splittedURL?.length - 1]
      if (systemConfigurationPageType === pageType) {
        result = sc
      }
    }
  })
  return result
}

export const emptyFunction = () => {
  return
}

export const getMasterPayload = (masterKey: string, obj: any) => {
  const body = {
    configKey: masterKey,
    configValue: {
      key: obj?.key || '',
      value: obj?.value || '',
    },
  }
  return body
}

const replacer = (match: any, pIndent: any, pKey: any, pVal: any, pEnd: any) => {
  const key = '<span class=json-key>'
  const val = '<span class=json-value>'
  const str = '<span class=json-string>'
  let r = pIndent || ''
  if (pKey) r = r + key + pKey.replace(/[": ]/g, '') + '</span>: '
  if (pVal) r = r + (pVal[0] === '"' ? str : val) + pVal + '</span>'
  return r + (pEnd || '')
}

export const prettyPrint = (obj: any) => {
  const jsonLine = /^( *)("[\w]+": )?("[^"]*"|[\w.+-]*)?([,[{])?$/gm
  return JSON.stringify(obj, null, 3)
    .replace(/&/g, '&amp;')
    .replace(/\\"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(jsonLine, replacer)
}

export const updatingSortOrderValue = (array: any[]) => {
  const copyArr = JSON.parse(JSON.stringify(array))
  copyArr?.forEach((item: any, index: number) => {
    item.sortOrder = index
  })
  return copyArr
}

export const uploadInPresignedURL = async (
  presignedUrl: any,
  file: any,
  dispatch: any,
  uploadFileName: any,
) => {
  try {
    if (!presignedUrl) return ''
    if (!file) {
      dispatch(showAlert([true, 'Please select a file', 'error']))
      return
    }
    const response = await fetch(presignedUrl, {
      method: 'PUT',
      body: file,
    })
    if (response.ok) {
      return uploadFileName
    } else {
      dispatch(showAlert([true, 'Upload Failed', 'error']))
      return ''
    }
  } catch (error) {
    dispatch(showAlert([true, 'Upload Failed', 'error']))
    return ''
  }
}

export const downloadFile = async (dispatch: any, path: string, markAsDoneDetail: any) => {
  try {
    let id = markAsDoneDetail?.legacyHouseId
    if (!id) {
      id = markAsDoneDetail?.blitzId
    }
    const url = `${CONSTANTS.CLOUDFRONT_BASE_URL_SUBTITLE}/subtitles/${id}/${path}`
    const res: any = await fetch(url)
    const blob: any = await res.blob()

    if (blob) {
      const blobUrl = URL.createObjectURL(blob)
      const link = document.createElement('a')

      if (!blobUrl.startsWith('blob:')) {
        throw new Error('Invalid blob URL')
      }
      link.href = blobUrl
      link.download = path
      link.click()
      URL.revokeObjectURL(blobUrl)
    }
  } catch (error: any) {
    dispatch(showAlert([true, `'Error downloading file:' ${error}`, 'error']))
  }
}

export const checkModuleAccess = (role: string | undefined) => {
  const result = { canRead: true, canWrite: true }
  if (role) {
    const roleData: any = getLocalStorage(CONSTANTS.LOCAL_KEYS.ROLE_DATA)
    for (let i = 0; i < roleData?.length; i++) {
      for (let j = 0; j < roleData[i]?.submodules?.length; j++) {
        if (roleData[i]?.submodules[j]?.key === role) {
          result.canRead = roleData[i]?.submodules[j]?.permission?.canRead
          result.canWrite = roleData[i]?.submodules[j]?.permission?.canWrite
          break
        }
      }
    }
  }
  return result
}
export const getCapitalise = (value: string) => {
  return value?.charAt(0)?.toUpperCase() + value?.replace('_', ' ')?.slice(1)?.toLowerCase()
}

export const convertSecondsToHours = (seconds: number) => {
  const days = Math.floor(seconds / (3600 * 24))
  const hours = Math.floor((seconds % (3600 * 24)) / 3600)
  const remainingSeconds = seconds % 3600
  const minutes = Math.floor(remainingSeconds / 60)
  const remSeconds = remainingSeconds % 60
  const getValue = (value: number, key: string) => {
    return `${value} ${key}${value > 1 ? 's' : ''}`
  }
  if (days > 0) {
    return `${getValue(days, 'day')}, ${getValue(hours, 'hour')}, ${getValue(
      minutes,
      'minute',
    )}, ${getValue(remSeconds, 'second')}`
  } else if (hours > 0) {
    return `${getValue(hours, 'hour')}, ${getValue(minutes, 'minute')}, ${getValue(
      remSeconds,
      'second',
    )}`
  } else if (minutes > 0) {
    return `${getValue(minutes, 'minute')}, ${getValue(remSeconds, 'second')}`
  } else if (remSeconds > 0) {
    return `${getValue(remSeconds, 'second')}`
  }
  return 'NA'
}

export const fetchOptionsValue = (options: any, value: string) => {
  if (options && options.length) {
    const displayObj = options.find((item: any) => item.key === value)
    return displayObj?.value ?? ''
  }
  return ''
}

export const getValueBasedOnString = (
  value: any,
  fieldType: string,
  tagInput: boolean,
  dataType: string,
  element: {
    attribute?: {
      dataType?: string
      options?: {
        value: any
        label: string
      }[]
    }
  },
): string => {
  if (fieldType !== CONSTANTS.FIELDTYPES.FILE) {
    if ((typeof value !== 'boolean' && !value) || (Array.isArray(value) && value.length === 0)) {
      return 'NA'
    }
    if (
      tagInput ||
      (fieldType === CONSTANTS.FIELDTYPES.SELECT &&
        dataType === CONSTANTS.ASSET_CREATION_OBJ.BOOLEAN)
    ) {
      if (Array.isArray(value)) {
        return value.join(', ')
      } else {
        return typeof value === 'boolean' ? (value ? 'Yes' : 'No') : value
      }
    } else if (fieldType === CONSTANTS.FIELDTYPES.SELECT) {
      if (Array.isArray(value)) {
        return value
          .map((item: any) => fetchOptionsValue(element?.attribute?.options, item))
          .join(', ')
      } else {
        return fetchOptionsValue(element?.attribute?.options, value)
      }
    } else if (
      fieldType === CONSTANTS.FIELDTYPES.DATE ||
      fieldType === CONSTANTS.FIELDTYPES.DATETIME ||
      fieldType === CONSTANTS.FIELDTYPES.TIME
    ) {
      if (dataType === CONSTANTS.FIELDTYPES.NUMBER) {
        return convertSecondsToHours(value)
      }
      return getDateInFormat(value ?? '', CONSTANTS.DATE_FORMAT_TIME)
    } else if (
      fieldType === CONSTANTS.FIELDTYPES.CHECKBOX ||
      fieldType === CONSTANTS.FIELDTYPES.RADIO ||
      fieldType === CONSTANTS.FIELDTYPES.SWITCH
    ) {
      return value ? 'Yes' : 'No'
    } else {
      return value
    }
  }
  return ''
}

export const subStringWithEllipses = (value: string, count = 50, elipses = true): string => {
  if (value.length <= count) {
    return value
  }
  const truncatedString = value.substring(0, count)
  return elipses ? `${truncatedString}...` : truncatedString
}
// Utilized it if you need temporary unique id
export const uniqueId = () => {
  return Math.random() + getTime(new Date())
}

export const replaceUnwanted = (data: string) => {
  return data?.replace(/[^A-Z0-9]+/gi, '_')?.toLowerCase()
}
export const filterObject = <T extends Record<string, string | number>>(obj: T): T => {
  const result: Partial<T> = {}
  for (const key in obj) {
    if (
      obj[key] !== 0 &&
      obj[key] !== '' &&
      key !== 'filterCondition' &&
      key !== 'filterValue' &&
      key !== 'filterBy'
    ) {
      result[key] = obj[key]
    }
  }

  return result as T
}
export const getCurrentStatus = (status: string) => {
  switch (status) {
    case 'PREVIEW_INITIATED':
      return 'Preview request in-progress'
    case 'TRANSCODING_INITIATED':
      return 'Transcoding in-progress'
    case 'VERIFICATION_INITIATED':
      return 'Fetching in-progress'
    default:
      return ''
  }
}

export const getSuccessStatus = (state: string) => {
  switch (state) {
    case 'validation':
      return 'Fetching Successful'
    case 'transcoding':
      return 'Transcoding Success'
    case 'preview':
      return 'Preview Request Successful'
    default:
      return `${state} is Successfully Done`
  }
}

export const changeToCapitalCase = (value: string) => {
  if (value) {
    return value.charAt(0).toUpperCase() + value.slice(1)
  }
}

/**
 * Function to return parsed data of JWT token in the form of object.
 * @function getParsedToken
 * @returns {object} JWT parsed object which is parsed from token stored in localstorage
 */
export const getParsedToken = () => {
  const authConfig: { token: string } = getLocalStorage('auth_config')
  if (authConfig?.token) {
    const parsedToken = jwtDecode(authConfig.token)
    return parsedToken
  }
}

export const logoutCyberArk = (message = '') => {
  if (message) {
    setLocalStorage(CONSTANTS.LOCAL_KEYS.LOGOUT_MESSAGE, { message })
  }
  const authToken: any = getLocalStorage(CONSTANTS.LOCAL_KEYS.AUTH_CONFIG)
  if (authToken?.token) {
    const parsedToken: { sub: { accessToken: string } } = jwtDecode(authToken.token)
    if (parsedToken?.sub?.accessToken) {
      const encodedOrigin = encodeURIComponent(`${window.location.origin}/login`)
      const redirectUrl = `${CONSTANTS.SESSION_END_URL}?id_token_hint=${parsedToken?.sub?.accessToken}&post_logout_redirect_uri=${encodedOrigin}`
      window.location.href = redirectUrl
    }
  } else {
    window.location.href = PAGES_ROUTES.LoginPage
  }
}

export const getDetailedErrorMessage = (jsonString: string, error: { message: string }) => {
  const lines = jsonString.split('\n')
  const positionMatch = error.message.match(/position (\d+)/)
  if (!positionMatch) return error.message

  if (positionMatch) {
    const position = parseInt(positionMatch[1], 10)
    let lineNumber = 0
    let charCount = 0
    const lineLengthArr = []
    // let count = 0
    for (let i = 0; i < lines.length; i++) {
      const lineLength = lines[i].length + 1
      lineLengthArr.push(lines[i].length)
      // count += lines[i].length
      const charValue = charCount + lineLength
      if (charValue > position) {
        lineNumber = i + 1
        break
      }

      charCount += lineLength
    }

    const nearbyCode = jsonString.substring(position - 10, position + 10)
    if (
      nearbyCode.includes(',') &&
      nearbyCode.includes('}') &&
      !error.message.includes('non-whitespace')
    ) {
      const lastCommaIndex = jsonString.lastIndexOf(',')
      const lastBraceIndex = jsonString.lastIndexOf('}')

      if (lastCommaIndex > lastBraceIndex) {
        return `Parse error: Invalid trailing comma before closing brace at position ${lastCommaIndex}. Suggestion: Remove the comma before '}'`
      }

      const safeLineIndex = lineNumber > 1 ? lineNumber - 1 : 0
      const safeLineNumber = lineNumber > 1 ? lineNumber - 1 : 1
      const safeCharCount = Math.max(0, charCount - 2)

      return `Parse error on line ${safeLineNumber}: Misplaced comma near line ${safeLineNumber} in JSON at position ${safeCharCount} (line ${safeLineNumber} column ${
        lines[safeLineIndex]?.length || 0
      })`
    }

    if (
      nearbyCode.includes(',') &&
      nearbyCode.includes('{') &&
      !error.message.includes('non-whitespace')
    ) {
      return `Parse error on line ${
        lineNumber - 1
      }: Misplaced comma near line ${lineNumber} in JSON at position ${
        positionMatch[1]
      } (line ${lineNumber} column ${lines[lineNumber - 1].length})`
    }

    return `Parse error on line ${lineNumber}: ${error.message}`
  } else if (!error.message.includes('position') && error.message.includes('Unexpected token')) {
    const undefinedPosition: any = []
    const errorIndex: any = []
    let positionCount = 0
    const lineBreakPosition = []
    let errorLineNumber = 0
    let errorLinerPosition = 0
    for (let i = 0; i < lines.length; i++) {
      const lineLength = lines[i]?.length + 1
      const elements = lines[i]?.split(' ')
      positionCount = positionCount + lines[i].length
      lineBreakPosition?.push(lineLength)
      for (const ele of elements) {
        const trimmedElement = `'${ele.trim()}'`
        if (trimmedElement === error.message?.split('Unexpected token')[1]?.split(',')[0]?.trim()) {
          errorIndex.push(lines[i].indexOf(ele.charAt(0)))
          undefinedPosition?.push(ele)
          errorLineNumber = lineBreakPosition.length - 1
          errorLinerPosition = lineBreakPosition[lineBreakPosition.length - 1]
          break
        }
      }
    }
    return `${error.message} at position ${positionCount} (line ${errorLineNumber} column ${errorLinerPosition})`
  }
  return error.message
}

const optionKeys = (keyVal: any) => keyVal.split(',').map((key: any) => key.trim())

const checkOptions = (options: any[], key: string, tempErrorState: any[]) => {
  if (
    options &&
    !options.some((item: any) => optionKeys(key).some((optionKey: any) => item.key === optionKey))
  ) {
    tempErrorState.push(key)
  }
}

const getFilteredValue = (options: any[], key: string) => {
  return (
    options?.filter((item: any) =>
      optionKeys(key).some((optionKey: any) => optionKey.toLowerCase() === item.key?.toLowerCase()),
    ) || []
  )
}

export const checkJsonValidation = (
  fieldData: any,
  localComplexFields: any,
  fieldName: string,
  fetchedData: any,
) => {
  const oldComplexFields = localComplexFields?.[fieldName] || []
  const leftParam = oldComplexFields[0]?.fields?.[0]?.parameter
  const rightParam = oldComplexFields[0]?.fields?.[1]?.parameter
  const leftOptions = fetchedData?.[leftParam.master ?? '']
  const rightOptions = fetchedData?.[rightParam.master ?? '']

  const tempErrorState: any = []

  Object.entries(fieldData).map(([key, value]: any) => {
    checkOptions(leftOptions, key, tempErrorState)
    checkOptions(rightOptions, value, tempErrorState)
  })

  return tempErrorState
}

export const addMoreJsonComplexFieldHelper = (
  localComplexFields: any,
  fieldData: any,
  fieldName: string,
  setValue?: any,
  fetchedData?: any,
  reset?: any,
) => {
  const oldComplexFields = localComplexFields[fieldName]
  const leftParam = oldComplexFields[0]?.fields?.[0]?.parameter
  const rightParam = oldComplexFields[0]?.fields?.[1]?.parameter
  const leftOptions = fetchedData[leftParam.master ?? '']
  const rightOptions = fetchedData[rightParam.master ?? '']

  reset({ [fieldName]: [] })

  const newFields = fieldData.map(({ key, value }: any, index: number) => {
    const updatedField = {
      id: index + 1,
      fields: oldComplexFields[0]?.fields || [],
    }

    const initalValue = leftParam?.multiSelect ? getFilteredValue(leftOptions, key) : (key ?? '')
    const ratingValue = rightParam?.multiSelect
      ? getFilteredValue(rightOptions, value)
      : (value ?? '')

    setValue(`${fieldName}_${index + 1}_${leftParam.fieldName}`, initalValue)
    setValue(`${fieldName}_${index + 1}_${rightParam.fieldName}`, ratingValue)
    return updatedField
  })

  return { newFields }
}

export const combinedObject = (arrayOfObjects: any, complexFieldName: any) =>
  arrayOfObjects?.[complexFieldName]?.reduce((acc: any, curr: any) => {
    const key = Object.keys(curr)[0] // Get the key from the current object
    const value = curr[key] // Get the value associated with that key

    // If the key already exists in the accumulator, concatenate the values
    if (acc[key]) {
      acc[key] += `, ${value}` // Concatenate with a comma
    } else {
      acc[key] = value // Otherwise, set the value
    }

    return acc // Return the accumulator for the next iteration
  }, {})

export const getComplexFieldOutput = (
  control: any,
  complexFieldName: string,
  fieldNames: string[],
) => {
  const output: any = []
  const addedKeys = new Set() // Track seen keys to avoid duplicates

  Object.keys(control._getWatch()).forEach((key) => {
    const match = key.match(new RegExp(`^${complexFieldName}_(\\d+)_${fieldNames[0]}$`))
    if (match) {
      const index = match[1]
      const initalKey = `${complexFieldName}_${index}_${fieldNames[0]}`
      const ratingKey = `${complexFieldName}_${index}_${fieldNames[1]}`
      const keyWatch = control._getWatch()?.[initalKey]
      const valueWatch = control._getWatch()?.[ratingKey]
      const initalValue = Array.isArray(keyWatch)
        ? keyWatch?.map((item: any) => item.key).join(', ')
        : keyWatch
      const ratingValue = Array.isArray(valueWatch)
        ? valueWatch?.map((item: any) => item.key).join(', ')
        : valueWatch

      if (initalValue && ratingValue && !addedKeys.has(initalValue)) {
        addedKeys.add(initalValue)
        output.push({
          [initalValue]: ratingValue,
        })
      }
    }
  })
  return output
}

export const logout = async () => {
  const { responseCode, message, error = {} } = await mainApiService(AUTH_MANAGEMENT.LOGOUT())
  if (responseCode === 200) {
    logoutCyberArk(message)
    return
  }
  if (error) store.dispatch(showAlert([true, error?.message, 'error']))
}
export const getSelectedAttributeDetails = (selectedAttri: any, attributes: any) => {
  const matchingObjects = []

  for (const selectedObj of selectedAttri) {
    const matchingDataObject = attributes.find((ele: any) => ele._id === selectedObj._id)

    if (matchingDataObject) {
      matchingObjects.push(matchingDataObject)
    }
  }

  return matchingObjects
}

export const convertPluraltoSingular = (str: string) => {
  return str.toLowerCase()?.endsWith('s') ? str.slice(0, -1) : str
}

export const AVS_MESSAGES: any = {
  SUCCESS: 'Success',
  FAILED: 'Failed',
  AVS_INGESTION: 'AVS Ingestion',
  AVS_PUBLISH: 'AVS Publishing',
  AVS_DEPUBLISH: 'AVS De-Publish',
}

export const getColor = (status: string) => {
  return status === 'SUCCESS' ? '#4C6A0B' : status === 'FAILED' ? '#D4351C' : ''
}

export const getBGColor = (status: string) => {
  return status === 'SUCCESS' ? '#F4F9EA' : status === 'FAILED' ? '#FFDBD5' : ''
}

export const getStatusMessage = (avsStatus: string, avsAction: string) => {
  const statusMessage = AVS_MESSAGES[avsStatus] || ''
  const actionMessage = AVS_MESSAGES[avsAction] || ''
  return actionMessage && statusMessage ? `${actionMessage}: ${statusMessage}` : ''
}
export function handleResponse(apiResponse: any) {
  let messages: any[] = []
  let isError = false
  let responseCode = null
  function traverse(node: any) {
    if (!node || typeof node !== 'object') return
    for (const key in node) {
      if (key === 'message' && typeof node?.[key] === 'string') {
        messages?.push(node?.[key])
      } else if ((key === 'messages' || key === 'errors') && Array.isArray(node?.[key])) {
        messages = messages?.concat(node?.[key]?.filter((msg: any) => typeof msg === 'string'))
      } else if (
        (key?.toLowerCase() === 'responsecode' || key?.toLowerCase() === 'code') &&
        typeof node?.[key] === 'number'
      ) {
        responseCode = node?.[key]
      } else {
        traverse(node?.[key])
      }
    }
  }
  traverse(apiResponse)
  // Determine if it is an error response
  isError = apiResponse?.status === 'error' || apiResponse?.error === true || responseCode !== 200
  return {
    error: isError,
    responseCode: responseCode,
    message: messages?.join(' '),
  }
}
export function convertAndCheck(input: any) {
  // Attempt to convert the input to a number
  const num = parseFloat(input)
  // Check if the input is a valid number
  if (!isNaN(num) && input === num.toString()) {
    return {
      original: input,
      converted: num,
      type: 'number',
    }
  } else {
    return {
      original: input,
      converted: NaN,
      type: 'string',
    }
  }
}
export function findParameterName(objects: any[], fieldName: string) {
  // Iterate over each object in the array

  for (const obj of objects) {
    // Check if the field name matches the object's field property
    if (obj.fieldName === fieldName) {
      // Return the parameter name if a match is found
      return obj.parameterName
    }
  }
  // Return null if no match is found
  return ''
}
export const validValueOrEmptyString = (value: any) => {
  if (!value) {
    return ''
  }
  return value
}

export const validateNoSpace = (value: string) => {
  return value?.trim() !== '' || 'This Field can not be empty or just spaces'
}
/**
 * To get the uniqe array obj removes deuplicate value based on keys
 * @function removeDuplicates
 * @param arr Array of object from which duplicate value need to be removed
 * @param key the key of by which we need to remove duplicate data from array
 * @returns {array} returns unique array of object based on key.
 */
export function removeDuplicates(arr: TypeObject[], key: string) {
  const seenAssetTypes = new Set()
  const uniqueObjects: TypeObject[] = []

  arr.forEach((obj: TypeObject) => {
    const keyObj = obj[key]
    if (!seenAssetTypes.has(keyObj)) {
      seenAssetTypes.add(keyObj)
      uniqueObjects.push(obj)
    }
  })

  return uniqueObjects
}
export const nullValuesPresent = (data: any) => {
  return Object?.values(data)?.every((value) => value === null)
}

export const getAttrDefValidationName = (validationNameKey: string, validationsList: any) => {
  return (
    (Array.isArray(validationsList) ? validationsList : [])?.find(
      (item: any) => item?.functionName === validationNameKey,
    )?.displayName || 'NA'
  )
}
export const getAttrDefDataSourceName = (dataSourceKey: string, dataSourceList: any) => {
  return (
    (Array.isArray(dataSourceList) ? dataSourceList : [])?.find(
      (item: any) => item?.key === dataSourceKey,
    )?.value || 'NA'
  )
}
export const getAttrDefScopeName = (scopeValueKey: string, scopesList: any) => {
  return (
    (Array.isArray(scopesList) ? scopesList : [])?.find((item: any) => item?.key === scopeValueKey)
      ?.value || 'NA'
  )
}
export const getAttrDefSourceAttributeName = (sourceAttributeKey: string, attributesList: any) => {
  return (
    (Array.isArray(attributesList) ? attributesList : [])?.find(
      (item: any) => item?.fieldName === sourceAttributeKey,
    )?.label || 'NA'
  )
}
export const staticCheckToHideAsterisk = (element: any) => {
  return element.fieldName === 'class' && element.fieldType === 'SELECT'
}

export const groupAndSortBasedOnBlitzId = (data: Record<string, any>[]) => {
  // Step 1: Group by blitzId
  const grouped = data.reduce((acc: any, item: any) => {
    if (!acc[item.blitzId]) {
      acc[item.blitzId] = []
    }
    acc[item.blitzId].push(item)
    return acc
  }, {})

  // Define the order of statuses
  const statusOrder = ['DRAFT', 'PUBLISHED', 'SCHEDULE PUBLISHED']

  // Function to get the order index
  const getStatusOrderIndex = (status: string) => {
    const index = statusOrder.indexOf(status)
    return index === -1 ? statusOrder.length : index
  }

  // Step 2: Sort each group by status order
  for (const blitzId in grouped) {
    grouped[blitzId].sort((a: any, b: any) => {
      return getStatusOrderIndex(a.status) - getStatusOrderIndex(b.status)
    })
  }

  // Convert the grouped object back to an array of grouped arrays
  const groupedArray = Object.entries(grouped).map(([blitzId, items]) => ({
    blitzId: Number(blitzId),
    items: items,
  }))

  return groupedArray
}
export const isValidImageURL = (url: string) => {
  return /\.(jpeg|jpg|gif|png|webp)$/.test(url)
}
export const validateValue = (value: any, dataType: any) => {
  let error = ''
  switch (dataType) {
    case 'String':
      if (typeof value !== 'string') {
        error = 'Default value must be a string'
      }
      break
    case 'Number':
      if (isNaN(value)) {
        error = 'Default value must be a number'
      }
      break
    case 'Boolean':
      if (value !== 'true' && value !== 'false') {
        error = 'Default value must be a boolean (true/false)'
      }
      break
    case 'Date':
      if (isNaN(Date.parse(value))) {
        error = 'Default value must be a valid date'
      }
      break
    case 'File':
      error = 'Default value for files should be handled in file input fields'
      break
    case 'Image File':
    case 'ImageType':
      if (!isValidImageURL(value)) {
        error = 'Default value must be a valid image URL'
      }
      break
    case 'JSON':
      try {
        JSON.parse(value)
      } catch (e) {
        error = 'Default value must be a valid JSON'
      }
      break
    default:
      break
  }
  return error
}

export const replaceHyphensWithSpaces = (text: string) => {
  return text.replace(/-/g, ' ')
}

export const formatMasterKey = (key: string): string => {
  const parts: string[] = key?.split('/') || []
  const lastPart: string = parts[parts?.length - 1]
  return lastPart?.replace(/_/g, ' ') || 'NA'
}
export const createKeyValuePairs = (input: any) => {
  if (Array.isArray(input)) {
    return input.map((str: string) => ({ key: str, value: str }))
  } else if (typeof input === 'string') {
    return [{ key: input, value: input }]
  } else {
    throw new Error('Input must be either an array of strings or a single string')
  }
}

export const toCamelCase = (str: string) => {
  if (typeof str !== 'string' || str.trim().length === 0) return ''

  str = str
    ?.replace(/\s+/g, ' ')
    .toLowerCase()
    .replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) =>
      index === 0 ? match.toLowerCase() : match.toUpperCase(),
    )
    .replace(/\s+/g, '')
  return str
}

export const isFieldRequired = (required: string) => required?.toLowerCase() === 'yes'

export const getCorrectMasterAPIUrl = (masterUrl: any) => {
  if (
    masterUrl &&
    (masterUrl.includes('system-configurations') || masterUrl.includes('blitz-master'))
  ) {
    masterUrl.trim()
    const splittedUrl = masterUrl.split('/')
    const keyName = `?keyName=${splittedUrl[splittedUrl.length - 1]}`
    splittedUrl.splice(splittedUrl.length - 1, 1)
    const finalUrl = `${splittedUrl.join('/')}${keyName}`
    return finalUrl
  }
  if (masterUrl) {
    return masterUrl
  }
}

export const toCapitalCase = (str: string) => {
  if (typeof str !== 'string' || !str.trim().length) return ''
  return str
    .split(' ')
    .map((word, index) =>
      index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
    )
    .join('')
}

export const dashStrToCapitalCase = (str: string) => {
  if (str) {
    return str
      .split('_')
      .map((word, index) =>
        index === 0
          ? word.toLowerCase()
          : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
      )
      .join('')
  }
  return '' as string
}

export const keyExists = (obj: any, key: any) => {
  if (!obj || (typeof obj !== 'object' && !Array.isArray(obj))) {
    return false
  } else if (Object.hasOwn(obj, key)) {
    return true
  } else if (Array.isArray(obj)) {
    for (let i = 0; i < obj.length; i++) {
      const result: any = keyExists(obj[i], key)
      if (result) {
        return result
      }
    }
  } else {
    for (const k in obj) {
      const result: any = keyExists(obj[k], key)
      if (result) {
        return result
      }
    }
  }

  return false
}

export const updateObject = (keyName: any, newVal: any, object: any) => {
  const results: any = {}
  for (const key in object) {
    if (key === keyName) {
      results[key] = newVal
    } else if (typeof object[key] === 'object' && object[key] !== null) {
      results[key] = updateObject(keyName, newVal, object[key])
    } else {
      results[key] = object[key]
    }
  }
  return results
}

export const checkIsSectionHasAddMore = (form: any[]) => {
  return form?.some((formField) => formField?.parameter?.addMore)
}

export const createDeepCopy = (object: any) => {
  return JSON.parse(JSON.stringify(object))
}

const getMasterOptionData = async (
  master = '',
  fieldName = '',
  contentCategoryValue = [] as any,
  assetCategoryValue = [] as any,
) => {
  if (master && fieldName) {
    const url = getCorrectMasterAPIUrl(master)
    const body = { contentCategoryValue, assetCategoryValue }
    const { payload: { data: { data = {}, responseCode = 0 } = {} } = {} } = await store.dispatch(
      getMastersData({ url, body }) as any,
    )
    if (responseCode === 200) {
      switch (fieldName) {
        case FORM_FIELD.CONTENT_CATEGORY:
          return data?.contentCategories || []
        case FORM_FIELD.ASSET_CATEGORY:
          return data?.assetCategories || []
        case FORM_FIELD.ASSET_TYPE:
          return data?.assetTypes || []
        default:
          if (master.includes('system-configurations')) {
            return data || []
          }
      }
    }
  }
  return []
}

const getOptionsListByContentCategoryValues = async (
  master: string,
  fieldName: string,
  widgetDetailData: any,
) => {
  const contentCategoryValues: any =
    (await getInputFormFieldValue(
      widgetDetailData,
      CATEGORY_LABEL.BLITZ_ASSET_CATEGORY,
      FORM_FIELD.CONTENT_CATEGORY,
    )) || {}
  const contentCategoryKeys: any[] = contentCategoryValues?.value?.map((ele: any) => ele?.key)
  const optionsListRes: any[] = await getMasterOptionData(master, fieldName, contentCategoryKeys)
  return optionsListRes || []
}

const getOptionsListByAssetCategoryValues = async (
  master: string,
  fieldName: string,
  widgetDetailData: any,
) => {
  const contentCategoryValues: any =
    (await getInputFormFieldValue(
      widgetDetailData,
      CATEGORY_LABEL.BLITZ_ASSET_CATEGORY,
      FORM_FIELD.CONTENT_CATEGORY,
    )) || {}
  const contentCategoryKeys = contentCategoryValues?.value?.map((ele: any) => ele?.key)
  const assetCategoryValues: any =
    (await getInputFormFieldValue(
      widgetDetailData,
      CATEGORY_LABEL.BLITZ_ASSET_CATEGORY,
      FORM_FIELD.ASSET_CATEGORY,
    )) || {}
  const assetCategoryKeys = assetCategoryValues?.value?.map((ele: any) => ele?.key)
  const optionsListRes = await getMasterOptionData(
    master,
    fieldName,
    contentCategoryKeys,
    assetCategoryKeys,
  )
  return optionsListRes || []
}

export const initializeInputFormUtil = async (
  formData = [] as any,
  pageType = '',
  widgetDetailData = {} as any,
) => {
  const {
    PAGE_TYPE: { UPDATE, EDIT, VIEW, CREATE },
  } = CONSTANTS
  const savedDataEngineType = widgetDetailData?.data?.engine?.toLowerCase() || DATA_ENGINES.manual
  let inputFormKeysWithAddMoreValue: any = {}
  const finalPreparedInputFormArr: any = []
  for (let formDataIndex = 0; formDataIndex < formData?.length; formDataIndex++) {
    const { label = '', form = [] } = formData[formDataIndex]
    const tempCategoryObj: any = {
      isCategoryHasAddMore: checkIsSectionHasAddMore(form),
      categoryLabel: label,
      categoryData: [
        {
          categoryFormFields: [],
        },
      ],
    }
    for (let fieldIndex = 0; fieldIndex < form?.length; fieldIndex++) {
      const formField: any = createDeepCopy(form[fieldIndex])
      formField.parameter.fieldName = dashStrToCapitalCase(formField.parameter.fieldName)
      const { parameter: { master = '', fieldName = '' } = {} } = formField || {}
      const optionsList = await getMasterOptionData(master, fieldName)
      formField['options'] = optionsList
      const tempObj: any = {}
      tempCategoryObj?.isCategoryHasAddMore
        ? (tempObj[toCapitalCase(label)] = true)
        : (tempObj[dashStrToCapitalCase(fieldName)] = false)
      inputFormKeysWithAddMoreValue = { ...inputFormKeysWithAddMoreValue, ...tempObj }
      if (
        (pageType === UPDATE && savedDataEngineType !== DATA_ENGINES.manual) ||
        ((pageType === EDIT || pageType === CREATE) &&
          savedDataEngineType === DATA_ENGINES.manual) ||
        ((pageType === EDIT || pageType === CREATE) && savedDataEngineType === '')
      ) {
        tempCategoryObj.categoryData[0].categoryFormFields.push(formField)
      }
      if (
        (pageType === EDIT || pageType === VIEW) &&
        savedDataEngineType &&
        savedDataEngineType !== DATA_ENGINES.manual
      ) {
        const categoryLabel = toCapitalCase(label)
        if (fieldName === FORM_FIELD.ASSET_CATEGORY) {
          const optionsListRes: any[] = await getOptionsListByContentCategoryValues(
            master,
            fieldName,
            widgetDetailData,
          )
          formField['options'] = optionsListRes
          tempCategoryObj.categoryData[0].categoryFormFields.push(formField)
        } else if (fieldName === FORM_FIELD.ASSET_TYPE) {
          const optionsListRes: any[] = await getOptionsListByAssetCategoryValues(
            master,
            fieldName,
            widgetDetailData,
          )
          formField['options'] = optionsListRes
          tempCategoryObj.categoryData[0].categoryFormFields.push(formField)
        } else if (categoryLabel === CATEGORY_LABEL.RANGE_BY_BLITZ_ATTRIBUTE) {
          const lengthOfCategory = widgetDetailData?.data?.query?.[categoryLabel]?.length
          if (lengthOfCategory > 1) {
            if (fieldIndex === 0) {
              tempCategoryObj.categoryData[0].categoryFormFields.push(formField)
              tempCategoryObj.categoryData[0].categoryFormFields.push(form[1])
              tempCategoryObj.categoryData[0].categoryFormFields.push(form[2])
              for (let tempI = 1; tempI < lengthOfCategory; tempI++) {
                const categoryFormArr = []
                categoryFormArr.push(formField)
                categoryFormArr.push(form[1])
                categoryFormArr.push(form[2])
                tempCategoryObj.categoryData.push({
                  categoryFormFields: categoryFormArr,
                })
              }
            }
          } else {
            tempCategoryObj.categoryData[0].categoryFormFields.push(formField)
          }
        } else if (
          [
            CATEGORY_LABEL.SELECT_BY_BLITZ_ATTRIBUTE,
            CATEGORY_LABEL.EXCLUDE_BY_BLITZ_ATTRIBUTE,
          ].includes(categoryLabel)
        ) {
          const lengthOfCategory = widgetDetailData?.data?.query?.[categoryLabel]?.length
          if (lengthOfCategory > 1) {
            tempCategoryObj.categoryData[0].categoryFormFields.push(formField)
            for (let tempI = 1; tempI < lengthOfCategory; tempI++) {
              const categoryFormArr = []
              categoryFormArr.push(formField)
              tempCategoryObj.categoryData.push({
                categoryFormFields: categoryFormArr,
              })
            }
            for (let tempI = 0; tempI < tempCategoryObj.categoryData?.length; tempI++) {
              const { newObj }: any =
                (await getInputFormFieldValueByIndex(widgetDetailData, label, tempI)) || {}
              tempCategoryObj.categoryData[tempI].categoryFormFields[1] = newObj
            }
          } else {
            const { newObj, value }: any =
              (await getInputFormFieldValue(widgetDetailData, categoryLabel, fieldName)) || {}
            tempCategoryObj.categoryData[0].categoryFormFields = [formField]
            if (isValidObject(newObj) && value && fieldName === FORM_FIELD.BLITZ_ATTRIBUTES) {
              tempCategoryObj.categoryData[0].categoryFormFields[1] = newObj
            }
          }
        } else {
          const { value }: any =
            (await getInputFormFieldValue(widgetDetailData, categoryLabel, fieldName)) || {}
          tempCategoryObj.categoryData[0].categoryFormFields.push(formField)
          if (formField?.conditions?.length > 0 && value) {
            getNewFieldObjForOthersAttributeChange(value, formField).then((re) => {
              re?.forEach((item: any) => {
                tempCategoryObj.categoryData[0].categoryFormFields.push(item)
              })
            })
          }
        }
      }
    }
    finalPreparedInputFormArr.push(tempCategoryObj)
  }
  return {
    inputFormKeysWithAddMoreValue,
    finalPreparedInputFormArr,
  }
}

export const getInputFormFieldValueByIndex = async (
  widgetDetailData = {} as any,
  categoryLabel = '',
  index = -1,
) => {
  categoryLabel = toCapitalCase(categoryLabel)
  const { data: { query = {} } = {} } = widgetDetailData || {}
  const formFieldArrByCategory = query[categoryLabel]
  const { parameterId = '', attributeKey = '' } = formFieldArrByCategory?.[index] || {}
  const newObj: any = await getNewFieldObjForBlitzAttributeChange(parameterId)
  const fieldValue = getFieldValueObj(attributeKey, newObj)
  return fieldValue
}

export const getFieldValueByCategoryIndexnFieldName = async (
  widgetDetailData = {} as any,
  categoryLabel = '',
  fieldName = '',
  index = -1,
) => {
  const { data: { query = {} } = {} } = widgetDetailData || {}
  const formFieldArrByCategory = query[categoryLabel]
  const { rangeKey = '', attributeKey = '', attributeValue } = formFieldArrByCategory?.[index] || {}
  if (fieldName === FORM_FIELD.RANGE_BY) {
    const fieldValue = getFieldValueObj(rangeKey, {})
    return fieldValue
  }
  if (fieldName === FORM_FIELD.BLITZ_ATTRIBUTES) {
    const fieldValue = getFieldValueObj(attributeKey, {})
    return fieldValue
  }
  if (
    [CATEGORY_LABEL.SELECT_BY_BLITZ_ATTRIBUTE, CATEGORY_LABEL.EXCLUDE_BY_BLITZ_ATTRIBUTE].includes(
      categoryLabel,
    )
  ) {
    const fieldValue = getFieldValueObj(attributeValue, {})
    return fieldValue
  }
  const fieldValue = getFieldValueObj(formFieldArrByCategory?.[index]?.[fieldName], {})
  return fieldValue
}

export const getInputFormFieldValue = async (
  widgetDetailData = {} as any,
  categoryLabel = '',
  fieldNameFromInputForm = '',
) => {
  let fieldValue: any
  if (isValidObject(widgetDetailData) && isValidObject(widgetDetailData?.data?.query)) {
    const { data: { query = {} } = {} } = widgetDetailData || {}
    const formFieldByFieldName = query[fieldNameFromInputForm]
    if (isValidObject(formFieldByFieldName) && !Array.isArray(formFieldByFieldName)) {
      const { value }: any = formFieldByFieldName || {}
      if (typeof value === 'string') {
        fieldValue = getFieldValueObj(value)
        return fieldValue
      }
    }
    if (formFieldByFieldName === undefined || Array.isArray(formFieldByFieldName)) {
      const formFieldArrByCategory = query[categoryLabel]
      if (Array.isArray(formFieldArrByCategory)) {
        for (
          let categoryFieldIndex = 0;
          categoryFieldIndex < formFieldArrByCategory.length;
          categoryFieldIndex++
        ) {
          const {
            parameterId = '',
            dataType,
            fieldName = '',
            value,
            attributeKey = '',
            attributeValue,
            rangeKey = '',
          } = formFieldArrByCategory[categoryFieldIndex] || {}
          if (fieldNameFromInputForm === fieldName) {
            if (
              fieldNameFromInputForm !== FORM_FIELD.RANGE_BY &&
              fieldNameFromInputForm !== FORM_FIELD.BLITZ_ATTRIBUTES
            ) {
              if (typeof value === 'object' && Array.isArray(value)) {
                fieldValue = getFieldValueObj(value)
                break
              }
              if (typeof value === 'string' && dataType === 'Number' && !Array.isArray(value)) {
                fieldValue = getFieldValueObj(value)
                break
              }
              if (typeof value === 'string' && !Array.isArray(value)) {
                fieldValue = getFieldValueObj(value)
                break
              }
            }
            if (fieldNameFromInputForm === FORM_FIELD.BLITZ_ATTRIBUTES) {
              if (parameterId) {
                const newObj: any = await getNewFieldObjForBlitzAttributeChange(parameterId)
                fieldValue = getFieldValueObj(attributeKey, newObj)
              } else {
                fieldValue = getFieldValueObj(attributeKey)
              }
              break
            }
            if (fieldNameFromInputForm === FORM_FIELD.RANGE_BY) {
              fieldValue = getFieldValueObj(rangeKey)
              break
            }
          }
          if (categoryLabel === CATEGORY_LABEL.RANGE_BY_BLITZ_ATTRIBUTE) {
            const firstObj = formFieldArrByCategory[categoryFieldIndex]
            fieldValue = {
              value: firstObj[fieldNameFromInputForm],
              newObj: {},
            }
            break
          }
          if (
            [
              CATEGORY_LABEL.SELECT_BY_BLITZ_ATTRIBUTE,
              CATEGORY_LABEL.EXCLUDE_BY_BLITZ_ATTRIBUTE,
            ].includes(categoryLabel)
          ) {
            if (attributeKey === fieldNameFromInputForm) {
              fieldValue = getFieldValueObj(attributeValue)
              break
            }
          }
        }
      }
    }
  }
  return fieldValue
}

export const getNewFieldObjForOthersAttributeChange = async (value: any, mainField?: any) => {
  const { conditions } = mainField
  const newObj: any = []
  if (mainField) {
    const newField = conditions.find((item: any) => item.parameterValue === value)
    if (newField && newField?.parameterValue && newField?.dependentParameters?.length > 0) {
      for (let i = 0; i < newField?.dependentParameters?.length; i++) {
        const dependentParameters = newField?.dependentParameters[i]
        const formField: any = createDeepCopy(dependentParameters)

        const { parameterId: { master = '' } = {} } = formField || {}

        const splittedUrl = master.split('/')
        const keyName = `keyName=${splittedUrl[splittedUrl.length - 1]}`
        const res = await store.dispatch(getMasterByKey(keyName) as any)

        if (res?.payload?.responseCode === 200) {
          if (formField.parameterId) {
            formField.options = res.payload.data
            formField.parameter = formField.parameterId
            formField.parameterRepositoryId = formField.parameter._id
            formField.parameter.fieldName = dashStrToCapitalCase(formField.parameter.fieldName)
          }

          newObj.push({
            required: 'No',
            grid: 6,
            validations: [],
            conditions: [],
            parameterRepositoryId: formField.parameter._id,
            options: res.payload.data || [],
            parameter: formField.parameterId,
          })
        }
      }
    }
  }
  return newObj
}

export const getNewFieldObjForBlitzAttributeChange = async (additionalField: any) => {
  let newObj = {}

  if (additionalField) {
    const { payload: { responseCode = 0, data = {} } = {} }: any = await store.dispatch(
      getParameterRepositoryDetail(
        typeof additionalField === 'object' ? additionalField._id : additionalField,
      ) as any,
    )
    if (responseCode === 200) {
      const { master = '', fieldType = '' } = data || {}
      if (master && fieldType?.toLowerCase() === 'select') {
        const masterUrl = getCorrectMasterAPIUrl(master)
        const masterRes = await store.dispatch(getAutomatedMastersData({ url: masterUrl }) as any)
        if (masterRes?.payload?.data?.responseCode === 200) {
          newObj = {
            required: 'No',
            grid: 6,
            validations: [],
            conditions: [],
            parameterRepositoryId: additionalField,
            options: masterRes?.payload?.data?.data || [],
            parameter: data,
          }
        }
      }
      if (!master && fieldType?.toLowerCase() !== 'select') {
        newObj = {
          required: 'No',
          grid: 6,
          validations: [],
          conditions: [],
          parameterRepositoryId: additionalField,
          parameter: data,
        }
      }
    }
  }
  return newObj
}

const getFieldValueObj = (fieldValue: any, newObj = {}) => {
  return {
    value: fieldValue,
    newObj: isValidObject(newObj) ? newObj : {},
  }
}

export const convertURL = (url: string) => {
  return `${CONSTANTS.CLOUDFRONT_BASE_URL}${url.slice(CONSTANTS.S3_BUCKET_BASE_URL?.length)}`
}
export function getKeyByType(item: any, type: 'id' | 'title'): string {
  if (!item || typeof item !== 'object') {
    return ''
  }
  const keysMap: { [key: string]: string[] } = {
    title: ['assetTitle', 'widgetTitle', 'containerTitle', 'siteNavigationTitle', 'title'],
    id: [
      'assetId',
      'widgetId',
      'containerId',
      'contentId',
      'siteNavigationId',
      'childContentId',
      'id',
    ],
  }

  const keysToCheck = keysMap[type]
  if (!keysToCheck) {
    return ''
  }

  for (const key of keysToCheck) {
    if (item[key]) {
      return key
    }
  }
  return ''
}
export const getModifiedData = (data: any[]) => {
  const { ASSET, CONTAINER, WIDGET } = MODULE_CONSTANTS

  return (
    data?.map((item: any, index: number) => {
      const idKey = getKeyByType(item, 'id')
      const id = item?.[idKey]
      const module =
        item?.type && (item.type === WIDGET || item.type === ASSET || item.type === CONTAINER)
          ? item.type
          : idKey.replace('Id', '')
      const position = item?.position ?? index + 1
      const selectedAssetProperty: any = {}
      if (module === ASSET) {
        selectedAssetProperty.pinnedLang = item?.pinnedLang
        selectedAssetProperty.isBaseAsset = item?.isBaseAsset
      }

      return { contentId: `${id}`, module, position, ...selectedAssetProperty }
    }) || []
  )
}
export const prepareDefaultDataObject = async (
  finalPreparedInputFormArr = [],
  widgetDetailData = {},
) => {
  let defaultDataTempObj: any = {}
  for (let formDataIndex = 0; formDataIndex < finalPreparedInputFormArr?.length; formDataIndex++) {
    const {
      isCategoryHasAddMore = false,
      categoryLabel = '',
      categoryData = [],
    } = finalPreparedInputFormArr[formDataIndex]
    const categoryLabelKey = toCapitalCase(categoryLabel)
    const tempObj: any = {}
    if (isCategoryHasAddMore) {
      tempObj[categoryLabelKey] = []
    }
    for (let categoryFormIndex = 0; categoryFormIndex < categoryData?.length; categoryFormIndex++) {
      const { categoryFormFields = [] } = categoryData[categoryFormIndex]
      for (let formFieldIndex = 0; formFieldIndex < categoryFormFields?.length; formFieldIndex++) {
        const formField = categoryFormFields[formFieldIndex]
        const { parameter: { fieldName = '' } = {} } = formField || {}
        let fieldValue: any
        if (
          [
            CATEGORY_LABEL.SELECT_BY_BLITZ_ATTRIBUTE,
            CATEGORY_LABEL.EXCLUDE_BY_BLITZ_ATTRIBUTE,
          ].includes(categoryLabelKey)
        ) {
          if (formFieldIndex === 0) {
            const { value }: any =
              (await getInputFormFieldValueByIndex(
                widgetDetailData,
                categoryLabel,
                categoryFormIndex,
              )) || {}
            fieldValue = value
          } else {
            const { value }: any =
              (await getInputFormFieldValue(widgetDetailData, categoryLabelKey, fieldName)) || {}
            fieldValue = value
          }
        } else if (categoryLabelKey === CATEGORY_LABEL.RANGE_BY_BLITZ_ATTRIBUTE) {
          const { value }: any =
            (await getFieldValueByCategoryIndexnFieldName(
              widgetDetailData,
              categoryLabelKey,
              fieldName,
              categoryFormIndex,
            )) || {}
          fieldValue = value
        } else {
          const { value }: any =
            (await getInputFormFieldValue(widgetDetailData, categoryLabelKey, fieldName)) || {}
          fieldValue = value
        }
        if (isCategoryHasAddMore) {
          tempObj[categoryLabelKey][categoryFormIndex] = {
            ...tempObj[categoryLabelKey][categoryFormIndex],
            [fieldName]: fieldValue,
          }
        } else {
          tempObj[fieldName] = fieldValue
        }
        defaultDataTempObj = { ...defaultDataTempObj, ...tempObj }
      }
    }
  }
  return defaultDataTempObj
}

export const debounceFunction = (func: any, timeout = 500) => {
  let timer: any
  return (...args: any[]) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func.apply(this, args)
    }, timeout)
  }
}

export const asyncDebounceFunction = (func: any, timeout = 500) => {
  let timer: any
  return async (...args: any[]) => {
    clearTimeout(timer)
    return new Promise<void>((resolve) => {
      timer = setTimeout(async () => {
        await func.apply(this, args)
        resolve()
      }, timeout)
    })
  }
}

export function cleanObject(obj: { [key: string]: any }) {
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v !== undefined && v !== null))
}

// Helper function to extract dynamic keys
export function extractDynamicData(prefix: string, originalData: any) {
  const dynamicData: any[] = []
  const regex = new RegExp(`^${prefix}_\\d+_(.+)$`)
  Object.keys(originalData).forEach((key) => {
    const match = key.match(regex)
    if (match) {
      const index = parseInt(key.split('_')[1], 10)
      const attribute = match[1]
      if (!dynamicData[index]) dynamicData[index] = {}
      dynamicData[index][attribute] = originalData[key]
    }
  })
  return dynamicData.map(cleanObject).filter((item: any) => Object.keys(item).length === 2)
}

export const greatestCommonDivisor = (firstNumber: number, secondNumber: number): number => {
  return secondNumber === 0
    ? firstNumber
    : greatestCommonDivisor(secondNumber, firstNumber % secondNumber)
}

export const calculateAspectRatio = (width: number, height: number): string => {
  const divisor = greatestCommonDivisor(width, height)
  return `${width / divisor}:${height / divisor}`
}

export const isWithinTolerance = (
  width: number,
  height: number,
  validWidth: number,
  validHeight: number,
) => {
  // Calculate the 10% tolerance range for width
  const minWidth = validWidth * 0.9
  const maxWidth = validWidth * 1.1

  // Calculate the 10% tolerance range for height
  const minHeight = validHeight * 0.9
  const maxHeight = validHeight * 1.1

  // Check if both width and height are within the tolerance range
  const isWidthValid = width >= minWidth && width <= maxWidth
  const isHeightValid = height >= minHeight && height <= maxHeight

  return isWidthValid && isHeightValid
}

export const getFormattedValue = (data: any) => {
  let result = 'NA'
  if (data?.parameterId && data?.value) {
    switch (data?.parameterId?.fieldType?.toLowerCase()) {
      case 'time':
        result = getDateInFormat(data?.value, CONSTANTS.TIME_FORMAT_3)
        break

      case 'year':
        result = getDateInFormat(data?.value, CONSTANTS.DATE_YEAR_FORMAT)
        break

      case 'datetime':
        result = getDateInFormat(data?.value, CONSTANTS.DATE_FORMAT_TIME)
        break

      case 'date':
        result = getDateInFormat(data?.value, CONSTANTS.DATE_FORMAT)
        break

      default:
        result = data?.value
        break
    }
  }

  return result
}

export const getFormattedValueBasedOnType = (value: any, fieldType: string) => {
  let result = 'NA'
  if (fieldType && value) {
    switch (fieldType?.toLowerCase()) {
      case 'time':
        result = getDateInFormat(value, CONSTANTS.TIME_FORMAT_3)
        break

      case 'year':
        result = getDateInFormat(value, CONSTANTS.DATE_YEAR_FORMAT)
        break

      case 'datetime':
        result = getDateInFormat(value, CONSTANTS.DATE_FORMAT_TIME)
        break

      case 'date':
        result = getDateInFormat(value, CONSTANTS.DATE_FORMAT)
        break

      default:
        result = value
        break
    }
  }

  return result
}

export const openLinkInNewTab = (url: string) => {
  window.open(url, '_blank', 'noopener,noreferrer')
}

export const validateField = (value: string, validations: any[], fieldName: string) => {
  for (const validation of validations) {
    switch (validation.functionName) {
      case FieldFunctions.EQUALS: {
        // Add logic for equals validation
        break
      }
      case FieldFunctions.ALPHA: {
        const regex = new RegExp(validation.customValue)
        if (!regex.test(value)) {
          return `${fieldName} must be alphabetic`
        }
        break
      }
      case FieldFunctions.ALPHANUM: {
        const regex = /^[a-zA-Z0-9]+$/
        if (!regex.test(value)) {
          return `${fieldName} must be alphanumeric`
        }
        break
      }
      case FieldFunctions.ALNUM_WITH_SPECIAL_CHARS: {
        const regex = new RegExp(validation.customValue)
        if (!regex.test(value)) {
          return `${fieldName} must be alphanumeric with special characters`
        }
        break
      }
      case FieldFunctions.MAX:
        if (value.length > parseInt(validation.customValue, 10)) {
          return `${fieldName} should not exceed ${validation.customValue} characters.`
        }
        break
      case FieldFunctions.MIN: {
        if (value.length < parseInt(validation.customValue, 10)) {
          return `${fieldName} should be at least ${validation.customValue} characters.`
        }
        break
      }
      case FieldFunctions.PATTERN: {
        const regex = new RegExp(validation.customValue)
        if (!regex.test(value)) {
          return `${fieldName} is invalid.`
        }
        break
      }
      case FieldFunctions.URI: {
        const regex = new RegExp(
          '^(https?:\\/\\/|http:\\/\\/)?' + // protocol (http or https optional)
            '((([a-z0-9](?:[a-z0-9-]*[a-z0-9])?)\\.)+[a-z]{2,}|' + // domain name
            'localhost|' + // localhost
            '\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}|' + // IP address
            '\\[?[a-f0-9]*:[a-f0-9:%.]*\\]?)' + // IPv6
            '(\\:\\d+)?(\\/[-a-z0-9+&@#/%=~_|$?!:.]*[a-z0-9+&@#/%=~_|$])?$', // path
          'i',
        )
        if (!regex.test(value)) {
          return `${fieldName} is invalid.`
        }
        break
      }
      case FieldFunctions.DATE_GREATER_THAN: {
        // Add logic for date greater than validation
        break
      }
      case FieldFunctions.DATE_LESS_THAN: {
        // Add logic for date less than validation
        break
      }
      case FieldFunctions.DATE_LESS_THAN_EQUALS: {
        // Add logic for date less than or equals validation
        break
      }
      case FieldFunctions.DATE_GREATER_THAN_EQUALS: {
        // Add logic for date greater than or equals validation
        break
      }
      case FieldFunctions.ISO: {
        const regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,3})?Z$/ // ISO date format
        if (!regex.test(value)) {
          return `${validation.displayName} is invalid.`
        }
        break
      }
      case FieldFunctions.VALIDATE_ASPECT_RATIO: {
        // Add logic for aspect ratio validation
        break
      }
      case FieldFunctions.VALIDATE_FILE_TYPE: {
        // Add logic for file type validation
        break
      }
      case FieldFunctions.VALIDATE_RESOLUTION: {
        // Add logic for resolution validation
        break
      }
      case FieldFunctions.COUNTRY_FOR_RATINGS: {
        // Add logic for country for ratings validation
        break
      }
      case FieldFunctions.LIMIT: {
        // Add logic for limit validation
        break
      }
      // Add more validation cases as needed
      default:
        break
    }
  }
  return true
}

const formatErrorMessage = (message: string) => {
  return message.replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase())
}

export const setFormErrors = (errors: any, setError: any) => {
  let imageErrors = null
  errors.forEach((error: string) => {
    const errorData = error
      .split('"')
      .filter(Boolean)
      .filter((item: string) => item !== ' ' && item)
    const fieldNameData = errorData[0].split('.')
    let fieldName = ''
    const message = errorData[errorData.length - 1]

    if (fieldNameData.length > 1) {
      const lastElement = fieldNameData[fieldNameData.length - 1]
      const secondLastElement = fieldNameData[fieldNameData.length - 2]

      if (secondLastElement.includes('[') && secondLastElement.includes(']')) {
        fieldName = `${secondLastElement}.${lastElement}`
      } else {
        fieldName = lastElement
      }
    } else {
      fieldName = fieldNameData[0]
    }

    let formattedString = formatErrorMessage(fieldName)
    if (fieldName.includes('].')) {
      const splitString = fieldName.split('].')[1]
      formattedString = formatErrorMessage(splitString)
    }
    const errorMessage = formattedString + ' ' + message.trim()
    if (setError === 'images') {
      imageErrors = {
        fieldName,
        errorMessage,
      }
    } else {
      setError(fieldName, {
        type: 'manual',
        message: errorMessage,
      })
    }
  })

  if (imageErrors) {
    return imageErrors
  }
}
// Utility function to dynamically fetch ID, title, type, or other fields
export const getDynamicRowValue = (data: any, fieldType: string) => {
  // Define regular expressions for different field types
  const regexMappings: { [key: string]: RegExp } = {
    id: /^(assetId|widgetId|containerId|contentId|siteNavigationId|id)$/,
    title: /^(assetTitle|widgetTitle|containerTitle|contentTitle|siteNavigationTitle|title)$/,
    type: /^(assetType|widgetType|containerType|siteNavigationType|contentType|type)$/,
    // You can add more categories if needed
  }
  // If the fieldType exists in the mapping, use the corresponding regex
  const regex = regexMappings[fieldType.toLowerCase()]
  if (!regex) return ''
  // Iterate over the data's keys and return the matching value
  for (const key of Object.keys(data)) {
    if (regex.test(key) && data[key]) {
      return data[key]
    }
  }
  // Return an empty string if no match is found
  return ''
}

export const displayMultipleTitle = (data: IKeyValue[] | null | undefined): string => {
  if (!data) return ''
  const predicate = (item: IKeyValue | string) => (typeof item === 'object' ? item.value : item)
  return data.map(predicate).join(', ')
}

export const getFieldValues = (value: any, fieldType: string) => {
  if (!value) return 'NA'

  if (Array.isArray(value)) {
    if (value.length === 0) return 'NA'
    return displayMultipleTitle(value)
  }

  return getFormattedValueBasedOnType(value, fieldType)
}

export const handleMarkAsDoneButton = async (dispatch: AppDispatch, requestedData: any) => {
  dispatch(setLoader(true))
  dispatch(setContainerErrors(null))
  try {
    const result: any = await mainApiService(requestedData)
    if (result?.responseCode === 200) {
      dispatch(showAlert([true, result.message, 'success']))
      return result
    } else {
      handleApiError(dispatch, result)
      return 'error'
    }
  } catch (error) {
    console.error('error', error)
  } finally {
    dispatch(setLoader(false))
  }
}

export const findKeyByWords = (sentence: any) => {
  const words = sentence.toUpperCase().split(' ')
  const key = CONSTANTS.TIPS_KEY.filter((item) =>
    words.every((word: any) => item.value.includes(word)),
  ).map((item) => item.key)
  return `key=${key?.[0]}`
}

export const getNavigationLink = (item: any) => {
  const { moduleName, contentMongoId } = item

  switch (moduleName) {
    case 'Container':
      return `/manage-container/view/${contentMongoId}`

    case 'Site Navigation':
      return `/site-navigation/view/${contentMongoId}`

    case 'Widget':
      return `/manage-widget/view/${contentMongoId}`

    default:
      return '/home'
  }
}

export const getDefaultFieldTitleValues = (data: any, parameterRef: any, required?: any) => {
  return {
    title: data?.parameterName,
    value: 'NA',
    updatedValue: '',
    fieldName: data?.fieldName,
    parameterRef,
    required: isFieldRequired(required),
    fieldType: data?.fieldType,
  }
}
export const getConditionalFieldValues = (data: any, prefilledData: any) => {
  const conditionalFieldToShow: any[] = []
  if (data?.conditions?.length > 0) {
    data.conditions.forEach((condition: any) => {
      const isItemValueInDetail = checkIsItemValueInDetail(
        prefilledData?.parameters,
        data?.parameter?.fieldName,
        condition?.parameterValue,
      )
      if (isItemValueInDetail && condition?.dependentParameters?.length > 0) {
        condition.dependentParameters.forEach((dependentParameter: any) => {
          conditionalFieldToShow.push(
            getDefaultFieldTitleValues(dependentParameter?.parameterId, []),
          )
        })
      }
    })
  }

  return conditionalFieldToShow
}

export const getPayloadFieldValue = (value: any, type: string) => {
  const dateAndTimeTypes = ['date', 'time', 'datetime', 'year']
  if (value && Array.isArray(value) && value.length === 0) return []
  if (value && dateAndTimeTypes.includes(type.toLowerCase()) && isNaN(new Date(value).getTime()))
    return undefined
  return value
}

export const getFieldBorderBottomValue = (data: any[], index: number) => {
  if (data?.length < 2) return 'none'
  if (index === data.length - 1) return 'none'
  return '1px solid rgba(0, 0, 0, 0.16)'
}

export const findPrefilledValue = (
  fromListToFind: any[],
  fieldNameOrValue: string,
  type: 'parameters' | 'conditions' = 'parameters',
) => {
  const predicate =
    type === 'conditions'
      ? (item: any) => fieldNameOrValue === item?.parameterValue
      : (item: any) => fieldNameOrValue === item?.parameterId?.fieldName

  return fromListToFind.find(predicate)
}

export const getConditionalFieldsToShow = (formData: any[], formFieldValues: any) => {
  const conditionalFieldsToShow: string[] = []
  formData?.forEach((form: any) => {
    form?.tabContent?.formData.forEach((item: any) => {
      if (item?.form?.length > 0) {
        item.form.forEach((formItem: any) => {
          const { conditions, parameter } = formItem
          if (conditions?.length > 0) {
            const currentFieldValue = formFieldValues?.[toCamelCase(parameter.fieldName)]
            const isCurrentValueAvailableInCondition = findPrefilledValue(
              conditions,
              currentFieldValue,
              'conditions',
            )
            if (isCurrentValueAvailableInCondition) {
              conditionalFieldsToShow.push(parameter.fieldName)
            }
          }
        })
      }
    })
  })
  return conditionalFieldsToShow
}
export const getPageName = (pageType: any) => {
  switch (pageType) {
    case 'widget':
      return { pageName: 'Manage Widget', pageLink: 'manage-widget' }
    case 'segment':
      return { pageName: 'Manage Segment', pageLink: 'manage-segment' }
    case 'site-navigation':
      return { pageName: 'Site Navigation', pageLink: 'site-navigation' }
    case 'container':
      return { pageName: 'Manage Conatiner', pageLink: 'manage-container' }
    case 'tray-ranking':
      return {
        pageName: 'Tray Ranking',
        pageLink: `${PAGES_ROUTES.BoltMaster}/${PAGES_ROUTES.TrayRanking}`,
      }
    case 'parameter-repository':
      return {
        pageName: 'Parameter',
        pageLink: `${PAGES_ROUTES.BoltMaster}/${PAGES_ROUTES.ParameterRepository}`,
      }
    default:
      return ''
  }
}

export const getHeaderData = (detailData: any, module: any) => {
  let headerData = []
  const behaviorFormData = detailData?.behaviour?.parameters
  let segment: any
  if (behaviorFormData?.length > 0) {
    const segmentData = behaviorFormData.find(
      (item: any) => item?.parameterId?.fieldName === 'segment',
    )

    segment = segmentData?.value || 'NA'
  }
  switch (module) {
    case 'container': {
      const getAssetTypeValues = () => {
        const assetType = detailData?.data?.parameters?.find(
          (item: any) => item?.parameterId?.fieldName === 'asset_types',
        )

        return assetType?.value || 'NA'
      }

      const ContainerHeader: { [key: string]: any } = {
        containerId: detailData?.containerId || 'NA',
        assetType: getAssetTypeValues(),
        createdOn: detailData?.createdAt || 'NA',
        segment: segment,
        lastUpdatedOn: detailData?.updatedAt || 'NA',
        lastFeaturedOn: detailData?.lastFeaturedDate || 'NA',
      }

      let keyToPresentInHeader: { key: string; title: string; type?: string }[] = []
      const layout =
        detailData?.layout?.toLowerCase() as keyof typeof CONSTANTS.CONTAINER_LAYOUT_HEADER_INFO
      if (
        layout &&
        Object.prototype.hasOwnProperty.call(CONSTANTS.CONTAINER_LAYOUT_HEADER_INFO, layout)
      ) {
        keyToPresentInHeader = CONSTANTS.CONTAINER_LAYOUT_HEADER_INFO[layout]
      } else {
        keyToPresentInHeader = CONSTANTS.CONTAINER_LAYOUT_HEADER_INFO['other layout']
      }
      for (const item of keyToPresentInHeader) {
        const updatedInfo: any = {
          title: item.title,
          value: ContainerHeader[item.key],
        }
        if (Object.prototype.hasOwnProperty.call(item, 'type')) {
          updatedInfo.type = item.type
        }
        headerData.push(updatedInfo)
      }

      break
    }

    case 'widget': {
      headerData = [
        {
          title: 'Segment',
          value: segment,
        },
        {
          title: 'Data Engine',
          value: detailData?.data?.engine
            ? `${detailData?.data?.engine.charAt(0).toUpperCase()}${detailData?.data?.engine
                .slice(1)
                .toLowerCase()}`
            : 'NA',
        },
        {
          title: 'Widget Id',
          value: detailData?.widgetId,
        },
        { title: 'Created on', value: detailData?.createdAt || 'NA', type: 'date' },
        {
          title: 'Last Updated on',
          value: detailData?.updatedAt || 'NA',
          type: 'date',
        },
        {
          title: 'Last Featured on',
          value: detailData?.lastFeaturedDate || 'NA',
          type: 'date',
        },
      ]
      break
    }

    case 'site-navigation': {
      headerData = [
        {
          title: 'Widget Id',
          value: detailData?.siteNavigationId,
        },
        {
          title: 'Segment',
          value: segment,
        },
        {
          title: 'Last Featured on',
          value: detailData?.lastFeaturedDate || 'NA',
          type: 'date',
        },
        { title: 'Created on', value: detailData?.createdAt || 'NA', type: 'date' },
        {
          title: 'Last Updated on',
          value: detailData?.updatedAt || 'NA',
          type: 'date',
        },
      ]
      break
    }

    case 'segment': {
      headerData = [
        { title: 'Created on', value: detailData?.createdAt || 'NA', type: 'date' },
        {
          title: 'Last Updated on',
          value: detailData?.updatedAt || 'NA',
          type: 'date',
        },
      ]
      break
    }

    case 'parameter-repository': {
      headerData = [
        {
          title: 'Mandatory',
          value: detailData?.mandatory ? 'True' : 'False',
        },
        { title: 'Created on', value: detailData?.createdAt || 'NA', type: 'date' },
        {
          title: 'Last Updated on',
          value: detailData?.updatedAt || 'NA',
          type: 'date',
        },
      ]
      break
    }

    default:
      break
  }

  return headerData
}

export const checkIsFormValid = (requiredFields: string[], fieldsValueData: any) => {
  return requiredFields?.every((field) => {
    const fieldValue = fieldsValueData?.[field]
    if (fieldValue && typeof fieldValue === 'object') {
      if (Array.isArray(fieldValue)) return fieldValue.length > 0
      return Object.keys(fieldValue).length > 0
    }
    return !!fieldValue
  })
}

export const checkIsItemValueInDetail = (dataToCheck: any[], fieldName: string, value: any) => {
  return dataToCheck?.find(
    (parameter: any) =>
      parameter?.parameterId?.fieldName === fieldName && parameter?.value === value,
  )
}

export const isImageTab = (item: any) => {
  return item?.key?.toLowerCase().includes('image')
}
export const isFieldHasValue = (value: any): boolean => {
  if (!value) return false
  if (typeof value === 'object') {
    return Array.isArray(value) ? value.length > 0 : Object.keys(value).length > 0
  }

  return value.trim() !== ''
}

export const checkFieldValue = (
  fieldName: string,
  prefilledData: any[],
  compareValue: string,
): boolean => {
  const fieldData = prefilledData?.find(
    (data: any) => data?.parameterId?.fieldName === fieldName || data?.fieldName === fieldName,
  )
  return fieldData ? isFieldHasValue(fieldData?.image?.s3Url || fieldData?.[compareValue]) : false
}

export const checkComplexFieldValue = (
  fieldName: any,
  prefilledData: any[],
  compareValue: string,
): boolean => {
  return Object.keys(fieldName).every((key) => {
    const requiredFieldsValue = fieldName[key]
    const complexPrefilledValue = prefilledData?.find(
      (data: any) => data?.parameterId?.fieldName === key || data?.fieldName === key,
    )
    if (
      !complexPrefilledValue ||
      !Array.isArray(complexPrefilledValue?.parameterRef) ||
      (Array.isArray(complexPrefilledValue?.parameterRef) &&
        complexPrefilledValue?.parameterRef.length === 0)
    ) {
      return false
    }

    return requiredFieldsValue.every((field: any) => {
      return complexPrefilledValue?.parameterRef?.every((dataArray: any[]) => {
        if (!dataArray || !Array.isArray(dataArray)) return
        const paramRefValue = dataArray?.find(
          (item: any) => item?.parameterId?.fieldName === field || item?.fieldName === field,
        )
        return isFieldHasValue(paramRefValue?.[compareValue])
      })
    })
  })
}

export const areAllRequiredFieldsPresent = (
  requiredFields: any[],
  prefilledData: any[],
  compareValue: string,
): boolean => {
  return requiredFields?.every((fieldName: any) => {
    return typeof fieldName === 'string'
      ? checkFieldValue(fieldName, prefilledData, compareValue)
      : checkComplexFieldValue(fieldName, prefilledData, compareValue)
  })
}

export const getRequiredFields = (formData: any) => {
  const requiredFieldsList: any[] = []
  formData?.forEach((formItem: any) => {
    if (formItem?.parameter?.fieldType?.toLowerCase() === 'complextype') {
      const complexRequiredFields: string[] = []
      formItem?.parameterRef?.forEach((subItem: any) => {
        if (isFieldRequired(subItem?.required) && subItem?.parameter?.fieldName)
          complexRequiredFields.push(subItem.parameter.fieldName)
      })
      if (complexRequiredFields.length > 0)
        requiredFieldsList.push({ [formItem?.parameter?.fieldName]: complexRequiredFields })
    } else if (isFieldRequired(formItem?.required) && formItem?.parameter?.fieldName)
      requiredFieldsList.push(formItem.parameter.fieldName)
  })

  return requiredFieldsList
}

export const extractUserInfo = (item: any) => {
  const userInfo: any = {}
  if (item?.updatedBy?.userEmail) {
    userInfo.updatedBy = item.updatedBy.userEmail
  }
  if (item?.createdBy?.userEmail) {
    userInfo.createdBy = item.createdBy.userEmail
  }
  return userInfo
}

export const checkComplexType = (data: any, selectedTabs?: any) => {
  if (!data) return false
  return data?.tabs
    ?.find((tab: any) => tab?.key === selectedTabs?.key)
    ?.tabContent?.formData?.[0]?.form?.some(
      (form: any) => form?.parameter?.fieldType?.toLowerCase() === 'complextype',
    )
}

export const isConditionMet = (data: any, parameter: any, condition: any) => {
  if (!data || !parameter || !condition) return false
  return (
    data?.[toCamelCase(parameter?.fieldName)]?.trim() === condition?.parameterValue &&
    condition?.dependentParameters?.length > 0
  )
}

export const extractDependentParameters = (data: any, parameter: any, conditions: any[]) => {
  const parameters: any[] = []
  if (!Array.isArray(conditions) || conditions?.length === 0 || !data || !parameter)
    return parameters
  for (const condition of conditions) {
    if (isConditionMet(data, parameter, condition)) {
      const { dependentParameters } = condition
      dependentParameters.forEach((parameterData: any) => {
        const { parameterId } = parameterData
        const extractedValue = data[parameterId?.fieldName]
        parameters.push({
          parameterId: parameterId?._id,
          fieldName: parameterId?.fieldName,
          value: getPayloadFieldValue(extractedValue, parameterId?.fieldType) || '',
        })
      })
    }
  }
  return parameters
}

export const transformDynamicObjectToArray = (data: Record<string, any>) => {
  const groupedData: Record<string, any> = {}

  // Iterate over the keys of the object
  Object.keys(data).forEach((key) => {
    // Use a regular expression to match keys with the pattern
    const match = key.match(/(.*?)_(\d+)_(.*)/)
    if (match) {
      const [_, base, index, subKey] = match
      // Initialize the base key group if it doesn't exist
      if (!groupedData[base]) {
        groupedData[base] = []
      }

      // Ensure the result array for the base key has an object for the current index
      if (!groupedData[base][+index - 1]) {
        groupedData[base][+index - 1] = {}
      }

      // Assign the value to the correct property
      groupedData[base][+index - 1][subKey] = data[key]
    }
  })

  return groupedData
}

export const handleComplexType = (parameter: any, formItem: any, data: any) => {
  if (!parameter || !formItem || !data) return null
  const transformedArr: any = transformDynamicObjectToArray(data)
  const fieldValue = transformedArr?.[parameter?.fieldName] || []

  return {
    parameterId: parameter?._id,
    fieldName: parameter?.fieldName,
    value: '',
    parameterRef: fieldValue
      ? fieldValue
          ?.map((subItem: any) =>
            formItem?.parameterRef.map((subParameter: any) => {
              const subParamField = toCamelCase(subParameter?.parameter?.fieldName)
              return {
                parameterId: subParameter?.parameter?._id,
                fieldName: subParameter?.parameter?.fieldName,
                value:
                  Array.isArray(subItem?.[subParamField]) && subItem[subParamField].length === 0
                    ? ''
                    : subItem[subParamField],
                _id: subParameter?.parameter?._id,
              }
            }),
          )
          .filter(Boolean)
      : [],
    _id: parameter?._id,
  }
}

export const handleSimpleType = (parameter: any, data: any) => {
  if (
    !parameter?.fieldName ||
    !parameter?.fieldType ||
    !Object.hasOwn(parameter, 'multiSelect') ||
    !data
  )
    return null

  const { fieldName, fieldType, multiSelect } = parameter
  let value = getPayloadFieldValue(data?.[fieldName], fieldType) || ''
  if (fieldName === 'segment' && !multiSelect) {
    value = getSessionStorage('singleSelectSegment') || value || []
  }
  if (fieldName === 'asset_types') {
    value = getSessionStorage('assetTypes') || []
  }

  return {
    parameterId: parameter?._id,
    fieldName: parameter?.fieldName,
    value,
  }
}

export const getImagePrefilledData = (prefilledFormData: any) => {
  if (
    !prefilledFormData ||
    !Array.isArray(prefilledFormData) ||
    (Array.isArray(prefilledFormData) && prefilledFormData.length === 0)
  )
    return []
  const imageData = prefilledFormData?.filter((item: any) =>
    item?.parameterId?.dataType?.toLowerCase()?.includes('image_type'),
  )
  if (!imageData || (imageData && imageData?.length === 0)) return []

  return imageData.map((item: any) => ({
    ...item,
    parameterId: item?.parameterId?._id,
  }))
}
export const getParameterDetails = (data: any, formData: any, prefilledFormData: any) => {
  const parameters: any[] = []
  if (!data || !formData) return parameters
  const formTabsList = formData?.tabs

  if (formTabsList?.length > 0) {
    formTabsList.forEach((item: any) => {
      if (Object.hasOwn(item, 'tabContent') && !isImageTab(item)) {
        const formData = getFormData(item)
        parameters.push(...extractParametersFromFormData(formData, data))
      }
    })
  }

  parameters.push(...getImagePrefilledData(prefilledFormData))

  return parameters.filter(Boolean)
}

export const extractParametersFromFormData = (formData: any, data: any) => {
  const parameters: any[] = []
  if (!formData || !data) return parameters
  const extractedParameters = extractParameters(formData, data)
  parameters.push(...extractedParameters)

  formData?.[0]?.form?.forEach((formItem: any) => {
    const { parameter, conditions } = formItem
    if (parameter?.fieldType?.toLowerCase() !== 'complextype') {
      parameters.push(...extractDependentParameters(data, parameter, conditions))
    }
  })

  return parameters
}

export const getFormData = (item: any) => {
  if (!item?.tabContent) return []
  return item?.tabContent?.formData?.filter((item: any) => item.label === '')
}

export const extractParameters = (formData: any, data: any) => {
  if (!formData || !data) return []

  return (
    formData?.[0]?.form?.flatMap((formItem: any) => {
      const { parameter } = formItem
      if (parameter?.fieldType?.toLowerCase() === 'complextype') {
        return handleComplexType(parameter, formItem, data)
      } else {
        return handleSimpleType(parameter, data)
      }
    }) || []
  )
}

export const capitalizeFirstLetter = (string: string) => {
  if (!string) return 'NA'
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
}

export const getSanitizedValue = (value: any) => {
  return DOMPurify.sanitize(value)
}

export const getSelectedDefinitionAttributeDetails = (selectedAttri: any, attributes: any) => {
  const matchingObjects = []
  for (const selectedObj of selectedAttri) {
    const selectedId = typeof selectedObj === 'string' ? selectedObj : selectedObj?._id
    const matchingDataObject = attributes?.find((ele: any) => ele?._id === selectedId)
    if (matchingDataObject) {
      matchingObjects?.push(matchingDataObject)
    } else if (typeof selectedObj === 'object' && selectedObj?._id) {
      matchingObjects?.push(selectedObj)
    }
  }
  return matchingObjects?.length ? matchingObjects : selectedAttri
}

export const handleDefinitionParameterChange = (
  e: any,
  index: any,
  newValue: any,
  accordianName: any,
  reason: any,
  tabName: any,
  tabs: any,
  accordiansContent: any,
  setAccordiansContent: any,
  selectedParameters: any,
  setSelectedParameters: any,
  setSelectedParametersList: any,
  dispatch: any,
  parametersList: any,
) => {
  const selectedTab = selectedParameters?.[accordianName]?.tabs?.find(
    (tab: IKeyValue) => tab.key === tabName,
  )

  if (reason === CONSTANTS?.AUTOCOMPLETE_EVENT_TYPES.INPUT) {
    return
  }
  let requiredArrayForAPIPayload: any = []
  if (reason === CONSTANTS.AUTOCOMPLETE_EVENT_TYPES.CLEAR) {
    const copyAccordiansContent = JSON.parse(JSON.stringify(accordiansContent))
    copyAccordiansContent[index].tabs = copyAccordiansContent?.[index]?.tabs?.map((item: any) => {
      if (item?.key === tabName) {
        return { ...item, parameters: [] }
      } else {
        return item
      }
    })
    setAccordiansContent(copyAccordiansContent)
  }
  if (
    reason === CONSTANTS.AUTOCOMPLETE_EVENT_TYPES.SELECTOPTION ||
    reason === CONSTANTS.AUTOCOMPLETE_EVENT_TYPES.REMOVEOPTION
  ) {
    const copyAccordiansContent = JSON.parse(JSON.stringify(accordiansContent))
    const copyNewValue = [...newValue]
    let filteredParameters = copyNewValue.filter((param: any) => {
      const hasMatchingParameterRef = copyNewValue.some((otherParam: any) => {
        if (otherParam?.parameterRef?.length) {
          return otherParam.parameterRef.some((ref: any) => {
            const refId = ref?._id
            const paramId = param?._id
            return refId === paramId
          })
        }
        return false
      })

      return !hasMatchingParameterRef
    })

    filteredParameters = filteredParameters?.map((item: any) => {
      if (item?.fieldType?.toLowerCase() === 'complextype' && item?.parameterRef?.length) {
        return {
          ...item,
          parameterRef: getSelectedDefinitionAttributeDetails(item?.parameterRef, parametersList),
        }
      } else {
        return item
      }
    })
    copyAccordiansContent[index].tabs = copyAccordiansContent?.[index]?.tabs?.map((item: any) => {
      if (item?.key === tabName) {
        return { ...item, parameters: filteredParameters }
      } else {
        return item
      }
    })
    setAccordiansContent(copyAccordiansContent)

    const updatedSelectedParameters = { ...selectedParameters }

    if (!updatedSelectedParameters?.[accordianName]) {
      updatedSelectedParameters[accordianName] = {
        tabs: [],
      }
    }

    const updatedTabs =
      updatedSelectedParameters?.[accordianName].tabs?.map(
        (tab: { key: string; value: string; parameters: any[] }) => {
          return {
            ...tab,
            parameters: tab.key === tabName ? newValue : tab.parameters,
          }
        },
      ) || []

    updatedSelectedParameters[accordianName].tabs = updatedTabs
    setSelectedParameters(updatedSelectedParameters)
    requiredArrayForAPIPayload = newValue?.map((item: any) => {
      const parameter = selectedTab?.parameters?.find(
        (param: { _id: string }) => param._id === item?._id,
      )
      let parameterObj: any = {
        parameterRepositoryId: item?._id,
        required: parameter?.required || 'No',
      }
      if (parameter) {
        parameterObj = {
          ...parameterObj,
          ...parameter,
        }
      }
      // Check for COMPLEXTYPE and append additional attributes if necessary
      if (item?.fieldType?.toLowerCase() === 'complextype' && item?.parameterRef?.length) {
        parameterObj.parameterRef = getSelectedDefinitionAttributeDetails(
          item.parameterRef,
          parametersList,
        )
      }

      if (parameterObj?.parameterRef) {
        parameterObj.parameterRef = parameterObj?.parameterRef?.map((item: any) => {
          return {
            parameterRepositoryId: typeof item === 'string' ? item : item?._id,
            required: item?.required || 'No',
          }
        })
      }
      return parameterObj
    })
  }
  const obj: any = {}
  const newPayload = tabs?.map((item: any) => {
    if (item.key === tabName) {
      return {
        ...item,
        parameters: requiredArrayForAPIPayload,
      }
    }
    const newParameters = item?.parameters?.map((item: any) => {
      const parameterObj: any = {
        parameterRepositoryId: item?._id,
        required: item?.required || 'No',
      }
      // Check for COMPLEXTYPE and append additional attributes if necessary
      if (item?.fieldType?.toLowerCase() === 'complextype' && item?.parameterRef?.length) {
        parameterObj.parameterRef = getSelectedDefinitionAttributeDetails(
          item?.parameterRef,
          parametersList,
        )
      }

      if (parameterObj?.parameterRef) {
        parameterObj.parameterRef = parameterObj.parameterRef?.map((item: any) => {
          return {
            parameterRepositoryId: typeof item === 'string' ? item : item?._id,
            required: item?.required || 'No',
          }
        })
      }
      return parameterObj
    })
    return { ...item, parameters: newParameters }
  })
  obj[accordianName] = { tabs: newPayload }
  dispatch(setSelectedParametersList(obj) as any)
}

export function transformArray(tabsData?: any) {
  const newObj = {
    tabs:
      tabsData?.tabs?.map((item: any) => {
        let inputArray = item?.parameters

        if (!Array.isArray(inputArray)) {
          return []
        }
        inputArray = inputArray?.map((item) => {
          if (
            !item ||
            !item?.parameterRepositoryId ||
            typeof item?.parameterRepositoryId?._id !== 'string'
          ) {
            return {
              parameterRepositoryId: '',
              required: 'No',
              conditions: [],
              validations: [],
            }
          }

          const parameterRef =
            item?.parameterRef?.map((refItem: any) => ({
              ...refItem,
              parameterRepositoryId: refItem?.parameterRepositoryId?._id,
            })) || []
          const { _id: parameterRepositoryId } = item.parameterRepositoryId
          const { required = 'No', conditions = [], validations = [] } = item
          return { parameterRepositoryId, required, conditions, validations, parameterRef }
        })

        return {
          ...item,
          parameters: inputArray,
        }
      }) || [],
  }

  return newObj
}

export const setAssetCategoryDefinitionData = (
  forFieldName: string,
  isReset: boolean,
  setValue: any,
  localDispatch: any,
  data: any,
  assetCategoryKeysArray: any,
) => {
  if (forFieldName === 'assetConfig.contentCategory') {
    !isReset && setValue('assetConfig.assetCategory', [])
    !isReset && setValue('assetConfig.assetType', [])
    localDispatch({ type: 'SET_ASSET_OPTIONS', payload: data?.assetCategories || [] })
    return
  }
  if (forFieldName === 'assetConfig.assetCategory') {
    !isReset && setValue('assetConfig.assetType', [])
    !isReset && setValue('assetConfig.assetCategory', assetCategoryKeysArray)
    localDispatch({ type: 'SET_TYPE_OPTIONS', payload: data?.assetTypes || [] })
    return
  }
}

export const updateDefinitionConfigDefaults = (configData: any) => {
  let updatedConfig = { ...configData }

  if (!updatedConfig?.layoutInfo?.length) {
    updatedConfig = {
      ...updatedConfig,
      layoutInfo: [{ type: '', layouts: [] }],
    }
  }

  if (!Object.hasOwn(updatedConfig, 'isMultiSelection')) {
    updatedConfig = {
      ...updatedConfig,
      isMultiSelection: 'yes',
    }
  }

  if (!Object.hasOwn(updatedConfig, 'isFilterRequired')) {
    updatedConfig = {
      ...updatedConfig,
      isFilterRequired: 'no',
    }
  }

  if (!Object.hasOwn(updatedConfig, 'isLimitedSelection')) {
    updatedConfig = {
      ...updatedConfig,
      isLimitedSelection: true,
    }
  }

  return updatedConfig
}

export const assetFieldsReducer = (
  state: typeof AssetFieldsIntialState,
  action: { type: string; payload: any },
) => {
  switch (action.type) {
    case 'SET_CATEGORY_OPTIONS':
      return { ...state, categoryOptions: action.payload }
    case 'SET_ASSET_OPTIONS':
      return { ...state, assetOptions: action.payload }
    case 'SET_TYPE_OPTIONS':
      return { ...state, typeOptions: action.payload }
    default:
      return state
  }
}

export const getStringArray = (array: string[] | undefined): string => {
  if (array && array.length > 0) {
    return array.join(', ')
  } else {
    return 'NA'
  }
}

export const compareData = (array1: any, array2: any) => {
  const normalizeData = (data: any) => {
    if (Object.keys(data).length === 0) return null

    const parameters = data?.parameters || []
    const assetInfo = data?.assetInfo || []
    const widgetInfo = data?.widgetInfo || []

    return {
      parameters: parameters?.map((param: any) => ({
        parameterId:
          typeof param.parameterId === 'object' ? param.parameterId._id : param.parameterId,
        fieldName: param.fieldName,
        value: param.value,
      })),
      assetInfo,
      widgetInfo,
    }
  }

  const normalizedArray1 = normalizeData(array1)
  const normalizedArray2 = normalizeData(array2)

  if (normalizedArray1 && normalizedArray2) {
    const map1 = normalizedArray1?.parameters?.reduce((acc: any, item: any) => {
      acc[item.fieldName] = item.value
      return acc
    }, {})

    const map2 = normalizedArray2?.parameters?.reduce((acc: any, item: any) => {
      acc[item.fieldName] = item.value
      return acc
    }, {})

    const allFields = new Set([...Object.keys(map1), ...Object.keys(map2)])

    for (const field of allFields) {
      const value1 = map1[field]
      const value2 = map2[field]

      if (!(field in map1)) {
        return false
      }

      if (!(field in map2)) {
        if (value1 !== '') {
          return false
        }
        continue
      }

      if (value1 === '' && value2) {
        return false
      }

      if (value1 !== '') {
        if (
          (value1 === '' && Array.isArray(value2) && value2.length === 0) ||
          (Array.isArray(value1) && value1.length === 0 && value2 === '')
        ) {
          continue
        }

        if (!compareValues(value1, value2)) {
          return false
        }
      }
    }
    if (!compareValues(normalizedArray1.assetInfo, normalizedArray2.assetInfo)) {
      return false
    }

    if (!compareValues(normalizedArray1.widgetInfo, normalizedArray2.widgetInfo)) {
      return false
    }

    return true
  }
  return false
}

export const compareNestedData = (data1: any, data2: any) => {
  const normalizeData = (data: any) => {
    if (!data) return null

    // Handle both array and object inputs
    const items = Array.isArray(data) ? data : data?.parameters || data
    return Array.isArray(items) ? items : [items]
  }

  const normalizedData1 = normalizeData(data1)
  const normalizedData2 = normalizeData(data2)

  if (!normalizedData1 || !normalizedData2) {
    return false
  }

  return compareValues(normalizedData1, normalizedData2)
}

export const updateFormFieldOptions = (formField: any, data: any) => {
  if (formField.parameterId) {
    formField.options = data
    formField.parameter = formField.parameterId
    formField.parameterRepositoryId = formField.parameter._id
    formField.parameter.fieldName = dashStrToCapitalCase(formField.parameter.fieldName)
  }
}

export const addFormFieldToCategory = (
  formDataArray: any[],
  formField: any,
  categoryLabel: string,
  setValue: any,
) => {
  formDataArray.forEach((formData: any) => {
    if (formData.categoryLabel === categoryLabel) {
      formData?.categoryData?.forEach((categoryData: any) => {
        setValue(formField.parameter.fieldName, '')
        categoryData.categoryFormFields.push(formField)
      })
    }
  })
}

export const saveFetchAssetsListInStore = (records = [], dispatch: any) => {
  const updatedRecords = records?.map((assetData: any) => {
    const nodes: any = []
    for (const [key, value] of Object.entries(assetData)) {
      if (key !== 'images') {
        nodes.push({
          label: key?.replace(/([A-Z])/g, ' $1').trim(),
          value: value,
        })
      }
    }
    const images: any = []
    for (const [key, value] of Object.entries(assetData?.images)) {
      images.push({
        url: value,
        title: key,
      })
    }
    return {
      id: getIDKey(assetData),
      title: assetData?.title,
      nodes: nodes || [],
      images: images || [],
    }
  })
  dispatch(setFetchedAssetsList(updatedRecords) as any)
}

export const getRestructuredLabelValue = (valueAtLabel: any) => {
  return valueAtLabel?.map((objOfFields: any) => {
    const finalRestructuredObj: any = {}
    if (Object.keys(objOfFields)?.length === 2) {
      const [elementAtIndex0, elementAtIndex1]: any = Object.entries(objOfFields)
      if (Array.isArray(elementAtIndex1[1])) {
        finalRestructuredObj[toCapitalCase(elementAtIndex0[1])] = elementAtIndex1[1]?.map(
          (ele: any) =>
            elementAtIndex1?.[0] === 'svodCountries' || elementAtIndex1?.[0] === 'svod_countries'
              ? ele?.key
              : ele?.value,
        )
      } else {
        finalRestructuredObj[toCapitalCase(elementAtIndex0[1])] = elementAtIndex1[1]
      }
    }
    if (Object.keys(objOfFields)?.length > 2) {
      const [elementAtIndex0, ...remainingArray]: any = Object.entries(objOfFields)
      let tempObj: any = {}
      if (elementAtIndex0[1]) {
        remainingArray?.map(([key, value]: any) => {
          const internalTempObj: any = {}
          internalTempObj[key] = value
          tempObj = { ...tempObj, ...internalTempObj }
        })
      }
      finalRestructuredObj[toCapitalCase(elementAtIndex0[1])] = tempObj
    }
    return finalRestructuredObj || {}
  })
}

export const resetCategoryFormFields = (formDataArray: any[], categoryLabel: string) => {
  formDataArray.forEach((formData: any) => {
    if (formData.categoryLabel === categoryLabel) {
      formData?.categoryData?.forEach((categoryData: any) => {
        categoryData.categoryFormFields = [categoryData.categoryFormFields[0]]
      })
    }
  })
}

export const handleConditionalOptionChange = async (
  conditions: any[],
  forFieldName = '',
  inputForm: any,
  setInputForm: any,
  dispatch: any,
  setValue: any,
) => {
  const copyInputFormData = [...inputForm]
  resetCategoryFormFields(copyInputFormData, 'Others')

  const newField = conditions.find((item: any) => item.parameterValue === forFieldName)
  if (newField && newField?.parameterValue && newField?.dependentParameters?.length > 0) {
    await processDependentParameters(
      newField.dependentParameters,
      copyInputFormData,
      dispatch,
      setValue,
    )
    setInputForm(copyInputFormData)
  }
}

const processDependentParameters = async (
  dependentParameters: any[],
  formDataArray: any[],
  dispatch: any,
  setValue: any,
) => {
  for (const dependentParameter of dependentParameters) {
    const formField: any = createDeepCopy(dependentParameter)
    const { parameterId: { master = '' } = {} } = formField || {}

    const keyName = extractKeyNameFromMaster(master)
    const res = await dispatch(getMasterByKey(keyName) as any)

    if (res?.payload?.responseCode === 200) {
      updateFormFieldOptions(formField, res.payload.data)
      addFormFieldToCategory(formDataArray, formField, 'Others', setValue)
    }
  }
}

const extractKeyNameFromMaster = (master: string) => {
  const splittedUrl = master.split('/')
  return `keyName=${splittedUrl[splittedUrl.length - 1]}`
}

export const updateAutomatedPayloadSaveAction = (
  formField = {} as any,
  value: any = '',
  categoryLabel = '',
  isCategoryHasAddMore = false,
  selectedObj = {} as any,
  categoryIndex = null as any,
  formFieldIndex = null as any,
  payloadForSaveAction: any,
  setPayloadForSaveAction: any,
  dispatch: any,
  setStorePayloadForSaveAction: any,
  inputForm: any,
) => {
  const { parameterRepositoryId = '', parameter = {} } = formField || {}
  const payloadForSaveActionCopy = createDeepCopy(payloadForSaveAction)
  const { data: { query = {} } = {} } = payloadForSaveActionCopy || {}
  if (categoryLabel === CATEGORY_LABEL.RANGE_BY_BLITZ_ATTRIBUTE && formFieldIndex > 0) {
    query[categoryLabel][categoryIndex][parameter?.fieldName] = value
    setPayloadForSaveAction(payloadForSaveActionCopy)
    dispatch(setStorePayloadForSaveAction(payloadForSaveActionCopy) as any)
    return
  }
  if (parameter?.fieldName === FORM_FIELD.BLITZ_ATTRIBUTES) {
    if (query?.[categoryLabel] && !value) {
      query[categoryLabel] = query[categoryLabel].filter(
        (item: any, index: number) => index !== categoryIndex && item.attributeKey,
      )
      setPayloadForSaveAction(payloadForSaveActionCopy)
      dispatch(setStorePayloadForSaveAction(payloadForSaveActionCopy) as any)
      return
    }
    const fieldAvailable = query?.[categoryLabel]?.[categoryIndex]
    if (isValidObject(fieldAvailable)) {
      if (selectedObj?.additionalField) {
        query[categoryLabel][categoryIndex]['parameterId'] = selectedObj?.additionalField
      } else {
        query[categoryLabel][categoryIndex]['parameterId'] = parameter._id
        delete query[categoryLabel][categoryIndex]['attributeValue']
      }
      query[categoryLabel][categoryIndex]['attributeKey'] = value
      setPayloadForSaveAction(payloadForSaveActionCopy)
      dispatch(setStorePayloadForSaveAction(payloadForSaveActionCopy) as any)
      return
    }
  }
  if (parameter?.fieldName === FORM_FIELD.RANGE_BY) {
    const fieldAvailable = query?.[categoryLabel]?.[categoryIndex]
    if (isValidObject(fieldAvailable)) {
      const selectedValueObj: any = formField?.options?.find((ele: any) => ele?.key === value)
      if (selectedValueObj) {
        query[categoryLabel][categoryIndex]['parameterId'] = selectedValueObj?._id || ''
        query[categoryLabel][categoryIndex]['rangeKey'] = value
      } else {
        query[categoryLabel][categoryIndex]['parameterId'] = parameter._id
        delete query[categoryLabel][categoryIndex]['rangeKey']
      }
      setPayloadForSaveAction(payloadForSaveActionCopy)
      dispatch(setStorePayloadForSaveAction(payloadForSaveActionCopy) as any)
      return
    }
  }
  const isFormFieldExistAtIndex = query[categoryLabel]?.findIndex(
    (ele: any) => ele?.parameterId === parameterRepositoryId,
  )
  if (isFormFieldExistAtIndex > -1) {
    if (!isCategoryHasAddMore) {
      if (typeof value === 'number') value = '' + value
      query[categoryLabel][isFormFieldExistAtIndex].value = value
    } else {
      if (categoryLabel !== CATEGORY_LABEL.RANGE_BY_BLITZ_ATTRIBUTE) {
        query[categoryLabel][isFormFieldExistAtIndex].attributeValue = value
      }
    }
    if (
      categoryLabel === FORM_FIELD.ORDER_BY &&
      !query[categoryLabel][isFormFieldExistAtIndex]?.value
    ) {
      delete query[categoryLabel][isFormFieldExistAtIndex]?.value
    }
  } else {
    const formFieldDataObj: any = {
      name: parameter?.parameterName || '',
      fieldName: parameter?.fieldName || '',
      fieldType: parameter?.fieldType || '',
      dataType: parameter?.dataType || '',
    }
    if (!isCategoryHasAddMore) {
      formFieldDataObj['value'] = value
      formFieldDataObj['parameterId'] = parameterRepositoryId
    } else {
      if (categoryLabel === CATEGORY_LABEL.RANGE_BY_BLITZ_ATTRIBUTE) {
        const selectedValueObj: any = formField?.options?.find((ele: any) => ele?.key === value)
        formFieldDataObj['parameterId'] = selectedValueObj?._id
        if (parameter?.fieldName === FORM_FIELD.RANGE_BY) {
          formFieldDataObj['rangeKey'] = value
        }
      } else {
        formFieldDataObj['parameterId'] = selectedObj?.additionalField
        formFieldDataObj['attributeKey'] = value
        formFieldDataObj['attributeValue'] = ''
      }
    }
    query[categoryLabel]?.push(formFieldDataObj)
  }

  if (categoryLabel === 'others') {
    const validFieldNames = inputForm
      .find((input: any) => input?.categoryLabel?.toLowerCase() === categoryLabel)
      ?.categoryData?.[0]?.categoryFormFields?.map((item: any) => item?.parameter?.fieldName)
    const filteredArray = payloadForSaveActionCopy.data?.query?.[categoryLabel]?.filter(
      (item: any) => validFieldNames.includes(item.fieldName),
    )

    if (filteredArray) {
      payloadForSaveActionCopy.data.query[categoryLabel] = filteredArray
    }
  }

  setPayloadForSaveAction(payloadForSaveActionCopy)
  dispatch(setStorePayloadForSaveAction(payloadForSaveActionCopy) as any)
}

export const compareValues = (filteredValue1: any, filteredValue2: any): boolean => {
  const value1 = Array.isArray(filteredValue1)
    ? filteredValue1.filter((item: any) => item && Object.keys(item).length > 0)
    : filteredValue1
  const value2 = Array.isArray(filteredValue2)
    ? filteredValue2.filter((item: any) => item && Object.keys(item).length > 0)
    : filteredValue2

  const isEmpty = (value: any) => {
    if (value === undefined || value === null || value === '') return true
    if (Array.isArray(value) && value.length === 0) return true
    if (typeof value === 'object' && Object.keys(value).length === 0) return true
    return false
  }

  if (isEmpty(value1) && isEmpty(value2)) {
    return true
  }

  if (value1 === undefined || value1 === null) {
    return value2 === undefined || value2 === null
  }

  if (typeof value1 !== typeof value2) {
    return false
  }

  switch (typeof value1) {
    case 'string':
      return value1 === value2

    case 'number':
      return value1 === value2

    case 'boolean':
      return value1 === value2

    case 'object': {
      if (value1 === null || value2 === null) {
        return value1 === value2
      }

      if (Array.isArray(value1) && Array.isArray(value2)) {
        if (value1.length !== value2.length) {
          return false
        }
        if (Array.isArray(value1[0])) {
          return value1.every((subArr1: any, index: number) =>
            compareValues(subArr1, value2[index]),
          )
        }

        if (value1.length > 0 && typeof value1[0] === 'object') {
          const sortedArr1 = [...value1].sort((a, b) => {
            const aKey = Object.values(a)[0]
            const bKey = Object.values(b)[0]
            return String(aKey).localeCompare(String(bKey))
          })

          const sortedArr2 = [...value2].sort((a, b) => {
            const aKey = Object.values(a)[0]
            const bKey = Object.values(b)[0]
            return String(aKey).localeCompare(String(bKey))
          })

          return sortedArr1.every((item1, index) => {
            const item2 = sortedArr2[index]
            const allKeys = new Set([...Object.keys(item1), ...Object.keys(item2)])

            return Array.from(allKeys).every((key) => {
              if (key === '_id') return true

              if (item1[key] === '' && (!item2[key] || item2[key] === '')) {
                return true
              }

              if ((!item1[key] || typeof item1[key] === undefined) && item2[key]) {
                return false
              }
              return compareValues(item1[key], item2[key])
            })
          })
        }

        const sorted1 = [...value1].sort()
        const sorted2 = [...value2].sort()
        return JSON.stringify(sorted1) === JSON.stringify(sorted2)
      }

      const keys1 = Object.keys(value1).filter((key) => key !== '_id')
      const keys2 = Object.keys(value2).filter((key) => key !== '_id')

      if (keys1.length !== keys2.length) {
        return false
      }

      return keys1.every((key) => {
        if (!(key in value2)) {
          return value1[key] === '' || value1[key] === null
        }
        if (value1[key] === '' && (!value2[key] || value2[key] === '')) {
          return true
        }

        return compareValues(value1[key], value2[key])
      })
    }

    default:
      return JSON.stringify(value1) === JSON.stringify(value2)
  }
}

export const transformArrayForBehaviour = (arr: any[]) => {
  if (!arr || arr.length === 0) return []
  return arr?.map((item: any) => {
    const transformedItem: any = {}

    transformedItem.parameterId =
      typeof item.parameterId === 'object' ? item.parameterId._id : item.parameterId
    transformedItem.fieldName = item.fieldName
    transformedItem.value = item.value

    if (item.parameterRef && item.parameterRef.length > 0) {
      transformedItem._id = item._id
      transformedItem.parameterRef = item.parameterRef.map((refGroup: any[]) =>
        refGroup.map((refItem: any) => ({
          parameterId:
            typeof refItem.parameterId === 'object' ? refItem.parameterId._id : refItem.parameterId,
          fieldName: refItem.fieldName,
          value: refItem.value,
          _id: refItem._id,
        })),
      )
    }

    return transformedItem
  })
}

export const getFieldValuesData = (
  pageType: string | undefined,
  prefilledData: any[],
  fieldData: any = {},
) => {
  if (pageType !== CONSTANTS.PAGE_TYPE.EDIT) return fieldData

  if (Object.keys(fieldData).length > 0) return fieldData

  const result: { [key: string]: any } = {}

  prefilledData?.forEach((item) => {
    const { parameterId, value, parameterRef } = item
    if (parameterId?.fieldType?.toLowerCase() !== 'file') {
      if (parameterRef && Array.isArray(parameterRef) && parameterRef.length > 0) {
        parameterRef.forEach((group: any, groupIndex: number) => {
          group.forEach((param: any) => {
            const key = `${parameterId?.fieldName}_${groupIndex + 1}_${param.fieldName}`
            result[key] = param.value
          })
        })
      } else {
        result[parameterId?.fieldName] = value
      }
    }
  })

  return result
}

export const getAssetNodes = (response: any, excludedNode: string[], type?: string) => {
  if (!response?.moduleInfo && !response?.nodes) {
    const nodeResult = []
    for (const key in response) {
      if (!excludedNode.includes(key?.toLowerCase())) {
        if (type === 'assetId') {
          nodeResult.push({
            label: key?.charAt(0)?.toUpperCase() + key.slice(1),
            value: response?.[key],
          })
        } else {
          nodeResult.push(response[key])
        }
      }
    }

    return nodeResult
  }

  return null
}

export const getEmptyStateText = (text: string) => {
  if (!text || text.trim().length === 0) return ''
  return `Please initiate search to add ${text.trim()}.`
}
export const getRadioFilter = (
  radioOptions: IKeyValue[],
  modalSelectedTab: string,
  shouldDisplayRadioFilterOption: boolean,
  currentStep: number,
) => {
  const radioFilter = { value: false, title: '' }
  if (radioOptions.length > 0 && modalSelectedTab && shouldDisplayRadioFilterOption) {
    radioFilter.title = getRadioFilterTitleText(modalSelectedTab)
    radioFilter.value = currentStep === 1
  }
  return radioFilter
}
export const getRadioFilterTitleText = (text: string) => {
  if (!text || text.trim().length === 0) return ''
  return `Please select ${getArticle(text)} ${text
    .trim()
    .toLowerCase()} category to start searching`
}

export const getWidgetDataBasedOnType = (
  layout: string,
  widgetFilterType: keyof WidgetFilterType,
) => {
  const {
    WIDGET_TYPES_LIST,
    SINGLE_ASSET_SELECT,
    WIDGET_TAB_IN_WIDGET_ASSET_MODAL,
    WIDGET_FILTER,
    TABS_IN_ASSET_MODAL,
    CONTAINER_TAB_IN_WIDGET_ASSET_MODAL,
    RADIO_OPTIONS_WITHOUT_GOB,
    ASSET_FILTER,
  } = CONSTANTS
  const widgetModuleData: WidgetFilterType = {
    singleAssetSelect: SINGLE_ASSET_SELECT,
    categoryPageLayout: WIDGET_TYPES_LIST.categoryPageLayout,
    widgetTabList: WIDGET_TAB_IN_WIDGET_ASSET_MODAL,
    containerTabList: CONTAINER_TAB_IN_WIDGET_ASSET_MODAL,
    celebrityLayout: WIDGET_TYPES_LIST.celebrityLayout,
    spotLightLayout: WIDGET_TYPES_LIST.spotlightLayout,
    widgetTabFilter: WIDGET_FILTER,
    assetTabFilter: ASSET_FILTER,
    siKeyMomentsTabView: WIDGET_TYPES_LIST.siKeyMomentsTabView,
    tabLayout: WIDGET_TYPES_LIST.tabLayout,
    tabsInModal: TABS_IN_ASSET_MODAL,
    radioOptionsWithoutGob: RADIO_OPTIONS_WITHOUT_GOB,
    filterBasedLayoutLandscape: WIDGET_TYPES_LIST.filterBasedLayoutLandscape,
    filterBasedLayoutPortrait: WIDGET_TYPES_LIST.filterBasedLayoutPortrait,
    filterBasedLayoutSquare: WIDGET_TYPES_LIST.filterBasedLayoutSquare,
    cardSkinnedVideo: WIDGET_TYPES_LIST.cardSkinnedVideo,
  }

  if (!layout || !widgetFilterType || !widgetModuleData[widgetFilterType]) return false

  const widgetModuleDataValue = widgetModuleData[widgetFilterType]
  if (typeof widgetModuleDataValue === 'string') {
    return layout.trim().toLowerCase() === widgetModuleDataValue.trim().toLowerCase()
  }

  return widgetModuleDataValue.includes(layout.trim().toLowerCase())
}

export const getCheckedValue = (checked?: boolean | 'undefined') => {
  if (!checked) return false
  if (checked === 'undefined') return undefined
  return checked
}

export const getSortTypeValue = (sortType: number, colType: string | number) => {
  const { ASSET_TITLE, ASSET_TYPE } = MODULE_CONSTANTS
  if (sortType && String(colType) === 'title') return ASSET_TITLE
  if (String(colType) === 'type') return ASSET_TYPE
  return colType
}

export const getFilterValues = (
  filterBy: 'layout' | 'type' | 'state',
  filterValue: string | string[],
  filterCondition: 'in' | 'contains' = 'in',
) => {
  return {
    filterBy,
    filterCondition,
    filterValue,
  }
}

export const convertObjectToArray = (obj: any) => {
  if (!obj || typeof obj !== 'object' || Object.keys(obj).length === 0) return []
  return Object.keys(obj).map((key: string) => {
    const title = key.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^./, (str) => str.toUpperCase())
    return {
      title: title,
      url: obj[key],
    }
  })
}

export const findIdInObject = (obj: DataObject): { id: string; module: string } | undefined => {
  if (!obj) return undefined
  const { ASSET, WIDGET, CONTAINER } = MODULE_CONSTANTS
  if (obj.assetId) {
    return { id: obj.assetId, module: ASSET }
  }
  if (obj.widgetId) {
    return { id: obj.widgetId, module: WIDGET }
  }
  if (obj.containerId) {
    return { id: obj.containerId, module: CONTAINER }
  }
  if (obj.siteNavigationId) {
    return { id: obj.siteNavigationId, module: 'siteNavigation' }
  }
  if (obj.contentId) {
    return { id: obj.contentId, module: obj.module }
  }
  return undefined
}

export const buildContentArray = (data: DataObject[]): ResultObject[] => {
  if (!data || data.length === 0) return []
  const results: ResultObject[] = []
  data.forEach((obj, index) => {
    const result = findIdInObject(obj)
    if (result) {
      results.push({
        contentId: `${result.id}`,
        module: result.module,
        position: index + 1,
      })
    }
  })
  return results
}

export const getImageNodeValue = (data: any) => {
  if (!data) return []

  const blitzImagesValue = data?.blitzImages?.value || data?.images?.value
  if (
    !blitzImagesValue ||
    typeof blitzImagesValue !== 'object' ||
    Object.keys(blitzImagesValue).length === 0
  ) {
    return []
  }

  const imagesArray = Array.isArray(data?.images) ? data?.images : []

  const imageNodesWithS3Url = new Set<string>()
  imagesArray.forEach((image: any) => {
    if (image?.s3Url && image?.imageNode) {
      imageNodesWithS3Url.add(image.imageNode)
    }
  })

  return Object.keys(blitzImagesValue).map((key: string) => {
    const title = key.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^./, (str) => str.toUpperCase())
    return {
      title: title,
      url: blitzImagesValue[key],
      highlighter: imageNodesWithS3Url.has(key),
    }
  })
}

export const getWidgetCheckedOrDisabledValue = (
  listToTest: any[],
  dataToMatch: any,
  filterType: string,
  newlySelectedItemData: any[],
  skipBaseAssetFilter?: boolean,
) => {
  if (!listToTest?.length || !dataToMatch || !filterType) return false
  return listToTest?.some((el: any) => {
    if (isSelectedItemBaseAsset(el)) {
      if (skipBaseAssetFilter) return false
      if (!newlySelectedItemData?.length) return false
      return newlySelectedItemData.some(
        (item) => getItemIdValue(item) === dataToMatch[filterType]?.toString(),
      )
    }
    return (
      el[filterType] !== null &&
      dataToMatch[filterType] !== null &&
      getItemIdValue(el) === dataToMatch[filterType]?.toString()
    )
  })
}
export const deepCompareArrays = (arr1: any[], arr2: any[]): boolean => {
  if (!Array.isArray(arr1) || !Array.isArray(arr2)) return false
  if (arr1.length !== arr2.length) return false

  return arr1.every((obj, index) => {
    const obj2 = arr2[index]

    if (typeof obj !== 'object' || typeof obj2 !== 'object') return obj === obj2

    const keys1 = Object.keys(obj)
    const keys2 = Object.keys(obj2)

    if (keys1.length !== keys2.length) return false

    return keys1.every((key) => {
      if (Array.isArray(obj[key]) && Array.isArray(obj2[key])) {
        return deepCompareArrays(obj[key], obj2[key]) // Recursively compare nested arrays
      } else if (typeof obj[key] === 'object' && typeof obj2[key] === 'object') {
        return deepCompareArrays([obj[key]], [obj2[key]]) // Recursively compare nested objects
      } else {
        return obj[key] === obj2[key] // Compare primitive values
      }
    })
  })
}

export const setSessionStorage = (key: string, value: any, route?: string) => {
  if (route) {
    sessionStorage.setItem('route', JSON.stringify(route))
  }
  sessionStorage.setItem(key, JSON.stringify(value))
}

export const getSessionStorage = (key: string) =>
  sessionStorage.getItem(key) ? JSON.parse(sessionStorage.getItem(key) ?? '') : ''

export const removeSessionStorage = (key: string) => {
  sessionStorage.removeItem(key)
}
export const removeLocalFilters = (excludePageData?: boolean) => {
  sessionStorage.removeItem('route')
  sessionStorage.removeItem('pageData')
  sessionStorage.removeItem('localFilters')
  if (!excludePageData) {
    sessionStorage.removeItem('localPageData')
  }
  sessionStorage.removeItem('localSearchFilter')
}

const getURL = (event: any, module: any) => {
  if (module === PageNames.TrayRanking && event?.isChildPageRequired?.toLowerCase() === 'yes') {
    return `/${PAGES_ROUTES.BoltMaster}/${PAGES_ROUTES.TrayRanking}/${PAGES_ROUTES.SegmentedList}/${event._id}`
  }
  if (event?.isChildPageRequired?.toLowerCase() === 'yes') {
    return `/${PAGES_ROUTES.ManageContainer}/${PAGES_ROUTES.ChildContainer}/${event._id}`
  } else {
    return `/${PAGES_ROUTES.ManageContainer}/${PAGES_ROUTES.PageTypeView}/${event._id}`
  }
}

export const getListingRowData = (params: {
  data: any
  columnHeader: any
  pageRoute?: string
  extraParams?: any
  module?: string
}) => {
  const { data, columnHeader, pageRoute, extraParams, module } = params
  const tempData: any = []
  if (columnHeader?.length === 0) return tempData

  data?.forEach((ele: any, index: number) => {
    const row: any = {}

    columnHeader?.forEach((key: any) => {
      const dataId = key?.id
      switch (dataId) {
        case 'engine':
          row[dataId] =
            ele[dataId] === 'NA'
              ? ele[dataId]
              : ele[dataId]?.charAt(0).toUpperCase() + ele[dataId]?.slice(1).toLowerCase()
          break
        case 'createdAt':
        case 'updatedAt':
        case 'lastFeaturedDate':
        case 'featuredDateTime':
        case 'unFeaturedDateTime':
          row[dataId] = getDateInFormat(ele[dataId] ?? '', CONSTANTS.DATE_FORMAT_TIME_SECONDS)
          break
        case 'state':
          row[dataId] = React.createElement(AssetStateLabel, { state: ele.stateDisplayName })
          break
        default:
          row[dataId] = ele[dataId]
          break
      }
    })

    extraParams &&
      extraParams.forEach((param: any) => {
        if (ele[param] !== undefined) {
          row[param] = ele[param]
        }
      })

    if (module === 'container' || module === 'TrayRanking') {
      row.rowURL = getURL(ele, module)
    } else if (module === 'advancedSearch') {
      const path =
        ele?.contentType?.toLowerCase() === 'sitenavigation' ||
        ele?.contentType?.toLowerCase() === 'site-navigation'
          ? `/site-navigation/view/${ele?._id}`
          : `/manage-${ele?.contentType}/view/${ele?._id}`
      row.rowURL = path
    } else {
      row.rowURL = `/${pageRoute}/${PAGES_ROUTES.PageTypeView}/${ele._id}`
    }

    tempData.push(row)
  })
  return tempData
}

export const isEveryItemInListSelected = (
  selectedItemList: any[],
  listData: any[],
  newlySelectedItemList: any[],
) => {
  const selectedItemListIds = new Set(newlySelectedItemList.map((item) => getItemIdValue(item)))

  const allSelectedItemsIdSet = new Set(selectedItemList.map((item) => getItemIdValue(item)))

  return listData.every((item) => {
    const itemIdValue = getItemIdValue(item)
    if (isSelectedItemBaseAsset(item)) return selectedItemListIds.has(itemIdValue)
    return allSelectedItemsIdSet.has(itemIdValue)
  })
}

export const handleSelectAllCheckOrUncheck = (
  selectedItemsLists: any[],
  listData: any[],
  newlySelectedItemList: any[],
  selectAllCheckedPageNumber: {
    [key: string]: Set<number>
  },
  selectedTab: string,
  currentPageNumber: number,
) => {
  let updatedSelectAllPageNumber = { ...selectAllCheckedPageNumber }

  const isCurrentPageSelected = updatedSelectAllPageNumber?.[selectedTab]?.has?.(currentPageNumber)
  if (selectedItemsLists.length < listData.length) {
    if (isCurrentPageSelected) {
      updatedSelectAllPageNumber = handleCurrentPageSelectionTrack(
        updatedSelectAllPageNumber,
        selectedTab,
        currentPageNumber,
        'removed',
      )
    }
  } else {
    if (!isCurrentPageSelected) {
      updatedSelectAllPageNumber = handleCurrentPageSelectionTrack(
        updatedSelectAllPageNumber,
        selectedTab,
        currentPageNumber,
        'added',
      )
    }
  }
  return {
    isSelectAllChecked: isEveryItemInListSelected(
      selectedItemsLists,
      listData,
      newlySelectedItemList,
    ),
    selectedPageNumber: updatedSelectAllPageNumber,
  }
}

export const handleCurrentPageSelectionTrack = (
  selectAllCheckedPageNumber: {
    [key: string]: Set<number>
  },
  selectedTab: string,
  currentPageNumber: number,
  selectionType: counterType = 'removed',
) => {
  if (
    !selectedTab ||
    !selectAllCheckedPageNumber ||
    Object.keys(selectAllCheckedPageNumber).length === 0
  )
    return selectAllCheckedPageNumber

  const selectedTabCheckedPageNumber = selectAllCheckedPageNumber[selectedTab] ?? new Set()

  const updatedSet = new Set(selectedTabCheckedPageNumber)

  if (selectionType === 'removed') {
    updatedSet.delete(currentPageNumber)
  } else {
    updatedSet.add(currentPageNumber)
  }

  return {
    ...selectAllCheckedPageNumber,
    [selectedTab]: updatedSet,
  }
}

export const isItemSelectedOrSaved = (
  list: any[],
  itemIdValue: string | number,
  newlySelectedItemList: any[],
) => {
  if (list.length === 0 || !itemIdValue) return false
  const selectedItemListIds = new Set(
    (newlySelectedItemList || []).map((item) => getItemIdValue(item)),
  )
  return list.some((selectedItem) => {
    if (isSelectedItemBaseAsset(selectedItem)) return selectedItemListIds.has(itemIdValue)
    return getItemIdValue(selectedItem) === itemIdValue.toString()
  })
}
export const mapPositionsToIds = (listDataToCheck: any[]): Map<number, string> => {
  if (listDataToCheck.length === 0) return new Map()

  const sortedList = sortListsBasedOnKey(listDataToCheck, 'position')
  const positionMap = new Map<number, string>()
  sortedList.forEach((item: any) => {
    let { position } = item
    if (!position) return
    while (positionMap.has(position)) {
      position++
    }
    const itemId = getDynamicRowValue(item, 'id')
    if (!itemId) return
    positionMap.set(position, itemId.toString())
  })
  return positionMap
}
export const getItemIdValue = (item: any) => {
  if (!item) return ''
  const itemId = getDynamicRowValue(item, 'id')
  if (typeof itemId === 'object') return itemId?.value ?? ''
  return itemId?.toString() ?? ''
}
export const updateArrayWithMappedPositions = (
  listData: any[],
  mapPositionsToIdsList: any[],
  pinnedItemPositions?: Set<number>,
) => {
  if (!listData.length) return listData

  const itemMappedPositionIds = mapPositionsToIds(mapPositionsToIdsList)

  const idToPosition = new Map([...itemMappedPositionIds].map(([pos, id]) => [id, pos - 1]))

  const minMappedPosition = Math.min(...Array.from(itemMappedPositionIds.keys()))

  const maxPosition = Math.max(...Array.from(itemMappedPositionIds.keys()))

  const totalLength = Math.max(maxPosition, listData.length + (pinnedItemPositions?.size || 0))

  const result = new Array(totalLength).fill(null)

  const PINNED = Symbol('pinned')

  pinnedItemPositions?.forEach((pos) => {
    const index = pos - 1
    if (index >= 0 && index < result.length) {
      result[index] = PINNED
    }
  })

  const remainingItems: any[] = []

  for (const item of listData) {
    const itemId = getItemIdValue(item)

    if (item.position && item.position < minMappedPosition) {
      const index = item.position - 1
      result[index] = item
      continue
    }

    if (itemId && idToPosition.has(itemId)) {
      const mappedIndex = idToPosition.get(itemId)

      if (mappedIndex === undefined) {
        remainingItems.push(item)
        continue
      }

      let desiredIndex = mappedIndex

      while (
        desiredIndex < result.length &&
        (result[desiredIndex] !== null || pinnedItemPositions?.has(desiredIndex + 1))
      ) {
        desiredIndex++
      }

      if (desiredIndex < result.length) {
        result[desiredIndex] = item
        continue
      }
    }

    remainingItems.push(item)
  }
  let remainingIndex = 0

  for (let i = 0; i < result.length; i++) {
    if (result[i] === null) {
      const resultantItem = remainingItems[remainingIndex++]
      if (resultantItem) {
        result[i] = { ...resultantItem, position: i + 1 }
      }
    }
  }

  return result
    .filter((item) => item !== PINNED)
    .filter(Boolean)
    .map((item, index) => ({
      ...item,
      position: index + 1,
    }))
}

export const getUpdatedAccordionColumnHeader = (
  columnList: { id: string; label: string; sort: boolean }[],
  stepNumber: number,
) => {
  if (columnList.length === 0 || stepNumber < 1) return columnList
  const updatedColumnList = [...columnList]
  const keyToAdd: { id: string; label: string; sort: boolean } = {
    id: 'defaultLanguage',
    label: 'Default Language',
    sort: true,
  }

  if (stepNumber === 2) {
    keyToAdd.id = 'pinnedLang'
    keyToAdd.label = 'Pinned Language'
  }

  updatedColumnList.push(keyToAdd)
  return updatedColumnList
}
export const getStepperData = (text: string, type: ModalType, pageModule?: IModuleType) => {
  if (text?.trim()?.length === 0) return []
  const { ADDITIONAL_PARAMETER_TEXT } = MODULE_CONSTANTS
  const prefix = capitalizeFirstLetter(type)
  return [
    { count: 1, value: `${prefix} ${capitalizeFirstLetter(text.trim())}` },
    {
      count: 2,
      value: `${prefix} ${
        pageModule === 'siteNavigation' ? ADDITIONAL_PARAMETER_TEXT : 'Position'
      }`,
    },
  ]
}
export const addAllKeyValueInList = (listToModify: IKeyValue[]) => {
  if (!listToModify || listToModify.length === 0) return []
  const assetCategoryFilterList: IKeyValue[] = [...listToModify]
  assetCategoryFilterList.unshift({ key: 'All', value: 'All' })
  return assetCategoryFilterList
}
export const unlockUser = async (
  data: any,
  module: string,
  contentIdKey: string,
  contentDocIdKey = '_id',
) => {
  try {
    await mainApiService(
      MULTIUSER_LOCKING.UNLOCK_USER({
        contentId: data[contentIdKey],
        module,
        contentDocId: data[contentDocIdKey],
      }),
    )
  } catch (error) {
    console.error('Failed to unlock:', error)
  }
}
export const fetchLayout = async (
  selectedType: string,
  item: 'widget' | 'container' = 'widget',
) => {
  if (!selectedType || selectedType.trim().length === 0) return []
  let resultData: IKeyValue[] = []
  try {
    const requestedData = MASTERS_MANAGEMENT.Layout({
      item,
      list: selectedType === 'All' ? '' : selectedType,
    })
    const result: any = await mainApiService(requestedData)
    resultData = result?.data?.Layouts ?? []
  } catch (error) {
    console.error('Error fetching layout:', error)
    throw error
  }
  return resultData
}
const updateRefConditions = (conditions: any[]) => {
  return conditions.map((condition: any) => {
    const updatedDependentParameters =
      condition?.dependentParameters?.map((dependentParameter: any) => ({
        ...dependentParameter,
        parameterId: dependentParameter?.parameterId?._id || dependentParameter?.parameterId,
      })) || []

    return {
      ...condition,
      dependentParameters: updatedDependentParameters,
    }
  })
}
export const preparePayloadForWidgetDefinitionCondition = (selectedParametersList: any) => {
  const preparedPayload: any = {}
  selectedParametersList &&
    Object.entries(selectedParametersList).forEach(([key, parameters]) => {
      preparedPayload[key] = {
        tabs: (parameters as any).tabs?.map((tab: any) => {
          const updatedParameters = tab.parameters?.map((data: any) => {
            if (data?.conditions?.length > 0) {
              const filteredConditions = data.conditions.filter((condition: any) => {
                return (
                  condition?.parameterValue !== null &&
                  condition?.parameterValue !== undefined &&
                  condition?.parameterValue !== ''
                )
              })

              const updatedConditions = filteredConditions.map((condition: any) => {
                const updatedDependentParameters =
                  condition?.dependentParameters?.map((dependentParameter: any) => {
                    return {
                      ...dependentParameter,
                      parameterId:
                        dependentParameter?.parameterId?._id || dependentParameter?.parameterId,
                    }
                  }) || []
                return {
                  ...condition,
                  dependentParameters: updatedDependentParameters,
                }
              })
              return {
                ...data,
                conditions: updatedConditions,
              }
            }

            if (data?.parameterRef?.length) {
              const updatedParameterRef = data.parameterRef?.map((ref: any) => {
                if (ref?.conditions?.length) {
                  const filteredRefConditions = ref.conditions.filter((condition: any) => {
                    return (
                      condition?.parameterValue !== null &&
                      condition?.parameterValue !== undefined &&
                      condition?.parameterValue !== ''
                    )
                  })

                  const updatedConditions = updateRefConditions(filteredRefConditions)
                  return {
                    ...ref,
                    conditions: updatedConditions,
                  }
                }
                return ref
              })

              return {
                ...data,
                parameterRef: updatedParameterRef,
              }
            }

            return data
          })

          const filteredParameters = updatedParameters.filter((param: any) => {
            const hasMatchingParameterRef = updatedParameters.some((otherParam: any) => {
              if (otherParam?.parameterRef?.length) {
                return otherParam.parameterRef.some((ref: any) => {
                  const refId = ref?.parameterRepositoryId
                  const paramId = param?.parameterRepositoryId
                  return refId === paramId
                })
              }
              return false
            })

            return !hasMatchingParameterRef
          })

          return { ...tab, parameters: filteredParameters }
        }),
      }
    })
  return preparedPayload
}
export const dynamicFieldFilterPreviouslySelectedOptions = (
  options: any[],
  name: string,
  formValues: any,
) => {
  const nameParts = name.split('.')
  if (nameParts.length > 2) {
    const [arrayName, arrayIndex, fieldName] = nameParts
    const currentFormArray = formValues[arrayName]
    if (!Array.isArray(currentFormArray)) return options
    const currentIndex = parseInt(arrayIndex, 10)
    const selectedValues = currentFormArray
      .filter((_, index) => index !== currentIndex)
      .map((item) => item[fieldName])
      .filter(Boolean)

    const updatedOptions = options?.map((data) => ({
      ...data,
      disabled: selectedValues?.includes(data.key),
    }))

    return updatedOptions
  } else {
    return options
  }
}
export const getContainerTypeList = async (dispatch: Dispatch) => {
  dispatch(setLoader(true))
  const requestedData: any = CONTAINER_MANAGEMENT_CRUD.TYPES()
  const result: any = await mainApiService(requestedData)
  let containerTypeList: IKeyValue[] = []
  if (result?.responseCode === 200 && result?.data?.records?.length > 0) {
    const list = result?.data?.records.map((type: string) => {
      return {
        key: type,
        value: type,
      }
    })
    containerTypeList = [{ key: 'All', value: 'All' }, ...list]
  }
  dispatch(setLoader(false))
  return containerTypeList
}
export const getWidgetTypeList = async (dispatch: Dispatch) => {
  dispatch(setLoader(true))
  const assetTypesData: any = await dispatch(assetTypes('') as any)
  let widgetTypeList: IKeyValue[] = []
  if (assetTypesData && assetTypesData?.payload?.data?.records?.length > 0) {
    let list: any[] = assetTypesData?.payload.data.records
    list = (list as [])?.map((type: any) => {
      return {
        key: type,
        value: type,
      }
    })
    widgetTypeList = [{ key: 'All', value: 'All' }, ...list]
  }
  dispatch(setLoader(false))
  return widgetTypeList
}
export const handleConfigKey = (key: string) => {
  if (!key || key.trim().length === 0) return ''
  const { ASSET, ASSET_CONFIG, CONTAINER, CONTAINER_CONFIG, WIDGET, WIDGET_CONFIG } =
    MODULE_CONSTANTS
  if (key === ASSET) return ASSET_CONFIG
  if (key === CONTAINER) return CONTAINER_CONFIG
  if (key === WIDGET) return WIDGET_CONFIG
  return ''
}
export const commaSeparatedArrOfString = (str: any) => {
  if (!str || str.trim().length === 0) return []
  const arr = str.split(',')
  return arr.map((item: string) => item.trim()).filter((item: string) => item.length > 0)
}
export const reorderItemOnDrag = (
  source: any,
  destination: any,
  listData: any[],
  pinnedItemPositions?: Set<number>,
) => {
  if (!source || !destination) return []
  const sourceIndex = source?.index - 1
  const destinationIndex = destination?.index - 1

  const copyDataListData: [] = listData?.length > 0 && JSON.parse(JSON.stringify(listData))
  if (isValidArray(listData)) {
    const element = copyDataListData?.slice(sourceIndex, sourceIndex + 1)[0]
    copyDataListData.splice(sourceIndex, 1)
    copyDataListData.splice(destinationIndex, 0, element)
  }
  return pinnedItemPositions
    ? syncUnpinnedItemPositions(copyDataListData, pinnedItemPositions)
    : copyDataListData
}
export const reorderListingColumnOnDrag = (
  result: any,
  selectedParameter: any[],
  setSelectedParameter: ReactDispatch<SetStateAction<any[]>>,
) => {
  if (!result.destination || !selectedParameter || !Array.isArray(selectedParameter)) return
  const items = Array.from(selectedParameter)
  const [reorderedItem] = items.splice(result.source.index, 1)
  items.splice(result.destination.index, 0, reorderedItem)
  items.forEach((item, index) => {
    item.sequence = index + 1
  })

  setSelectedParameter(items)
}
export const checkIsFieldValueValid = (value: any) => {
  if (
    !value ||
    (Array.isArray(value) && value.length === 0) ||
    (isValidObject(value) && Object.keys(value).length === 0)
  )
    return false

  return true
}
export const isInnerFieldValid = (data: any[], key: string[]) => {
  if (!Array.isArray(data)) return []
  let result = true
  key?.forEach((item) => {
    result = data?.some((ele: any) => checkIsFieldValueValid(ele[item]))
  })
  return result
}

export const setFilterValues = (
  filters: any,
  setContentId: any,
  setSelectedValue: any,
  setSelectedLayoutValue: any,
  setSelectedStateValue: any,
  setValue: any,
  disabledFields?: (selectedType: string) => void,
) => {
  filters?.forEach((filter: any) => {
    switch (filter?.filterBy) {
      case 'contentId':
        setContentId(filter?.filterValue)
        setValue('contentId', filter?.filterValue)
        break
      case 'subType':
        setSelectedValue(filter?.filterValue)
        setValue('subType', filter?.filterValue)
        disabledFields?.(filter?.filterValue)
        break
      case 'layout':
        setSelectedLayoutValue(filter?.filterValue)
        setValue('layout', filter?.filterValue)
        break
      case 'state':
        setSelectedStateValue(filter?.filterValue)
        setValue('state', filter?.filterValue)
        break
    }
  })
}

export const setFiltersForContentStatus = (
  setContentId: any,
  setSelectedValue: any,
  setSelectedLayoutValue: any,
  setValue: any,
  setFromDateTime: any,
  setToDateTime: any,
  localFilters: any,
  typeList?: any,
) => {
  const filters = localFilters ? JSON.parse(localFilters) : null
  if (filters) {
    Object.entries(filters).forEach(([key, value]: any) => {
      switch (key) {
        case 'filters':
          value?.forEach((filter: any) => {
            switch (filter?.filterBy) {
              case 'contentId':
                setContentId(filter?.filterValue)
                setValue('contentId', filter?.filterValue)
                break
              case 'type':
                if (typeList && typeList.length > 0) {
                  const selectedValues: any = typeList.filter((type: any) =>
                    filter?.filterValue?.includes(type?.value),
                  )
                  setSelectedValue(selectedValues)
                  setValue('subType', selectedValues)
                }
                break
              case 'layout':
                setSelectedLayoutValue(filter.filterValue)
                setValue('layout', filter.filterValue)
                break
            }
          })
          break
        case 'fromDate':
          setFromDateTime(value ? new Date(value as string) : null)
          break
        case 'toDate':
          setToDateTime(value ? new Date(value as string) : null)
          break
      }
    })
  }
  return filters
}

export const handleMarkAsDoneOnView = async (data: any, selectedCategory: any, dispatch: any) => {
  const payload = {
    id: data?._id,
    parameterCategory: selectedCategory,
  }

  const requestedData: any = WIDGET_MANAGEMENT_CRUD.MARK_AS_DONE(payload)
  const markAsDoneResult = await handleMarkAsDoneButton(dispatch, requestedData)
  dispatch(getWidgetDetailById(data?._id) as any)
  dispatch(showAlert([true, markAsDoneResult.message, 'success']))
}
export const getArticle = (itemType: string) => {
  if (!itemType || itemType.trim().length === 0) return ''
  return ['a', 'e', 'i', 'o', 'u'].includes(itemType.trim()[0].toLowerCase()) ? 'an' : 'a'
}
export const updateSelectedAccordionHeading = (text: string, length: number) => {
  if (!text || text.trim().length === 0 || !length) return ''
  return `Selected ${text.trim()} (${length})`
}

export const checkDateTimeError = (
  startDate: Date | null,
  endDate: Date | null,
  setError: any,
  clearErrors: any,
) => {
  const currentDate = new Date()
  clearErrors('EndDate')
  clearErrors('StartDate')

  if (startDate && startDate > currentDate) {
    setError('StartDate', { type: 'manual', message: 'From date cannot be the future date' })
  } else if (endDate && endDate > currentDate) {
    setError('EndDate', { type: 'manual', message: 'To date cannot be the future date' })
  } else if (startDate && endDate && startDate > endDate) {
    setError('EndDate', {
      type: 'manual',
      message: 'To date should not be earlier than From date',
    })
  }
}

export const fetchItemTypes = async (item: string) => {
  const requestedData = ADVANCE_SEARCH.LIST({ item })

  try {
    const result: any = await mainApiService(requestedData)
    return result?.data?.Types || []
  } catch (error) {
    console.error('Error fetching item types:', error)
  }
}

export const getItemModule = (item: any) => {
  if (!item || typeof item !== 'object' || Object.keys(item).length === 0) return

  const { ASSET, WIDGET, CONTAINER } = MODULE_CONSTANTS
  const itemIdValue = getKeyByType(item, 'id')
  if (item?.module === ASSET || itemIdValue.includes(ASSET)) return ASSET
  if (item?.module === WIDGET || itemIdValue.includes(WIDGET)) return WIDGET
  return CONTAINER
}
export const getUpdatedItemDetailList = (
  replaceAndEditItemDetail: IReplaceAndEditItemData,
  existingItemList: any[],
  updatedDetailList: any[],
  pinnedItemPositions?: Set<number>,
) => {
  if (!updatedDetailList || !Array.isArray(updatedDetailList) || !updatedDetailList.length)
    return []

  if (replaceAndEditItemDetail.id?.toString()?.trim()?.length)
    return updateItemPositionsInList(
      replaceAndEditItemDetail,
      existingItemList,
      updatedDetailList,
      pinnedItemPositions,
    )
  return updateArrayWithMappedPositions(
    [...existingItemList, ...updatedDetailList],
    updatedDetailList ?? [],
    pinnedItemPositions,
  )
}
export const updateItemPositionsInList = (
  replaceAndEditItemDetail: IReplaceAndEditItemData,
  existingItemList: any[],
  editItemDetail: { [key: string]: any }[] = [],
  pinnedItemPositions?: Set<number>,
) => {
  if (
    !replaceAndEditItemDetail.id ||
    !existingItemList?.length ||
    !Array.isArray(editItemDetail) ||
    !editItemDetail.length
  ) {
    return []
  }

  const updatedItemListData = [...existingItemList]

  const getUnpinnedIndex = (globalPosition: number) => {
    if (!pinnedItemPositions?.size) return globalPosition - 1

    let pinnedBefore = 0
    pinnedItemPositions.forEach((position) => {
      if (position < globalPosition) pinnedBefore++
    })

    return globalPosition - pinnedBefore - 1
  }

  const removeIndex = getUnpinnedIndex(replaceAndEditItemDetail.position)
  updatedItemListData.splice(removeIndex, 1)

  let insertPosition = editItemDetail[0].position
  if (pinnedItemPositions?.size) {
    while (pinnedItemPositions.has(insertPosition)) insertPosition++
  }

  const insertIndex = getUnpinnedIndex(insertPosition)
  updatedItemListData.splice(insertIndex, 0, editItemDetail[0])
  return updatedItemListData.map((item, index) => ({
    ...item,
    position: index + 1,
  }))
}

export const getExistingBaseSelectedIds = (existingItemList: any[]) => {
  if (!existingItemList || existingItemList.length === 0) return new Set<string>()
  const { ASSET } = MODULE_CONSTANTS
  return new Set(
    existingItemList
      .filter((item) => item?.module === ASSET && item?.variantType?.trim()?.length > 0)
      .map((item) => getItemIdValue(item)),
  )
}
export const getErrorIds = (existingItemList: any[], result: any) => {
  if (!Array.isArray(existingItemList) || existingItemList.length === 0) return []
  if (!Array.isArray(result) || result.length === 0) return []

  const baseSelectedIds = getExistingBaseSelectedIds(existingItemList)

  return result
    .filter((item: any) => baseSelectedIds.has(item?.contentId))
    .map((item: any) => item?.baseContentId?.toString())
}
export const getPositionErrorIds = (existingItemList: any[], result: any) => {
  if (!Array.isArray(existingItemList) || existingItemList.length === 0) return []
  if (!Array.isArray(result) || result.length === 0) return []

  const baseSelectedPositions = new Set(existingItemList.map((item) => item?.position))

  return result
    .filter((item: any) => baseSelectedPositions.has(item?.position))
    .map((item: any) => (item?.baseContentId || item?.contentId)?.toString())
}
export const sortListsBasedOnKey = (lists: any[], key: string) => {
  if (lists.length === 0) return []
  return lists.sort((firstItem, secondItem) => firstItem?.[key] - secondItem?.[key])
}
export const reorderPinnedItem = (
  existingItemList: any[],
  updatedDetailList: any[],
  replaceAndEditItemData?: IReplaceAndEditItemData,
) => {
  if (replaceAndEditItemData && replaceAndEditItemData.type !== 'add') {
    const oldItemList = [...existingItemList]
    const indexToUpdate = oldItemList.findIndex(
      (item) => item?.position === replaceAndEditItemData.position,
    )
    if (indexToUpdate === -1) return oldItemList
    oldItemList.splice(indexToUpdate, 1, updatedDetailList[0])
    return replaceAndEditItemData.type === 'edit'
      ? sortListsBasedOnKey(oldItemList, 'position')
      : oldItemList
  }
  return sortListsBasedOnKey([...existingItemList, ...updatedDetailList], 'position')
}
export const itemModalConfirmHandler = async ({
  dispatch,
  selectedItemListData,
  newlySelectedItems,
  replaceAndEditItemData,
  additionalParameterItemId,
  modalType,
  setBaseErrorIds,
  setBaseErrorIdsType,
  pinnedItemPositions,
}: ManageWidgetConfirmHandler) => {
  if (additionalParameterItemId?.trim()?.length) return []
  const modifiedPayload: { contents: any[] } = { contents: [] }
  modifiedPayload.contents = getModifiedData(newlySelectedItems)
  const requestedData = WIDGET_MANAGEMENT_CRUD.CONTENT_METADATA(modifiedPayload)
  const result: any = await mainApiService(requestedData)
  let finalResult: any[] = []
  if (result?.responseCode === 200 && result?.data?.records) {
    if (
      replaceAndEditItemData.type !== 'edit' ||
      (replaceAndEditItemData.type === 'edit' && isSelectedItemBaseAsset(newlySelectedItems[0]))
    ) {
      let errorIds: any[] = getErrorIds(selectedItemListData, result?.data?.records)
      if (errorIds.length > 0) setBaseErrorIdsType?.('duplicate')
      if (errorIds.length === 0 && modalType === 'pin' && replaceAndEditItemData.type === 'add') {
        errorIds = getPositionErrorIds(selectedItemListData, result?.data?.records)
        if (errorIds.length > 0) setBaseErrorIdsType?.('position')
      }
      if (errorIds.length === 0) setBaseErrorIdsType?.('')
      setBaseErrorIds?.(errorIds)

      if (errorIds.length > 0) return false
    }

    const reorderedItemsList =
      modalType === 'pin'
        ? reorderPinnedItem(selectedItemListData, result.data.records, replaceAndEditItemData)
        : getUpdatedItemDetailList(
            replaceAndEditItemData,
            selectedItemListData,
            result.data.records,
            pinnedItemPositions ?? new Set<number>(),
          )
    finalResult =
      pinnedItemPositions && pinnedItemPositions.size !== 0
        ? syncUnpinnedItemPositions(reorderedItemsList, pinnedItemPositions)
        : reorderedItemsList
  } else {
    dispatch(showAlert([true, combineErrorMessage(result), 'error']))
  }
  return finalResult
}
export const getIdsOfNewlyAddedItems = (newlySelectedItemList: any[], setList: Set<string>) => {
  if (!newlySelectedItemList || newlySelectedItemList.length === 0) return new Set<string>()

  const ids = new Set<string>(setList)
  newlySelectedItemList.forEach((item) => {
    const itemId = getDynamicRowValue(item, 'id')
    if (itemId) ids.add(itemId.toString())
  })
  return ids
}
export const checkIfItemIsSelected = (listData: any[], itemIdToMatch: string | number) => {
  if (!listData || listData.length === 0 || !itemIdToMatch) return false

  return listData.find((selectedItem: any) => {
    const selectedItemIdKey = getKeyByType(selectedItem, 'id')
    return (
      (selectedItem?.[selectedItemIdKey]?.value?.toString() ??
        selectedItem?.[selectedItemIdKey]?.toString()) === itemIdToMatch?.toString()
    )
  })
}

export const addOriginalUrlToChildren = (data: any[]) => {
  if (!Array.isArray(data)) return []
  return data.map((item) => {
    const newItem = {
      ...item,
      originalUrl: item?.url_key,
      url: `/${PAGES_ROUTES.BoltMaster}/${PAGES_ROUTES.Masters}/${item?.url_key}`,
    }

    if (Array.isArray(item?.child) && item?.child?.length > 0) {
      newItem.child = addOriginalUrlToChildren(item.child)
    }

    return newItem
  })
}

export const getAllOriginalUrls = (data: any[]): string[] => {
  if (!Array.isArray(data)) return []

  const urls: string[] = []

  const extractUrls = (items: any[]) => {
    items?.forEach((item) => {
      if (item?.originalUrl) {
        urls.push(item.originalUrl)
      }
      if (Array.isArray(item?.child) && item?.child.length > 0) {
        extractUrls(item.child)
      }
    })
  }

  extractUrls(data)
  return urls
}

export const getCountryDataFormSegmentMaster = async () => {
  const countryData = COUNTRIES_CRUD.LIST_COUNTRY('sortBy=value&sortType=1')
  const countryResult: any = await mainApiService(countryData)
  const tempData: any = []
  if (countryResult?.responseCode === 200) {
    countryResult?.data?.records?.forEach((ele: any) => {
      tempData.push({
        value: ele?._id,
        label: ele?.value,
        key: ele?.key,
      })
    })
  }
  return tempData
}

export const getPackFamily = async () => {
  const requestedData: any = MASTERS_MANAGEMENT.SEGMENT_MASTER.LIST(
    'pack-family',
    'sortBy=value&sortType=1',
  )
  const packFamilyData: any = await mainApiService(requestedData)
  const tempData: any = []
  if (packFamilyData?.responseCode === 200) {
    packFamilyData?.data?.records?.forEach((ele: any) => {
      tempData.push({
        value: ele?._id,
        label: ele?.value,
        key: ele?.key,
      })
    })
  }
  return tempData
}
export const formatParameterData = (input: any[]) => {
  if (!Array.isArray(input)) return []

  return input.map((item) => {
    if (Array.isArray(item.parameterRef) && item.parameterRef.length > 0) {
      const formattedRef = item.parameterRef.map((ref: any) => ({
        ...ref,
        fieldName: ref?.parameter?.fieldName || '',
        setValue: undefined,
      }))
      return {
        ...item,
        parameterRef: [formattedRef],
      }
    }
    return {
      ...item,
      setValue: undefined,
    }
  })
}

export const setLayoutsForBulkForm = (
  selectedLayouts: any,
  layouts: any,
  setSelectedLayouts: any,
) => {
  const oldSelectedLayouts = [...selectedLayouts]

  if (Array.isArray(selectedLayouts)) {
    if (selectedLayouts.every((item: any) => typeof item === 'string')) {
      Array.isArray(layouts) &&
        setSelectedLayouts(layouts?.filter((obj: any) => selectedLayouts.includes(obj?.key)))
    } else if (
      selectedLayouts.every(
        (item) => typeof item === 'object' && item !== null && !Array.isArray(item),
      )
    ) {
      const updatedLayout = oldSelectedLayouts.filter((selectedLayout: IKeyValue) =>
        layouts.some((layout: IKeyValue) => layout.key === selectedLayout?.key),
      )
      setSelectedLayouts(updatedLayout)
    }
  }
}

export const fetchLayoutForBulkOperation = async (
  selectedTypes: any[],
  value: any,
  setLayouts: any,
) => {
  const itemKey = value
  if (selectedTypes?.length > 0) {
    try {
      const layoutPromises = selectedTypes.map(async (type) => {
        const requestedData = ADVANCE_SEARCH.Layout({
          item: itemKey,
          list: type?.key,
        })
        const result: any = await mainApiService(requestedData)
        return result.data?.Layouts || []
      })
      const layoutsArray = await Promise.all(layoutPromises)
      const mergedLayouts = [...new Set(layoutsArray.flat())]
      setLayouts(mergedLayouts)
    } catch (error) {
      console.error('Error fetching layouts:', error)
    }
  } else {
    try {
      const requestedData = ADVANCE_SEARCH.Layout({
        item: itemKey,
        list: '',
      })
      const result: any = await mainApiService(requestedData)
      const layouts = result?.data?.Layouts || []
      setLayouts(layouts)
    } catch (error) {
      console.error('Error fetching layouts:', error)
    }
  }
}

export const createPayloadForSearch = (
  getValues: any,
  selectedFromDateTime: any,
  selectedToDateTime: any,
  selectedState: any,
  selectedTypes: any,
  selectedLayouts: any,
) => {
  const payload: any = {}
  if (getValues('item')) payload.item = getValues('item')
  if (getValues('title')) payload.title = getValues('title')
  if (selectedFromDateTime) payload.fromDate = selectedFromDateTime
  if (selectedToDateTime) payload.toDate = selectedToDateTime
  payload.page = 1
  payload.limit = 10
  const filters = []
  if (getValues('id')) {
    filters.push({
      filterBy: 'contentId',
      filterCondition: 'in',
      filterValue: commaSeparatedArrOfString(getValues('id')),
    })
  }
  if (selectedState) {
    filters.push({
      filterBy: 'state',
      filterCondition: 'in',
      filterValue: commaSeparatedArrOfString(selectedState),
    })
  }
  if (selectedTypes.length > 0) {
    filters.push({
      filterBy: 'type',
      filterCondition: 'in',
      filterValue: selectedTypes.map((type: any) => type?.key),
    })
  }

  if (selectedLayouts.length > 0) {
    filters.push({
      filterBy: 'layout',
      filterCondition: 'in',
      filterValue: selectedLayouts.map((layout: any) => layout?.key),
    })
  }
  payload.filters = filters.length > 0 ? filters : []
  return payload
}

export const getFieldTitleValues = (data: any, prefilledData: any) => {
  if (!data || !prefilledData) return []

  const fieldsToShow: any[] = []
  data?.forEach((item: any) => {
    fieldsToShow.push(
      getDefaultFieldTitleValues(item?.parameter, item?.parameterRef, item?.required),
    )
    fieldsToShow.push(...getConditionalFieldValues(item, prefilledData))
  })

  return fieldsToShow
}
export const getUpdatedFormFieldValues = (
  formField: { [key: string]: IFieldTitleValue[] },
  prefilledData: any[],
) => {
  if (
    !formField ||
    !prefilledData ||
    Object.keys(formField).length === 0 ||
    prefilledData.length === 0
  )
    return

  const updatedFormFields: { [key: string]: IFieldTitleValue[] } = { ...formField }
  for (const key in formField) {
    const parameterTabData = formField[key]
    parameterTabData?.forEach((item: any) => {
      const itemUpdatedValue = findPrefilledValue(prefilledData, item?.fieldName)
      if (itemUpdatedValue) {
        let preFilledValue = itemUpdatedValue?.value
        if (itemUpdatedValue?.parameterId?.fieldType?.toLowerCase() === 'file') {
          preFilledValue = itemUpdatedValue?.image?.s3Url
        }
        item.value = getFieldValues(preFilledValue, itemUpdatedValue?.parameterId?.fieldType)
        item.setValue = preFilledValue || undefined
        if (itemUpdatedValue?.parameterRef?.length > 0) {
          item.parameterRef = itemUpdatedValue.parameterRef.map((refItemArray: any[]) => {
            return refItemArray.map((refItem: any) => {
              const matchingItem = item.parameterRef?.find(
                (param: any) => param.parameter._id === refItem.parameterId._id,
              )
              if (matchingItem?.required) {
                return {
                  ...refItem,
                  setValue: refItem?.value || undefined,
                  required: matchingItem?.required,
                }
              }
              return refItem
            })
          })
        }
      }
    })
  }

  return updatedFormFields
}

export const disableButtonBasedOnRole = (path: string) => {
  for (let i = 0; i < DrawerData?.length; i++) {
    if (DrawerData[i].path.includes(path)) {
      const moduleAccess = checkModuleAccess(DrawerData[i]?.role)
      if (!moduleAccess.canWrite) {
        return true
      }
    }
  }
}

export const checkRolePermissionOnLinkClick = (event: any, role: any, navigate: any) => {
  const moduleAccess = checkModuleAccess(role)
  if (!moduleAccess.canRead && !moduleAccess.canWrite) {
    event.preventDefault()
    navigate(`${PAGES_ROUTES.AccessDenied}`)
  }
}

export const getRoleByURL = (url: string) => {
  if (!url || url.trim().length === 0) return ''
  const matchedRole = DrawerData?.find((item) => item.path.includes(url))
  if (matchedRole) {
    return matchedRole.role
  }
  return ''
}

export const handlePieClick = (
  event: any,
  item: any,
  navigate: any,
  chartData: any,
  selectedItem: any,
) => {
  const state = chartData[item.dataIndex].stateName
  const routeMap: Record<string, string> = {
    container: PAGES_ROUTES.ManageContainer,
    widget: PAGES_ROUTES.ManageWidget,
    sitenavigation: PAGES_ROUTES.SiteNavigation,
  }

  if (selectedItem && routeMap[selectedItem]) {
    const role = getRoleByURL(routeMap[selectedItem])
    navigate(`/${routeMap[selectedItem]}?state=${encodeURIComponent(state)}`)
    checkRolePermissionOnLinkClick(event, role, navigate)
  }
}
export const getSelectedItemDetailForEdit = (
  detail: {
    nodes: { label: string; value: string }[]
    supportedAudioLanguages: IPinnedLang[]
    pinnedLang: IPinnedLang[]
    variantType: string
    position: number
    isBaseAsset: boolean | string
  },
  keysToCheck: { id: string }[],
  position: number,
) => {
  if (!keysToCheck.length) return {}
  const { nodes, pinnedLang, supportedAudioLanguages, isBaseAsset } = detail
  const resultantValue: Record<string, any> = {
    pinnedLang,
    supportedAudioLanguages,
    position,
    isBaseAsset,
  }
  for (const key of keysToCheck) {
    const id = key.id

    if (Object.hasOwn(detail, id)) {
      resultantValue[id] = (detail as unknown as any)[id]
    } else {
      const filteredValue = nodes?.find(
        (item: { label: string; value: string | number }) => toCamelCase(item.label) === id,
      )
      if (filteredValue) resultantValue[id] = filteredValue.value
    }
  }
  return resultantValue
}

export const fetchCategory = async () => {
  let category: any = []
  const requestedData = SYSTEM_CONFIG_APIS.LIST_MASTERS('PLATFORM_CATEGORY')
  const result: any = await mainApiService(requestedData)
  if (result?.responseCode === 200) {
    category = result?.data?.map((item: any) => {
      return {
        value: item?.key,
        label: item?.value,
      }
    })
  }
  return category
}
export const getTransformedChildData = (data: any) => {
  if (!Array.isArray(data)) return data
  const updatedData: any = {
    childContentId: data[0]?.childContentId,
    childContentMongoId: data[0]?.childContentMongoId,
    childData: transformItemResponse(data[0]),
  }
  return updatedData
}
export const transformItemResponse = (response: any) => {
  const nodes: any[] = response?.moduleInfo || response?.nodes || []
  const images: any[] = getImageNodeValue(response)
  const title = response?.title || ''
  const id = response?.[getKeyByType(response, 'id')]
  const module = response?.module || ''
  const itemType = response?.itemType || ''
  const isDefault = !!response?.isDefault
  const supportedAudioLanguages = response?.supportedAudioLanguages || []
  const pinnedLang = response?.pinnedLang || []
  const variantType = response?.variantType || 'NA'
  const state = response?.state
  const isBaseAsset = response?.isBaseAsset
  const position = response?.position
  const isScheduled = response?.isScheduled
  const availableFrom = response?.availableFrom
  const availableTo = response?.availableTo
  const childContentInfo = response?.childContentInfo
    ? getTransformedChildData(response?.childContentInfo)
    : {}
  const isPinned = response?.isPinned

  const result: any = {
    nodes,
    images,
    id,
    isDefault,
    title,
    module,
    supportedAudioLanguages,
    pinnedLang,
    variantType,
    state,
    isBaseAsset,
    childContentInfo,
    position,
    itemType,
    isPinned,
  }

  if (isScheduled) result.isScheduled = isScheduled
  if (availableFrom) result.availableFrom = availableFrom
  if (availableTo) result.availableTo = availableTo
  return result
}
export const getItemListColumn = (tabToCheck: string) => {
  const {
    WIDGET_MODAL_TABLE,
    CONTAINER_MODAL_TABLE_FOR_SPOTLIGHT,
    CONTAINER_MODAL_COLUMNS,
    SITE_NAVIGATION_MODAL_LISTING_COLUMNS,
  } = CONSTANTS
  const { ASSET, WIDGET, CONTAINER, CHILD_MODAL } = MODULE_CONSTANTS

  const columnsMap: { [key: string]: any[] } = {
    [ASSET]: WIDGET_MODAL_TABLE,
    [WIDGET]: CONTAINER_MODAL_TABLE_FOR_SPOTLIGHT,
    [CONTAINER]: CONTAINER_MODAL_COLUMNS,
    [CHILD_MODAL]: SITE_NAVIGATION_MODAL_LISTING_COLUMNS,
  }

  return columnsMap[tabToCheck] || []
}
export const getAccordionTableHeader = (moduleTypeText?: string) => {
  const { ASSET, WIDGET, CONTAINER } = MODULE_CONSTANTS
  const {
    SELECTED_ASSET_MODAL_TABLE,
    SELECTED_WIDGET_MODAL_LIST,
    SITE_NAVIGATION_SELECTED_ITEM_CONTAINER_MODAL_TABLE,
    SELECTED_WIDGET_MODAL_TABLE_FOR_SPOTLIGHT,
  } = CONSTANTS

  const titleText = moduleTypeText?.toLowerCase()
  if (titleText === ASSET) return SELECTED_ASSET_MODAL_TABLE
  if (titleText === WIDGET) return SELECTED_WIDGET_MODAL_LIST
  if (titleText === CONTAINER) return SITE_NAVIGATION_SELECTED_ITEM_CONTAINER_MODAL_TABLE
  return SELECTED_WIDGET_MODAL_TABLE_FOR_SPOTLIGHT
}
export const getUpdatedAccordionTableHeader = (moduleType: string, currentStep: number) => {
  const { WIDGET, CONTAINER } = MODULE_CONSTANTS
  if (moduleType.toLowerCase() === WIDGET || moduleType.toLowerCase() === CONTAINER)
    return getAccordionTableHeader(moduleType)
  return getUpdatedAccordionColumnHeader(getAccordionTableHeader(moduleType), currentStep)
}
export const callGetList = (
  search: string,
  sorttype: number,
  coltype: string | number,
  filterValue: any,
  pagenumber: number,
  pagecount: number,
  lastSearchedText: string,
  modalSelectedTab: string,
  selectedRadioOption: string,
) => {
  const { ASSET, TITLE } = MODULE_CONSTANTS
  let getListOptions: any = {
    searchText: search || lastSearchedText,
    sortType: sorttype || -1,
    page: pagenumber,
    limit: pagecount,
  }

  if (modalSelectedTab?.toLowerCase() === ASSET) {
    getListOptions = {
      ...getListOptions,
      assetCategory: selectedRadioOption,
      sortBy: getSortTypeValue(sorttype, coltype),
      sortType: sorttype,
    }
  } else {
    getListOptions = {
      sortBy: sorttype && String(coltype) === 'title' ? TITLE : coltype,
      typefilters: [],
      filters: filterValue,
      ...getListOptions,
    }
  }

  return getListOptions
}
export const getFilteredValues = (layout: string) => {
  const { FOOTER_TITLE, SUB_FOOTER_TITLE } = MODULE_CONSTANTS
  if (layout === 'L1') return ['L2']
  if (layout === 'L2') return ['L3']
  if (layout === FOOTER_TITLE) return [SUB_FOOTER_TITLE]
  return []
}
export const getItemList = async ({
  options,
  modalSelectedTab,
  selectedRadioOption,
  dispatch,
  definitionInfo,
  keyToCheckInDefinition,
  shouldDisplayRadioFilterOption,
  selectedFilterValues,
  checkedState,
  selectedItemListData,
  newlySelectedWidgetData,
  replaceAndEditItemData,
  onSelectChange,
  isItemSingleSelect,
  selectAllProps,
  isChildModalOpened,
  setDisabledList,
  selectedAssetTypes,
  pinnedItemsList,
}: GetItemsList) => {
  const { ASSET, CONTAINER, TYPE_FILTERS } = MODULE_CONSTANTS
  const { ASSET_STATUS, DATE_TIME_FORMAT, DATE_TIME_FORMAT_SECONDS } = CONSTANTS
  const { FEATURED, SCHEDULE_TO_FEATURE } = ASSET_STATUS

  let selectAllPropsValue = {}
  let result
  const tab = modalSelectedTab?.toLowerCase()
  if (tab === ASSET) {
    const payloadData = {
      ...(options?.sortBy !== '' ? { sortBy: options.sortBy } : {}),
      ...(selectedAssetTypes && selectedAssetTypes.length > 0
        ? { assetTypes: selectedAssetTypes.map((assetType) => assetType.key).join(', ') }
        : {}),
      limit: options?.limit || 10,
      page: options.page || 1,
      searchText: commaSeparatedArrOfString(options.searchText),
      sortType: options.sortType || -1,
      assetCategory: selectedRadioOption,
    }
    result = await dispatch(assetList(payloadData) as any)
  } else {
    const paramsData: any = {
      ...options,
      searchText: commaSeparatedArrOfString(options?.searchText),
      sortType: options?.sortType || -1,
      page: options?.page || 1,
      limit: typeof options?.limit === 'number' && !isNaN(options.limit) ? options.limit : 10,
      filters: [
        ...(Array.isArray(options?.filters) ? options.filters : []),
        ...(Array.isArray(options?.typefilters) ? options.typefilters : []),
        ...(isChildModalOpened
          ? [
              {
                ...getFilterValues('layout', getFilteredValues(definitionInfo?.layout ?? '')),
              },
            ]
          : []),
        getFilterValues('state', [FEATURED, SCHEDULE_TO_FEATURE]),
      ],
    }
    if (options?.sortBy) paramsData.sortBy = options.sortBy
    if (options.filterValue) paramsData.searchText = options.filterValue
    if (options?.typefilters && Array.isArray(options?.typefilters)) {
      delete paramsData[TYPE_FILTERS]
    }
    if (!options.sortBy) {
      delete paramsData.sortBy
    }

    const isLimitedSelection = definitionInfo?.[keyToCheckInDefinition]?.isLimitedSelection
    const layoutInfo = definitionInfo?.[keyToCheckInDefinition]?.layoutInfo
    if (isLimitedSelection && layoutInfo?.length > 0) {
      const typeFilterValues = layoutInfo.map((item: { type: string }) => item.type)
      const layoutFilterValues = layoutInfo.flatMap((item: { layouts: string[] }) => item.layouts)

      paramsData.filters.push(
        getFilterValues('layout', [...new Set(layoutFilterValues)] as string[]),
      )
      paramsData.filters.push(getFilterValues('type', typeFilterValues))
    }

    if (shouldDisplayRadioFilterOption) {
      if (selectedRadioOption.length > 0 && selectedRadioOption.toLowerCase() !== 'all') {
        paramsData.filters.push(getFilterValues('type', [selectedRadioOption]))
      }
      if (selectedFilterValues.length > 0) {
        paramsData.filters.push(
          getFilterValues(
            'layout',
            selectedFilterValues?.map((value: any) => value?.key || ''),
          ),
        )
      }
    }

    if (tab === CONTAINER) {
      result = await dispatch(getContainerListAPICall(paramsData) as any)
    } else if (isChildModalOpened) {
      const requestedData = SITE_NAVIGATION_CRUD.LISTING(paramsData)
      result = await mainApiService(requestedData)
    } else {
      paramsData.widgetCategory = selectedRadioOption
      result = await dispatch(getWidgetListAPICall(paramsData) as any)
    }
  }

  const data = isChildModalOpened ? result?.data : result?.payload?.data
  const responseCode = isChildModalOpened ? result?.responseCode : result?.payload?.responseCode
  if (responseCode === 200 && data?.count > 0) {
    const { records = [] } = data
    const initialCheckedState: any = { ...checkedState }
    const initialDisabledState: Set<string> = new Set()
    const selectedDataList = [
      ...selectedItemListData,
      ...(pinnedItemsList ?? []),
      ...newlySelectedWidgetData,
    ]

    const tempData = records
      .map((item: any) => {
        const IDKey = getKeyByType(item, 'id')
        if (!IDKey) return null

        let initialState = false
        if (isChildModalOpened)
          initialState = item[IDKey]?.toString() === replaceAndEditItemData?.childId

        initialCheckedState[item[IDKey]] = isChildModalOpened
          ? initialState
          : getWidgetCheckedOrDisabledValue(selectedDataList, item, IDKey, newlySelectedWidgetData)

        const disabledFlag = isChildModalOpened
          ? initialState
          : getWidgetCheckedOrDisabledValue(
              [...selectedItemListData, ...(pinnedItemsList ?? [])],
              item,
              IDKey,
              newlySelectedWidgetData,
              true,
            )
        if (disabledFlag) initialDisabledState.add(item[IDKey]?.toString())

        const propsData = {
          key: item[IDKey],
          checked: initialCheckedState[item[IDKey]] || false,
          onChange: () => onSelectChange(item),
          disabled: initialDisabledState.has(item[IDKey]?.toString()),
        }
        const radioPropsData = {
          inputId: item[IDKey],
          value: item[IDKey],
          ...propsData,
        }

        const commonProps = {
          checkbox: !replaceAndEditItemData.id
            ? getCheckboxOrRadioComponent(isItemSingleSelect, radioPropsData, {
                id: item[IDKey],
                checked: propsData.checked,
                handleChange: () => propsData.onChange(),
                disabled: propsData.disabled,
              })
            : getCheckboxOrRadioComponent(
                true,
                {
                  ...radioPropsData,
                  classes: initialDisabledState.has(item[IDKey]?.toString()) ? 'disabled-row' : '',
                },
                {},
              ),
          [`${IDKey}`]: item[IDKey],
          title: item.title || item.widgetTitle || item.containerTitle,
          type: item.assetType || item.type || item.widgetType,
          layout: item.layout || item.widgetLayout || item.containerLayout,
          originalValue: item,
        }

        if (tab === ASSET) {
          return {
            ...commonProps,
            assetCategory: item?.assetCategory,
            variantType: item?.variantType || 'NA',
            defaultLanguage: item?.defaultLanguage?.value || 'NA',
          }
        }
        if (tab === CONTAINER) {
          return {
            ...commonProps,
            _id: item._id,
            segment: item.segment,
            createdAt: getDateInFormat(item.createdAt ?? '', DATE_TIME_FORMAT),
            updatedAt: getDateInFormat(item.updatedAt ?? '', DATE_TIME_FORMAT),
            lastFeaturedDate: getDateInFormat(
              item.lastFeaturedDate ?? '',
              DATE_TIME_FORMAT_SECONDS,
            ),
            state: React.createElement(AssetStateLabel, { state: item.stateDisplayName }),
          }
        }
        return commonProps
      })
      .filter(Boolean)

    if (!(isItemSingleSelect && replaceAndEditItemData.id)) {
      if (!selectAllProps?.showCheckbox && records.length > 0) {
        selectAllPropsValue = { checked: false, isCheckboxClicked: false, showCheckbox: true }
      }
    } else {
      selectAllPropsValue = { checked: false, isCheckboxClicked: false, showCheckbox: false }
    }

    setDisabledList?.(new Set(initialDisabledState))

    return {
      transformedData: tempData,
      selectAllPropsValue,
      count: data?.count ?? 0,
      updatedCheckedState: initialCheckedState,
    }
  }

  return { transformedData: [], selectAllPropsValue, count: 0, updatedCheckedState: checkedState }
}
export const isSelectedItemBaseAsset = (selectedItemDetail: Record<string, any>) => {
  return selectedItemDetail?.variantType?.toLowerCase() === 'base'
}
export const validateDateTime = (
  setError: any,
  clearErrors: any,
  startDate: Date | string,
  endDate: Date | string,
  startErrorField: keyof FormValues,
  endErrorField: keyof FormValues,
  pageType?: string,
) => {
  const now = new Date()
  let hasErrors = false

  if (startDate && pageType !== 'edit') {
    const start = new Date(startDate)
    if (start < now) {
      hasErrors = true
      setError(startErrorField, {
        type: 'START_DATE_IN_PAST',
        message: 'Start date and time cannot be in the past',
      })
    } else {
      clearErrors(startErrorField)
    }
  }

  if (startDate && endDate) {
    const start = new Date(startDate)
    const end = new Date(endDate)
    if (end <= start) {
      hasErrors = true
      setError(endErrorField, {
        type: 'END_DATE_LESS_THAN_EQUAL_TO_START_DATE',
        message: 'End date can not be less than or equal to start date',
      })
    } else {
      clearErrors(endErrorField)
    }
  }

  return hasErrors
}
export const checkActiveWindow = async (moduleName: string) => {
  if (moduleName) {
    const activeWindow = REVOKE_ACCESS_API.CHECK_ACTIVE_WINDOW(moduleName)
    const result: any = await mainApiService(activeWindow)
    if (result?.responseCode === 200) {
      const convertedMessage = changeDateFormatOnIdentifier(result?.message, '$')
      return convertedMessage
    } else {
      return ''
    }
  }
}

export const changeDateFormatOnIdentifier = (text: string, identifier: string) => {
  const regex = new RegExp(
    `\\${identifier}(\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{3}Z)`,
    'g',
  )

  return text.replace(regex, (match, utcDateStr) => {
    const formattedIST = getDateInFormat(utcDateStr, CONSTANTS.DATE_FORMAT_TIME_SECONDS)
    return `${formattedIST}`
  })
}
export const getFilteredBaseAssetIds = (itemList: any[], errorIds: string[]) => {
  if (itemList.length === 0 || errorIds.length === 0) return []
  const selectedItemIds = new Set(itemList.map((item) => getItemIdValue(item)))
  return errorIds.filter((errorId) => selectedItemIds.has(errorId))
}

export const getFilterOptions = (dataType: any) => {
  switch (dataType) {
    case 'number':
      return filterConditions[CONSTANTS.FIELDTYPES.NUMBER]

    case 'string':
      return filterConditions[CONSTANTS.FIELDTYPES.TEXT]

    case 'array':
      return filterConditions[CONSTANTS.FIELDTYPES.TEXT]

    case 'boolean':
      return filterConditions[CONSTANTS.FIELDTYPES.TEXT]

    case 'date':
      return filterConditions[CONSTANTS.FIELDTYPES.DATETIME]

    default:
      return []
  }
}

export const getUnfeaturedTime = (featureLaterInfo: any) => {
  if (!featureLaterInfo) return 'NA'
  if (!featureLaterInfo.isRecurring) {
    return featureLaterInfo.unFeaturedDateTime
  }
  const recurrence = featureLaterInfo.recurrence
  if (recurrence?.recurringEndDate && recurrence?.unfeatureTime) {
    return `${recurrence.recurringEndDate} ${recurrence.unfeatureTime}`
  }
  return 'NA'
}
export const getWeeklyFrequencyMessage = (weekInterval: number, repeatsOn: string[]): string => {
  const allDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
  const selectedAllDays =
    Array.isArray(repeatsOn) &&
    repeatsOn.length === allDays.length &&
    allDays.every((day) => repeatsOn.includes(day))

  if (weekInterval === 1 && selectedAllDays) {
    return 'Weekly on all days'
  }
  if (weekInterval === 1) {
    return `Weekly on ${repeatsOn.join(', ')}`
  }
  if (selectedAllDays) {
    return `Every ${weekInterval} weeks on all days`
  }
  return `Every ${weekInterval} weeks on ${repeatsOn.join(', ')}`
}

export const downloadCSVFromBlobOrFile = (sourceData: Blob | IExtendedFile, fileName: string) => {
  const blobUrl = URL.createObjectURL(sourceData)
  const link = document.createElement('a')
  link.href = blobUrl
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(blobUrl)
  return true
}
export const downloadCSVFromResponse = async (
  csvString: string,
  dispatch: any,
  fileName: string,
) => {
  try {
    const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' })
    downloadCSVFromBlobOrFile(blob, fileName)
  } catch (error: any) {
    dispatch(showAlert([true, `Error downloading file: ${error.message}`, 'error']))
  }
}
export const downloadCSVFromFile = async (file: IExtendedFile, dispatch: any, fileName: string) => {
  try {
    const result = downloadCSVFromBlobOrFile(file, fileName)
    if (result) dispatch(showAlert([true, 'File downloaded successfully', 'success']))
  } catch (error: any) {
    dispatch(showAlert([true, `Error downloading file: ${error.message}`, 'error']))
  }
}
export const downloadCsvFromUrl = async (
  csvUrl: string,
  dispatch: any,
  fileName: string,
  successToastMessage?: string,
) => {
  try {
    const csvS3Url = `${CONSTANTS.CLOUDFRONT_BASE_URL}${csvUrl.slice(
      CONSTANTS.S3_BUCKET_BASE_URL?.length,
    )}`
    const response = await fetch(csvS3Url)
    const blob = await response.blob()
    const result = downloadCSVFromBlobOrFile(blob, fileName)
    if (successToastMessage && result) dispatch(showAlert([true, successToastMessage, 'success']))
  } catch (error: any) {
    dispatch(showAlert([true, `Error downloading file: ${error.message}`, 'error']))
  }
}
export const downloadBulkUpdateCsvSample = async (dispatch: AppDispatch, jobName: string) => {
  try {
    const requestedData = BULK_OPERATIONS.SAMPLE_CSV_DOWNLOAD()
    const result: any = await mainApiService(requestedData)
    await downloadCSVFromResponse(result, dispatch, `BoltBulkUpdateTemplate_${jobName}`)
    dispatch(showAlert([true, 'Template downloaded successfully', 'success']))
  } catch (error: any) {
    dispatch(showAlert([true, `Error downloading file: ${error.message}`, 'error']))
  }
}
export const downloadBulkUpdateCsvReport = async (
  dispatch: AppDispatch,
  fileName: string,
  jobId: string,
  toastMessage: string,
) => {
  try {
    const requestedData = BULK_OPERATIONS.DOWNLOAD_BULK_CSV_REPORT_DOWNLOAD(jobId)
    const result: any = await mainApiService(requestedData)
    if (result?.responseCode === 200) {
      await downloadCSVFromResponse(result, dispatch, fileName)
      dispatch(showAlert([true, toastMessage, 'success']))
    }
  } catch (error: any) {
    dispatch(showAlert([true, `Error downloading file: ${error.message}`, 'error']))
  }
}
export const handlePinnedItemPositionChange = (
  value: number,
  index: number,
  itemList: any[],
  updateSelectedAssetDetailsList?: (data: any[]) => void,
) => {
  if (itemList.length === 0) return []

  const clonedItemList = structuredClone(itemList)
  const filteredItem = clonedItemList[index]
  filteredItem.position = value
  updateSelectedAssetDetailsList?.(clonedItemList)
}

export const handleCsvUploadCreateJobPayload = (
  selectedData: { type: IKeyValue[]; layouts: IKeyValue[] },
  originalTypeAndLayoytList: { type: IKeyValue; layouts: IKeyValue[] }[],
) => {
  const selectedLayoutKeys = new Set(selectedData.layouts.map((layout) => layout.key))

  const selectedTypeKeys = new Set(selectedData.type.map((type) => type.key))

  const transformedResult = originalTypeAndLayoytList
    .filter((item) => selectedTypeKeys.has(item.type.key))
    .map((item) => {
      const filteredLayouts = item.layouts.filter((layout) => selectedLayoutKeys.has(layout.key))

      return {
        type: item.type,
        layouts: filteredLayouts,
      }
    })
  return transformedResult
}

export const transformTypeAndLayoutResponse = (
  typeAndLayoutList: { type: IKeyValue; layouts: IKeyValue[] }[],
) => {
  const transformedData: ITypeAndLayoutList = { layouts: {}, type: [] }
  typeAndLayoutList.forEach((item) => {
    transformedData.layouts[toCamelCase(item.type.key)] = item.layouts
    transformedData.type.push(item.type)
  })
  return transformedData
}
export const formatFileSize = (bytes: number, decimals = 2): string => {
  if (bytes === 0) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}
export const transformTypeAndLayout = (data: { type: IKeyValue; layouts: IKeyValue[] }[]) => {
  return data.reduce<{ type: IKeyValue[]; layouts: IKeyValue[] }>(
    (acc, item) => {
      acc.type.push(item.type)
      acc.layouts.push(...item.layouts)
      return acc
    },
    { type: [], layouts: [] },
  )
}
export const handleGenerateCsvPreSignedUrl = async (
  jobId: string | number,
  fileData?: IExtendedFile,
) => {
  if (!fileData) return

  const fileKey = `${CONSTANTS.S3_BUCKET_IMAGE_BASE_FOLDER}bulk_ops/${jobId}.csv`
  const preSignedUrlPayload = ASSETS_CRUD.GENERATE_PRESIGNED_URL('image', fileKey)

  try {
    const result = await mainApiService(preSignedUrlPayload)
    if (result?.responseCode === 200) {
      await axios.put(result?.data?.url ?? '', fileData, {
        headers: {
          upload: true,
          'Content-Type': fileData.type,
        },
      })
      return { response: fileKey, success: true }
    } else {
      return { response: result?.error?.message, success: false }
    }
  } catch (error) {
    return { response: 'Upload Failed', success: false }
  }
}
export const uploadCsvProcess = async ({
  csvDetail,
  file,
  dispatch,
  id,
}: UploadCsvProcess): Promise<{ value: string; success: boolean }> => {
  const response = { value: '', success: false }
  try {
    const res = await handleGenerateCsvPreSignedUrl(csvDetail?.jobId, file)

    response.value = res?.success ? null : res?.response
    response.success = res?.success ?? false

    if (!res?.success) return response

    await handleCsvUpload({
      s3Url: `${CONSTANTS.S3_BUCKET_BASE_URL}/${res.response}`,
      fileName: file.name,
      fileSize: formatFileSize(file.size),
      updateNow: false,
      validate: true,
      csvDetail,
      dispatch,
      id,
    })
  } catch (error) {
    response.success = false
  }
  return response
}
export const handleCsvUpload = async ({
  fileName,
  fileSize,
  s3Url,
  updateNow,
  validate,
  scheduleDate,
  csvDetail,
  dispatch,
  navigate,
  id,
  shouldNavigate = false,
  toastMessage,
}: CsvUpload) => {
  const { CsvBulkUpdate, BulkOperation, PageTypeView } = PAGES_ROUTES
  const { jobName, module, targetState, layoutInfo, jobId } = csvDetail

  const payload = {
    jobName,
    targetState,
    module,
    layoutInfo,
    jobId,
    fileUploadInfo: s3Url.trim().length === 0 ? {} : { url: s3Url, name: fileName, size: fileSize },
    updateNow,
    validate,
    ...(scheduleDate ? { scheduleDate } : {}),
  }

  try {
    dispatch(setLoader(true))
    const result = await mainApiService(BULK_OPERATIONS.CSV_BULK_UPLOAD_UPDATE(payload))

    if (result?.responseCode === 200) {
      let messageToShow = result?.message ?? ''
      if (updateNow) messageToShow = CONSTANTS.CSV_BULK_UPDATE_STARTED
      if (scheduleDate) messageToShow = CONSTANTS.CSV_BULK_UPDATE_SCHEDULED
      dispatch(showAlert([true, toastMessage ?? messageToShow, 'success']))
      if (shouldNavigate) navigate?.(`/${BulkOperation}/${CsvBulkUpdate}/${PageTypeView}/${id}`)
    } else {
      dispatch(showAlert([true, combineErrorMessage(result), 'error']))
    }
  } catch (error) {
    dispatch(showAlert([true, 'Unexpected error occurred.', 'error']))
  } finally {
    dispatch(setLoader(false))
  }
}
export const transformCsvDetailData = <T extends Record<string, any>>(
  keysToCheck: Record<string, Record<string, string>>,
  csvDetail: T,
): Record<string, IKeyValue[]> => {
  const dataToShow: Record<string, IKeyValue[]> = {}

  Object.entries(keysToCheck).forEach(([groupKey, fields]) => {
    dataToShow[groupKey] = Object.entries(fields)
      .filter(([dataKey]) => csvDetail[dataKey as keyof T] !== undefined)
      .map(([dataKey, label]) => ({
        key: label,
        value: csvDetail[dataKey as keyof T],
      }))
  })

  return dataToShow
}

export const validateCsvContent = (csvText: string): CsvValidationResult => {
  const errors: CsvValidationError[] = []

  try {
    if (!csvText?.trim()) {
      return {
        isValid: false,
        errors: [{ message: CSV_VALIDATION_RULES.MESSAGES.UNABLE_TO_READ_HEADERS }],
      }
    }

    const rows = csvText
      .split(/\r?\n/)
      .map((row) => row.trim())
      .filter(Boolean)
    if (rows.length < 1) {
      return {
        isValid: false,
        errors: [{ message: CSV_VALIDATION_RULES.MESSAGES.UNABLE_TO_READ_HEADERS }],
      }
    }

    const headers = rows[0].split(',').map((header) =>
      header
        .trim()
        .toLowerCase()
        .replace(/^"|"/g, '')
        .replace(/^\uFEFF/, ''),
    )

    const allowedHeaders = Object.keys(CSV_VALIDATION_RULES.COLUMN_RULES).map((col) =>
      col.toLowerCase(),
    )

    const invalidHeaders = headers.filter((header) => !allowedHeaders.includes(header))

    if (invalidHeaders.length > 0) {
      return {
        isValid: false,
        errors: [
          {
            row: 0,
            message: CSV_VALIDATION_RULES.MESSAGES.INVALID_COLUMNS.replace(
              '$columns',
              invalidHeaders.join(', '),
            ),
          },
        ],
      }
    }

    const missingColumns = CSV_VALIDATION_RULES.REQUIRED_COLUMNS.filter(
      (col) => !headers.includes(col.toLowerCase()),
    )

    if (missingColumns.length > 0) {
      return {
        isValid: false,
        errors: [
          {
            row: 0,
            message: CSV_VALIDATION_RULES.MESSAGES.MISSING_REQUIRED_COLUMNS.replace(
              '$columns',
              missingColumns.join(', '),
            ),
          },
        ],
      }
    }

    for (let rowIndex = 1; rowIndex < rows.length; rowIndex++) {
      const values = rows[rowIndex]
        .split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/)
        .map((val) => val.trim().replace(/^"|"$/g, ''))

      const rowData: Record<string, string> = {}
      headers.forEach((header, index) => {
        rowData[header] = values[index] ?? ''
      })

      headers.forEach((column) => {
        const rule = CSV_VALIDATION_RULES.COLUMN_RULES[column]
        const value = rowData[column]

        if (rule) {
          if (rule.required && (value === undefined || value === '')) {
            errors.push({
              row: rowIndex + 1,
              column,
              message: CSV_VALIDATION_RULES.MESSAGES.REQUIRED.replace('$property', column),
            })
          } else if (value && rule.pattern && !rule.pattern.test(value)) {
            errors.push({
              row: rowIndex + 1,
              column,
              message: rule.message,
            })
          }
        }
      })
    }

    return {
      isValid: errors.length === 0,
      errors,
    }
  } catch (error) {
    console.error('CSV Validation Error:', error)
    return {
      isValid: false,
      errors: [{ message: CSV_VALIDATION_RULES.MESSAGES.UNEXPECTED_ROW_ERROR }],
    }
  }
}

export const formatCsvErrors = (errors: CsvValidationError[]): string => {
  return errors
    .map((err) => `${err.message}${err.row !== undefined ? ` at row ${err.row}` : ''}`)
    .join('. ')
}

export const csvBulkCancelPopupDescription = (
  jobStatus: 'in-progress' | 'in-queue' | 'scheduled',
  jobName: string,
) => {
  if (!jobName) return ''
  const {
    CSV_IN_PROGRESS_CANCEL_MESSAGE,
    CSV_IN_QUEUE_CANCEL_MESSAGE,
    CSV_SCHEDULED_CANCEL_MESSAGE,
  } = CONSTANTS
  let description = CSV_IN_PROGRESS_CANCEL_MESSAGE
  if (jobStatus === 'in-queue') description = CSV_IN_QUEUE_CANCEL_MESSAGE
  if (jobStatus === 'scheduled') description = CSV_SCHEDULED_CANCEL_MESSAGE
  return description.replace('$jobName', jobName)
}

export const handleCsvBulkUpdateJobCancel = async ({
  dispatch,
  jobId,
  setRefetchToken,
  refetch,
}: HandleCsvBulkUpdateJobCancel) => {
  if (!jobId) return
  const { CSV_SUCCESSFUL_CANCEL_MESSAGE, CSV_CANCEL_ERROR_MESSAGE } = CONSTANTS
  try {
    const requestedData = BULK_OPERATIONS.CSV_BULK_UPLOAD_CANCEL({ jobId })
    const result: any = await mainApiService(requestedData)
    const { message } = handleResponse(result)
    if (result?.responseCode === 200) {
      dispatch(showAlert([true, CSV_SUCCESSFUL_CANCEL_MESSAGE, 'success']))
      setRefetchToken?.((prev) => prev + 1)
      refetch?.()
    } else {
      dispatch(
        showAlert([true, message.trim().length > 0 ? message : CSV_CANCEL_ERROR_MESSAGE, 'error']),
      )
    }
  } catch (error) {
    dispatch(showAlert([true, CSV_CANCEL_ERROR_MESSAGE, 'error']))
  }
}

export const getLayoutFilterValue = (typeKey: FetchRightDrawerLayout, moduleKey: string) => {
  return Object.entries(typeKey)
    .filter(([_, value]) => value.trim() !== '')
    .map(
      ([key, value]) => `${key === 'moduleKey' ? moduleKey : CONSTANTS.SEARCH_BY_LAYOUT}=${value}`,
    )
    .join('&')
}

export const transformRightDrawerLayoutResponse = (
  layoutList: { layout: string; _id: string; [key: string]: string }[],
  layoutKey: string,
) => {
  return layoutList.map((type: any) => ({
    key: type.layout,
    value: type._id,
    moduleType: type[layoutKey],
  }))
}

export const layoutIdInSessionStorage = (type: 'remove' | 'add' | 'get', id?: string) => {
  const { LAYOUT_ID } = CONSTANTS
  if (type === 'add' && id) return sessionStorage.setItem(LAYOUT_ID, id)
  if (type === 'get') return sessionStorage.getItem(LAYOUT_ID)
  return sessionStorage.removeItem(CONSTANTS.LAYOUT_ID)
}

export const hasAdUnit = (items: any) => {
  return items.some((item: any) => item?.itemType?.toLowerCase() === 'ad units')
}

export const syncUnpinnedItemPositions = (
  unpinnedItemList: any[],
  pinnedItemPositions: Set<number>,
) => {
  if (!unpinnedItemList.length) return []

  const updatedUnpinnedItemList = []
  let nextAvailable = 1
  let unpinnedPointer = 0

  while (unpinnedPointer < unpinnedItemList.length) {
    if (!pinnedItemPositions.has(nextAvailable)) {
      updatedUnpinnedItemList.push({
        ...unpinnedItemList[unpinnedPointer],
        position: nextAvailable,
      })
      unpinnedPointer++
    }
    nextAvailable++
  }

  return updatedUnpinnedItemList
}
export const getDetailListingCommonRows = ({
  createdBy,
  updatedBy,
  createdAt,
  updatedAt,
}: {
  createdBy: string
  updatedBy: string
  createdAt: string
  updatedAt: string
}) => {
  const { DATE_FORMAT_TIME_SECONDS } = CONSTANTS
  return {
    createdBy,
    updatedBy,
    createdAt: getDateInFormat(createdAt ?? '', DATE_FORMAT_TIME_SECONDS),
    updatedAt: getDateInFormat(updatedAt ?? '', DATE_FORMAT_TIME_SECONDS),
  }
}
